"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// node_modules/is-hotkey/lib/index.js
var require_lib = __commonJS({
  "node_modules/is-hotkey/lib/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var IS_MAC = typeof window != "undefined" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
    var MODIFIERS = {
      alt: "altKey",
      control: "ctrlKey",
      meta: "metaKey",
      shift: "shiftKey"
    };
    var ALIASES = {
      add: "+",
      break: "pause",
      cmd: "meta",
      command: "meta",
      ctl: "control",
      ctrl: "control",
      del: "delete",
      down: "arrowdown",
      esc: "escape",
      ins: "insert",
      left: "arrowleft",
      mod: IS_MAC ? "meta" : "control",
      opt: "alt",
      option: "alt",
      return: "enter",
      right: "arrowright",
      space: " ",
      spacebar: " ",
      up: "arrowup",
      win: "meta",
      windows: "meta"
    };
    var CODES = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      control: 17,
      alt: 18,
      pause: 19,
      capslock: 20,
      escape: 27,
      " ": 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      arrowleft: 37,
      arrowup: 38,
      arrowright: 39,
      arrowdown: 40,
      insert: 45,
      delete: 46,
      meta: 91,
      numlock: 144,
      scrolllock: 145,
      ";": 186,
      "=": 187,
      ",": 188,
      "-": 189,
      ".": 190,
      "/": 191,
      "`": 192,
      "[": 219,
      "\\": 220,
      "]": 221,
      "'": 222
    };
    for (f = 1; f < 20; f++) {
      CODES["f" + f] = 111 + f;
    }
    var f;
    function isHotkey2(hotkey, options2, event) {
      if (options2 && !("byKey" in options2)) {
        event = options2;
        options2 = null;
      }
      if (!Array.isArray(hotkey)) {
        hotkey = [hotkey];
      }
      var array = hotkey.map(function(string) {
        return parseHotkey(string, options2);
      });
      var check = function check2(e) {
        return array.some(function(object) {
          return compareHotkey(object, e);
        });
      };
      var ret = event == null ? check : check(event);
      return ret;
    }
    function isCodeHotkey(hotkey, event) {
      return isHotkey2(hotkey, event);
    }
    function isKeyHotkey(hotkey, event) {
      return isHotkey2(hotkey, { byKey: true }, event);
    }
    function parseHotkey(hotkey, options2) {
      var byKey = options2 && options2.byKey;
      var ret = {};
      hotkey = hotkey.replace("++", "+add");
      var values = hotkey.split("+");
      var length = values.length;
      for (var k in MODIFIERS) {
        ret[MODIFIERS[k]] = false;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = void 0;
      try {
        for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;
          var optional = value.endsWith("?") && value.length > 1;
          if (optional) {
            value = value.slice(0, -1);
          }
          var name = toKeyName(value);
          var modifier = MODIFIERS[name];
          if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
            throw new TypeError('Unknown modifier: "' + value + '"');
          }
          if (length === 1 || !modifier) {
            if (byKey) {
              ret.key = name;
            } else {
              ret.which = toKeyCode(value);
            }
          }
          if (modifier) {
            ret[modifier] = optional ? null : true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      return ret;
    }
    function compareHotkey(object, event) {
      for (var key in object) {
        var expected = object[key];
        var actual = void 0;
        if (expected == null) {
          continue;
        }
        if (key === "key" && event.key != null) {
          actual = event.key.toLowerCase();
        } else if (key === "which") {
          actual = expected === 91 && event.which === 93 ? 91 : event.which;
        } else {
          actual = event[key];
        }
        if (actual == null && expected === false) {
          continue;
        }
        if (actual !== expected) {
          return false;
        }
      }
      return true;
    }
    function toKeyCode(name) {
      name = toKeyName(name);
      var code = CODES[name] || name.toUpperCase().charCodeAt(0);
      return code;
    }
    function toKeyName(name) {
      name = name.toLowerCase();
      name = ALIASES[name] || name;
      return name;
    }
    exports.default = isHotkey2;
    exports.isHotkey = isHotkey2;
    exports.isCodeHotkey = isCodeHotkey;
    exports.isKeyHotkey = isKeyHotkey;
    exports.parseHotkey = parseHotkey;
    exports.compareHotkey = compareHotkey;
    exports.toKeyCode = toKeyCode;
    exports.toKeyName = toKeyName;
  }
});

// node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "node_modules/lodash/_freeGlobal.js"(exports, module2) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// node_modules/lodash/_root.js
var require_root = __commonJS({
  "node_modules/lodash/_root.js"(exports, module2) {
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// node_modules/lodash/isFinite.js
var require_isFinite = __commonJS({
  "node_modules/lodash/isFinite.js"(exports, module2) {
    var root = require_root();
    var nativeIsFinite = root.isFinite;
    function isFinite2(value) {
      return typeof value == "number" && nativeIsFinite(value);
    }
    module2.exports = isFinite2;
  }
});

// node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "node_modules/lodash/_Symbol.js"(exports, module2) {
    var root = require_root();
    var Symbol2 = root.Symbol;
    module2.exports = Symbol2;
  }
});

// node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "node_modules/lodash/_getRawTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module2.exports = getRawTag;
  }
});

// node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "node_modules/lodash/_objectToString.js"(exports, module2) {
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module2.exports = objectToString;
  }
});

// node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "node_modules/lodash/_baseGetTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module2.exports = baseGetTag;
  }
});

// node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "node_modules/lodash/isObject.js"(exports, module2) {
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module2.exports = isObject;
  }
});

// node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "node_modules/lodash/isFunction.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObject = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module2.exports = isFunction;
  }
});

// node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "node_modules/lodash/_coreJsData.js"(exports, module2) {
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module2.exports = coreJsData;
  }
});

// node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "node_modules/lodash/_isMasked.js"(exports, module2) {
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module2.exports = isMasked;
  }
});

// node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "node_modules/lodash/_toSource.js"(exports, module2) {
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module2.exports = toSource;
  }
});

// node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "node_modules/lodash/_baseIsNative.js"(exports, module2) {
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module2.exports = baseIsNative;
  }
});

// node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "node_modules/lodash/_getValue.js"(exports, module2) {
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    module2.exports = getValue;
  }
});

// node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "node_modules/lodash/_getNative.js"(exports, module2) {
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    module2.exports = getNative;
  }
});

// node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "node_modules/lodash/_nativeCreate.js"(exports, module2) {
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module2.exports = nativeCreate;
  }
});

// node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "node_modules/lodash/_hashClear.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module2.exports = hashClear;
  }
});

// node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "node_modules/lodash/_hashDelete.js"(exports, module2) {
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = hashDelete;
  }
});

// node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "node_modules/lodash/_hashGet.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    module2.exports = hashGet;
  }
});

// node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "node_modules/lodash/_hashHas.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    module2.exports = hashHas;
  }
});

// node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "node_modules/lodash/_hashSet.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module2.exports = hashSet;
  }
});

// node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "node_modules/lodash/_Hash.js"(exports, module2) {
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module2.exports = Hash;
  }
});

// node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "node_modules/lodash/_listCacheClear.js"(exports, module2) {
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module2.exports = listCacheClear;
  }
});

// node_modules/lodash/eq.js
var require_eq = __commonJS({
  "node_modules/lodash/eq.js"(exports, module2) {
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module2.exports = eq;
  }
});

// node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "node_modules/lodash/_assocIndexOf.js"(exports, module2) {
    var eq = require_eq();
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module2.exports = assocIndexOf;
  }
});

// node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "node_modules/lodash/_listCacheDelete.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module2.exports = listCacheDelete;
  }
});

// node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "node_modules/lodash/_listCacheGet.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    module2.exports = listCacheGet;
  }
});

// node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "node_modules/lodash/_listCacheHas.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module2.exports = listCacheHas;
  }
});

// node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "node_modules/lodash/_listCacheSet.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module2.exports = listCacheSet;
  }
});

// node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "node_modules/lodash/_ListCache.js"(exports, module2) {
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module2.exports = ListCache;
  }
});

// node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "node_modules/lodash/_Map.js"(exports, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var Map2 = getNative(root, "Map");
    module2.exports = Map2;
  }
});

// node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "node_modules/lodash/_mapCacheClear.js"(exports, module2) {
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    module2.exports = mapCacheClear;
  }
});

// node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "node_modules/lodash/_isKeyable.js"(exports, module2) {
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module2.exports = isKeyable;
  }
});

// node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "node_modules/lodash/_getMapData.js"(exports, module2) {
    var isKeyable = require_isKeyable();
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    module2.exports = getMapData;
  }
});

// node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "node_modules/lodash/_mapCacheDelete.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = mapCacheDelete;
  }
});

// node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "node_modules/lodash/_mapCacheGet.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module2.exports = mapCacheGet;
  }
});

// node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "node_modules/lodash/_mapCacheHas.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module2.exports = mapCacheHas;
  }
});

// node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "node_modules/lodash/_mapCacheSet.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module2.exports = mapCacheSet;
  }
});

// node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "node_modules/lodash/_MapCache.js"(exports, module2) {
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module2.exports = MapCache;
  }
});

// node_modules/lodash/memoize.js
var require_memoize = __commonJS({
  "node_modules/lodash/memoize.js"(exports, module2) {
    var MapCache = require_MapCache();
    var FUNC_ERROR_TEXT = "Expected a function";
    function memoize2(func, resolver) {
      if (typeof func != "function" || resolver != null && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize2.Cache || MapCache)();
      return memoized;
    }
    memoize2.Cache = MapCache;
    module2.exports = memoize2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/_virtual/_rollupPluginBabelHelpers.js
var require_rollupPluginBabelHelpers = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/_virtual/_rollupPluginBabelHelpers.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _typeof(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof = function(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
          symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
        keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread2(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr))
        return arr;
    }
    function _iterableToArrayLimit(arr, i) {
      if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
        return;
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i)
            break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null)
            _i["return"]();
        } finally {
          if (_d)
            throw _e;
        }
      }
      return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o)
        return;
      if (typeof o === "string")
        return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor)
        n = o.constructor.name;
      if (n === "Map" || n === "Set")
        return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length)
        len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
      return arr2;
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    exports.arrayLikeToArray = _arrayLikeToArray;
    exports.arrayWithHoles = _arrayWithHoles;
    exports.defineProperty = _defineProperty;
    exports.iterableToArrayLimit = _iterableToArrayLimit;
    exports.nonIterableRest = _nonIterableRest;
    exports.objectSpread2 = _objectSpread2;
    exports.slicedToArray = _slicedToArray;
    exports.typeof = _typeof;
    exports.unsupportedIterableToArray = _unsupportedIterableToArray;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/createHandlerSetter.js
var require_createHandlerSetter = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/createHandlerSetter.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var createHandlerSetter = function createHandlerSetter2(handlerValue) {
      var handlerRef = react.useRef(handlerValue);
      handlerRef.current = handlerValue;
      var setHandler = react.useCallback(function(nextCallback) {
        if (typeof nextCallback !== "function") {
          throw new Error("the argument supplied to the 'setHandler' function should be of type function");
        }
        handlerRef.current = nextCallback;
      });
      return [handlerRef, setHandler];
    };
    exports.default = createHandlerSetter;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDidMount.js
var require_useDidMount = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDidMount.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var useDidMount = function useDidMount2(handler) {
      var _createHandlerSetter = createHandlerSetter.default(handler), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onMountHandler = _createHandlerSetter2[0], setOnMountHandler = _createHandlerSetter2[1];
      react.useEffect(function() {
        if (onMountHandler.current) {
          onMountHandler.current();
        }
      }, []);
      return setOnMountHandler;
    };
    exports.default = useDidMount;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWillUnmount.js
var require_useWillUnmount = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWillUnmount.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var useWillUnmount = function useWillUnmount2(handler) {
      var _createHandlerSetter = createHandlerSetter.default(handler), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onUnmountHandler = _createHandlerSetter2[0], setOnUnmount = _createHandlerSetter2[1];
      react.useEffect(function() {
        return function() {
          if (onUnmountHandler.current) {
            onUnmountHandler.current();
          }
        };
      }, []);
      return setOnUnmount;
    };
    exports.default = useWillUnmount;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useLifecycle.js
var require_useLifecycle = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useLifecycle.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useDidMount = require_useDidMount();
    var useWillUnmount = require_useWillUnmount();
    var useLifecycle = function useLifecycle2(mount, unmount) {
      var onDidMount = useDidMount.default(mount);
      var onWillUnmount = useWillUnmount.default(unmount);
      return {
        onDidMount,
        onWillUnmount
      };
    };
    exports.default = useLifecycle;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGlobalEvent.js
var require_useGlobalEvent = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGlobalEvent.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var defaultOptions = {
      capture: false,
      once: false,
      passive: false
    };
    var useGlobalEvent2 = function useGlobalEvent3(eventName) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var fn = arguments.length > 2 ? arguments[2] : void 0;
      var _createHandlerSetter = createHandlerSetter.default(fn), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), callbackRef = _createHandlerSetter2[0], setCallbackRef = _createHandlerSetter2[1];
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      react.useEffect(function() {
        var cb = function cb2(event) {
          if (callbackRef.current) {
            callbackRef.current(event);
          }
        };
        if (callbackRef.current && eventName) {
          window.addEventListener(eventName, cb, opts);
        }
        return function() {
          if (eventName) {
            window.removeEventListener(eventName, cb, opts);
          }
        };
      }, [eventName, options2]);
      return setCallbackRef;
    };
    exports.default = useGlobalEvent2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWindowResize.js
var require_useWindowResize = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWindowResize.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useGlobalEvent2 = require_useGlobalEvent();
    var useWindowResize = function useWindowResize2(handler) {
      return useGlobalEvent2.default("resize", null, handler);
    };
    exports.default = useWindowResize;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWindowScroll.js
var require_useWindowScroll = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWindowScroll.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useGlobalEvent2 = require_useGlobalEvent();
    var useWindowScroll = function useWindowScroll2(handler) {
      return useGlobalEvent2.default("scroll", null, handler);
    };
    exports.default = useWindowScroll;
  }
});

// node_modules/lodash.debounce/index.js
var require_lodash = __commonJS({
  "node_modules/lodash.debounce/index.js"(exports, module2) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce(func, wait, options2) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options2)) {
        leading = !!options2.leading;
        maxing = "maxWait" in options2;
        maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options2 ? !!options2.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = debounce;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDebouncedFn.js
var require_useDebouncedFn = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDebouncedFn.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _interopDefault(ex) {
      return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
    }
    var react = require("react");
    var debounce = _interopDefault(require_lodash());
    var defaultOptions = {
      leading: false,
      trailing: true
    };
    var useDebouncedFn = function useDebouncedFn2(fn) {
      var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var dependencies = arguments.length > 3 ? arguments[3] : void 0;
      var debounced = debounce(fn, wait, options2);
      return react.useCallback(debounced, dependencies);
    };
    exports.default = useDebouncedFn;
  }
});

// node_modules/lodash.throttle/index.js
var require_lodash2 = __commonJS({
  "node_modules/lodash.throttle/index.js"(exports, module2) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce(func, wait, options2) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options2)) {
        leading = !!options2.leading;
        maxing = "maxWait" in options2;
        maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options2 ? !!options2.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function throttle(func, wait, options2) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options2)) {
        leading = "leading" in options2 ? !!options2.leading : leading;
        trailing = "trailing" in options2 ? !!options2.trailing : trailing;
      }
      return debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = throttle;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useThrottledFn.js
var require_useThrottledFn = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useThrottledFn.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _interopDefault(ex) {
      return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
    }
    var react = require("react");
    var throttle = _interopDefault(require_lodash2());
    var defaultOptions = {
      leading: false,
      trailing: true
    };
    var useThrottledFn = function useThrottledFn2(fn) {
      var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var dependencies = arguments.length > 3 ? arguments[3] : void 0;
      var throttled = throttle(fn, wait, options2);
      return react.useCallback(throttled, dependencies);
    };
    exports.default = useThrottledFn;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/createCbSetterErrorProxy.js
var require_createCbSetterErrorProxy = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/createCbSetterErrorProxy.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var createCbSetterErrorProxy = function createCbSetterErrorProxy2(errorMessage) {
      return new Proxy(/* @__PURE__ */ Object.create(null), {
        get: function get(target, property) {
          if (property && typeof property === "string" && property.slice(0, 2) === "on") {
            return function() {
              throw new Error(errorMessage);
            };
          }
          return {
            error: errorMessage
          };
        }
      });
    };
    exports.default = createCbSetterErrorProxy;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/hasOwnProperty.js
var require_hasOwnProperty = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/hasOwnProperty.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var hasOwnProperty = function hasOwnProperty2(obj, prop) {
      return obj ? Object.prototype.hasOwnProperty.call(obj, prop) : false;
    };
    exports.default = hasOwnProperty;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouseEvents.js
var require_useMouseEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouseEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var hasOwnProperty = require_hasOwnProperty();
    var assignMouseEventOnMount = function assignMouseEventOnMount2(targetRef, handlerRef, eventName) {
      react.useEffect(function() {
        var cb = function cb2(mouseEvent) {
          if (handlerRef.current) {
            handlerRef.current(mouseEvent);
          }
        };
        var target;
        if (targetRef !== null && !!targetRef.current) {
          target = targetRef.current;
        }
        if (targetRef === null) {
          target = document;
        }
        if (target && target.addEventListener) {
          target.addEventListener(eventName, cb);
        }
        return function() {
          if (target && target.removeEventListener) {
            target.removeEventListener(eventName, cb);
          }
        };
      }, []);
    };
    var useMouseEvents = function useMouseEvents2() {
      var targetRef = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onMouseDownHandler = _createHandlerSetter2[0], setOnMouseDown = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onMouseEnterHandler = _createHandlerSetter4[0], setOnMouseEnter = _createHandlerSetter4[1];
      var _createHandlerSetter5 = createHandlerSetter.default(), _createHandlerSetter6 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter5, 2), onMouseLeaveHandler = _createHandlerSetter6[0], setOnMouseLeave = _createHandlerSetter6[1];
      var _createHandlerSetter7 = createHandlerSetter.default(), _createHandlerSetter8 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter7, 2), onMouseMoveHandler = _createHandlerSetter8[0], setOnMouseMove = _createHandlerSetter8[1];
      var _createHandlerSetter9 = createHandlerSetter.default(), _createHandlerSetter10 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter9, 2), onMouseOutHandler = _createHandlerSetter10[0], setOnMouseOut = _createHandlerSetter10[1];
      var _createHandlerSetter11 = createHandlerSetter.default(), _createHandlerSetter12 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter11, 2), onMouseOverHandler = _createHandlerSetter12[0], setOnMouseOver = _createHandlerSetter12[1];
      var _createHandlerSetter13 = createHandlerSetter.default(), _createHandlerSetter14 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter13, 2), onMouseUpHandler = _createHandlerSetter14[0], setOnMouseUp = _createHandlerSetter14[1];
      if (targetRef !== null && !hasOwnProperty.default(targetRef, "current")) {
        return createCbSetterErrorProxy.default("Unable to assign any mouse event to the given ref");
      }
      assignMouseEventOnMount(targetRef, onMouseDownHandler, "mousedown");
      assignMouseEventOnMount(targetRef, onMouseEnterHandler, "mouseenter");
      assignMouseEventOnMount(targetRef, onMouseLeaveHandler, "mouseleave");
      assignMouseEventOnMount(targetRef, onMouseMoveHandler, "mousemove");
      assignMouseEventOnMount(targetRef, onMouseOutHandler, "mouseout");
      assignMouseEventOnMount(targetRef, onMouseOverHandler, "mouseover");
      assignMouseEventOnMount(targetRef, onMouseUpHandler, "mouseup");
      return Object.freeze({
        onMouseDown: setOnMouseDown,
        onMouseEnter: setOnMouseEnter,
        onMouseLeave: setOnMouseLeave,
        onMouseMove: setOnMouseMove,
        onMouseOut: setOnMouseOut,
        onMouseOver: setOnMouseOver,
        onMouseUp: setOnMouseUp
      });
    };
    exports.default = useMouseEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouseState.js
var require_useMouseState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouseState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useMouseEvents = require_useMouseEvents();
    var createStateObject = function createStateObject2(event) {
      return {
        clientX: event.clientX,
        clientY: event.clientY,
        screenX: event.screenX,
        screenY: event.screenY
      };
    };
    var useMouseState = function useMouseState2() {
      var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var _useState = react.useState({
        clientX: 0,
        clientY: 0,
        screenX: 0,
        screenY: 0
      }), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
      var _useMouseEvents = useMouseEvents.default(ref), onMouseMove = _useMouseEvents.onMouseMove;
      onMouseMove(function(event) {
        var nextState = createStateObject(event);
        setState(nextState);
      });
      return state;
    };
    exports.default = useMouseState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouse.js
var require_useMouse = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouse.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useMouseEvents = require_useMouseEvents();
    var useMouseState = require_useMouseState();
    var useMouse = function useMouse2() {
      var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var state = useMouseState.default(ref);
      var events = useMouseEvents.default(ref);
      return [state, events];
    };
    exports.default = useMouse;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useTimeout.js
var require_useTimeout = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useTimeout.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      cancelOnUnmount: true
    };
    var useTimeout = function useTimeout2(fn, milliseconds) {
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearTimeout(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        if (typeof milliseconds === "number") {
          timeout.current = setTimeout(function() {
            callback.current();
          }, milliseconds);
        }
      }, [milliseconds]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useTimeout;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/usePreviousValue.js
var require_usePreviousValue = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/usePreviousValue.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var usePreviousValue = function usePreviousValue2(value) {
      var prevValue = react.useRef();
      react.useEffect(function() {
        prevValue.current = value;
        return function() {
          prevValue.current = void 0;
        };
      });
      return prevValue.current;
    };
    exports.default = usePreviousValue;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useConditionalTimeout.js
var require_useConditionalTimeout = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useConditionalTimeout.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var usePreviousValue = require_usePreviousValue();
    var defaultOptions = {
      cancelOnUnmount: true,
      cancelOnConditionChange: true
    };
    var useConditionalTimeout = function useConditionalTimeout2(fn, milliseconds, condition) {
      var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var prevCondition = usePreviousValue.default(condition);
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearTimeout(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        if (condition && typeof milliseconds === "number") {
          timeout.current = setTimeout(function() {
            callback.current();
          }, milliseconds);
        }
      }, [condition, milliseconds]);
      react.useEffect(function() {
        if (prevCondition && condition !== prevCondition && opts.cancelOnConditionChange) {
          clear();
        }
      }, [condition, options2]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useConditionalTimeout;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useInterval.js
var require_useInterval = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useInterval.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      cancelOnUnmount: true
    };
    var useInterval = function useInterval2(fn, milliseconds) {
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearInterval(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        clear();
        if (typeof milliseconds === "number") {
          timeout.current = setInterval(function() {
            callback.current();
          }, milliseconds);
        }
      }, [milliseconds]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useInterval;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/geolocationStandardOptions.js
var require_geolocationStandardOptions = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/geolocationStandardOptions.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var geoStandardOptions = /* @__PURE__ */ Object.create(null);
    geoStandardOptions.enableHighAccuracy = false;
    geoStandardOptions.timeout = 4294967295;
    geoStandardOptions.maximumAge = 0;
    var geolocationStandardOptions = Object.freeze(geoStandardOptions);
    exports.default = geolocationStandardOptions;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocationEvents.js
var require_useGeolocationEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocationEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = function useGeolocationEvents2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var watchId = react.useRef();
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onChangeRef = _createHandlerSetter2[0], setOnChangeRef = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onErrorRef = _createHandlerSetter4[0], setOnErrorRef = _createHandlerSetter4[1];
      var isSupported = typeof window !== "undefined" && "geolocation" in window.navigator;
      react.useEffect(function() {
        var onSuccess = function onSuccess2(successEvent) {
          if (onChangeRef.current) {
            onChangeRef.current(successEvent);
          }
        };
        var onError = function onError2(err) {
          if (onErrorRef.current) {
            onErrorRef.current(err);
          }
        };
        if (isSupported) {
          watchId.current = window.navigator.geolocation.watchPosition(onSuccess, onError, options2);
        }
        return function() {
          if (isSupported) {
            window.navigator.geolocation.clearWatch(watchId.current);
          }
        };
      }, []);
      return !isSupported ? createCbSetterErrorProxy.default("The Geolocation API is not supported") : Object.freeze({
        isSupported,
        onChange: setOnChangeRef,
        onError: setOnErrorRef
      });
    };
    exports.default = useGeolocationEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/makePositionObject.js
var require_makePositionObject = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/makePositionObject.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var makePositionObj = function makePositionObj2(position) {
      return !position ? null : {
        timestamp: position.timestamp,
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          altitude: position.coords.altitude,
          accuracy: position.coords.accuracy,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed
        }
      };
    };
    exports.default = makePositionObj;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isSamePosition.js
var require_isSamePosition = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isSamePosition.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isSamePosition = function isSamePosition2(current, next) {
      if (!current || !next || !next.coords)
        return false;
      if (current.timestamp && next.timestamp && current.timestamp !== next.timestamp)
        return false;
      return current.coords.latitude === next.coords.latitude && current.coords.longitude === next.coords.longitude && current.coords.altitude === next.coords.altitude && current.coords.accuracy === next.coords.accuracy && current.coords.altitudeAccuracy === next.coords.altitudeAccuracy && current.coords.heading === next.coords.heading && current.coords.speed === next.coords.speed;
    };
    exports.default = isSamePosition;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocationState.js
var require_useGeolocationState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocationState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = require_useGeolocationEvents();
    var makePositionObject = require_makePositionObject();
    var isSamePosition = require_isSamePosition();
    var useGeolocationState = function useGeolocationState2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var _useState = react.useState(null), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), position = _useState2[0], setPosition = _useState2[1];
      var _useState3 = react.useState(false), _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2), isRetrieving = _useState4[0], setRetrieving = _useState4[1];
      var _useGeolocationEvents = useGeolocationEvents.default(options2), isSupported = _useGeolocationEvents.isSupported, onChange = _useGeolocationEvents.onChange;
      var savePosition = react.useCallback(function() {
        if (position === null) {
          setRetrieving(true);
          navigator.geolocation.getCurrentPosition(function(nextPosition) {
            if (!isSamePosition.default(position, nextPosition)) {
              setPosition(makePositionObject.default(nextPosition));
              setRetrieving(false);
            }
          });
        }
      }, [position]);
      react.useEffect(savePosition, [position]);
      onChange(savePosition);
      return Object.freeze({
        isSupported,
        isRetrieving,
        position
      });
    };
    exports.default = useGeolocationState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocation.js
var require_useGeolocation = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = require_useGeolocationEvents();
    var useGeolocationState = require_useGeolocationState();
    var useGeolocation = function useGeolocation2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var state = useGeolocationState.default(options2);
      var events = useGeolocationEvents.default(options2);
      return [state, events];
    };
    exports.default = useGeolocation;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isClient.js
var require_isClient = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isClient.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var isClient = (typeof window === "undefined" ? "undefined" : _rollupPluginBabelHelpers.typeof(window)) === "object";
    exports.default = isClient;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isAPISupported.js
var require_isAPISupported = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isAPISupported.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isApiSupported = function isApiSupported2(api) {
      return api in window;
    };
    exports.default = isApiSupported;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMediaQuery.js
var require_useMediaQuery = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMediaQuery.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var errorMessage = "matchMedia is not supported, this could happen both because window.matchMedia is not supported by your current browser or you're using the useMediaQuery hook whilst server side rendering.";
    var useMediaQuery = function useMediaQuery2(mediaQuery) {
      if (!isClient.default || !isAPISupported.default("matchMedia")) {
        console.warn(errorMessage);
        return null;
      }
      var _useState = react.useState(!!window.matchMedia(mediaQuery).matches), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isVerified = _useState2[0], setIsVerified = _useState2[1];
      react.useEffect(function() {
        var mediaQueryList = window.matchMedia(mediaQuery);
        var documentChangeHandler = function documentChangeHandler2() {
          return setIsVerified(!!mediaQueryList.matches);
        };
        mediaQueryList.addListener(documentChangeHandler);
        documentChangeHandler();
        return function() {
          mediaQueryList.removeListener(documentChangeHandler);
        };
      }, [mediaQuery]);
      return isVerified;
    };
    exports.default = useMediaQuery;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useValueHistory.js
var require_useValueHistory = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useValueHistory.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var useValueHistory = function useValueHistory2(value) {
      var history = react.useRef([]);
      react.useEffect(function() {
        history.current.push(value);
      }, [value]);
      return history.current;
    };
    exports.default = useValueHistory;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useOnlineState.js
var require_useOnlineState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useOnlineState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useGlobalEvent2 = require_useGlobalEvent();
    var useOnlineState = function useOnlineState2() {
      var isSupported = typeof window !== "undefined" && "ononline" in window;
      var _useState = react.useState(isSupported ? navigator.onLine : true), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isOnline = _useState2[0], setIsOnline = _useState2[1];
      var whenOnline = useGlobalEvent2.default("online", {
        capture: true
      });
      var whenOffline = useGlobalEvent2.default("offline", {
        capture: true
      });
      if (!isSupported) {
        console.warn("The current device does not support the 'online/offline' events, you should avoid using useOnlineState");
        return isOnline;
      }
      whenOnline(function() {
        setIsOnline(true);
      });
      whenOffline(function() {
        setIsOnline(false);
      });
      return isOnline;
    };
    exports.default = useOnlineState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useViewportSpy.js
var require_useViewportSpy = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useViewportSpy.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      root: void 0,
      rootMargin: "0px",
      threshold: 0
    };
    var useViewportSpy = function useViewportSpy2(elementRef) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var _useState = react.useState(), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isVisible = _useState2[0], setIsVisible = _useState2[1];
      react.useLayoutEffect(function() {
        var observer = new IntersectionObserver(function(entries) {
          return entries.forEach(function(item) {
            var nextValue = item.isIntersecting;
            setIsVisible(nextValue);
          });
        }, options2);
        observer.observe(elementRef.current);
        return function() {
          observer.disconnect(elementRef.current);
        };
      }, [elementRef]);
      return isVisible;
    };
    exports.default = useViewportSpy;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useValidatedState.js
var require_useValidatedState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useValidatedState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useValidatedState = function useValidatedState2(validator, initialValue) {
      var _useState = react.useState(initialValue), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
      var validation = react.useRef({
        changed: false
      });
      var onChange = react.useCallback(function(nextValue) {
        setState(nextValue);
        validation.current = {
          changed: true,
          valid: validator(nextValue)
        };
      }, [validator]);
      return [state, onChange, validation.current];
    };
    exports.default = useValidatedState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDragEvents.js
var require_useDragEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDragEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var hasOwnProperty = require_hasOwnProperty();
    var assignDragEventOnMount = function assignDragEventOnMount2(targetRef, handlerRef, eventName) {
      react.useEffect(function() {
        var cb = function cb2(dragEvent) {
          if (handlerRef.current) {
            handlerRef.current(dragEvent);
          }
        };
        if (targetRef.current) {
          targetRef.current.addEventListener(eventName, cb);
        }
        return function() {
          if (targetRef.current) {
            targetRef.current.removeEventListener(eventName, cb);
          }
        };
      }, []);
    };
    var useDragEvents = function useDragEvents2(targetRef) {
      var setDraggable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onDrag = _createHandlerSetter2[0], setOnDrag = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onDrop = _createHandlerSetter4[0], setOnDrop = _createHandlerSetter4[1];
      var _createHandlerSetter5 = createHandlerSetter.default(), _createHandlerSetter6 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter5, 2), onDragEnter = _createHandlerSetter6[0], setOnDragEnter = _createHandlerSetter6[1];
      var _createHandlerSetter7 = createHandlerSetter.default(), _createHandlerSetter8 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter7, 2), onDragEnd = _createHandlerSetter8[0], setOnDragEnd = _createHandlerSetter8[1];
      var _createHandlerSetter9 = createHandlerSetter.default(), _createHandlerSetter10 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter9, 2), onDragExit = _createHandlerSetter10[0], setOnDragExit = _createHandlerSetter10[1];
      var _createHandlerSetter11 = createHandlerSetter.default(), _createHandlerSetter12 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter11, 2), onDragLeave = _createHandlerSetter12[0], setOnDragLeave = _createHandlerSetter12[1];
      var _createHandlerSetter13 = createHandlerSetter.default(), _createHandlerSetter14 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter13, 2), onDragOver = _createHandlerSetter14[0], setOnDragOver = _createHandlerSetter14[1];
      var _createHandlerSetter15 = createHandlerSetter.default(), _createHandlerSetter16 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter15, 2), onDragStart = _createHandlerSetter16[0], setOnDragStart = _createHandlerSetter16[1];
      if (targetRef !== null && !hasOwnProperty.default(targetRef, "current")) {
        return createCbSetterErrorProxy.default("Unable to assign any drag event to the given ref");
      }
      react.useEffect(function() {
        if (setDraggable && targetRef.current && !targetRef.current.hasAttribute("draggable")) {
          targetRef.current.setAttribute("draggable", true);
        }
      }, []);
      assignDragEventOnMount(targetRef, onDrag, "drag");
      assignDragEventOnMount(targetRef, onDrop, "drop");
      assignDragEventOnMount(targetRef, onDragEnter, "dragenter");
      assignDragEventOnMount(targetRef, onDragEnd, "dragend");
      assignDragEventOnMount(targetRef, onDragExit, "dragexit");
      assignDragEventOnMount(targetRef, onDragLeave, "dragleave");
      assignDragEventOnMount(targetRef, onDragOver, "dragover");
      assignDragEventOnMount(targetRef, onDragStart, "dragstart");
      return Object.freeze({
        onDrag: setOnDrag,
        onDrop: setOnDrop,
        onDragEnter: setOnDragEnter,
        onDragEnd: setOnDragEnd,
        onDragExit: setOnDragExit,
        onDragLeave: setOnDragLeave,
        onDragOver: setOnDragOver,
        onDragStart: setOnDragStart
      });
    };
    exports.default = useDragEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDrag.js
var require_useDrag = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDrag.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useDragEvents = require_useDragEvents();
    var defaultOptions = {
      dragImage: null,
      dragImageXOffset: 0,
      dragImageYOffset: 0,
      transfer: null,
      transferFormat: "text"
    };
    var useDrag = function useDrag2(targetRef) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var _useDragEvents = useDragEvents.default(targetRef, true), onDragStart = _useDragEvents.onDragStart, onDragEnd = _useDragEvents.onDragEnd;
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isDragging = _useState2[0], setIsDragging = _useState2[1];
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2 || {});
      onDragStart(function(event) {
        setIsDragging(true);
        if (opts.dragImage) {
          var img = new Image();
          img.src = opts.dragImage;
          event.dataTransfer.setDragImage(img, opts.dragImageXOffset, opts.dragImageYOffset);
        }
        if (opts.transfer) {
          var data = _rollupPluginBabelHelpers.typeof(opts.transfer) === "object" ? JSON.stringify(opts.transfer) : "".concat(opts.transfer);
          event.dataTransfer.setData(opts.transferFormat, data);
        }
      });
      onDragEnd(function() {
        return setIsDragging(false);
      });
      return isDragging;
    };
    exports.default = useDrag;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDropZone.js
var require_useDropZone = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDropZone.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useDragEvents = require_useDragEvents();
    var useDropZone = function useDropZone2(targetRef) {
      var _useDragEvents = useDragEvents.default(targetRef, false), onDrop = _useDragEvents.onDrop, onDragOver = _useDragEvents.onDragOver, onDragLeave = _useDragEvents.onDragLeave;
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isOver = _useState2[0], setIsOver = _useState2[1];
      onDragOver(function(event) {
        event.preventDefault();
        setIsOver(true);
      });
      onDragLeave(function() {
        setIsOver(false);
      });
      return {
        isOver,
        onDrop
      };
    };
    exports.default = useDropZone;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useRequestAnimationFrame.js
var require_useRequestAnimationFrame = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useRequestAnimationFrame.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var defaultOptions = {
      increment: 1,
      startAt: 0,
      finishAt: 100
    };
    var errorMessage = "requestAnimationFrame is not supported, this could happen both because window.requestAnimationFrame is not supported by your current browser version or you're using the useRequestAnimationFrame hook whilst server side rendering.";
    var useRequestAnimationFrame = function useRequestAnimationFrame2(func) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      if (!isClient.default || !isAPISupported.default("requestAnimationFrame")) {
        console.warn(errorMessage);
        return createCbSetterErrorProxy.default(errorMessage);
      }
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options2);
      var progress = react.useRef(opts.startAt);
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onFinish = _createHandlerSetter2[0], setOnFinish = _createHandlerSetter2[1];
      var next = function next2() {
        return window.requestAnimationFrame(step);
      };
      var step = react.useCallback(function() {
        if (progress.current <= opts.finishAt || opts.finishAt === -1) {
          func(progress.current, next);
          progress.current += opts.increment;
        } else if (onFinish.current) {
          onFinish.current();
        }
      }, [func, opts.finishAt, opts.increment, progress.current, onFinish.current]);
      if (progress.current <= opts.startAt) {
        next();
      }
      return setOnFinish;
    };
    exports.default = useRequestAnimationFrame;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/safelyParseJson.js
var require_safelyParseJson = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/safelyParseJson.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var safelyParseJson = function safelyParseJson2(parseString) {
      try {
        return JSON.parse(parseString);
      } catch (e) {
        return null;
      }
    };
    exports.default = safelyParseJson;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useLocalStorage.js
var require_useLocalStorage = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useLocalStorage.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var safelyParseJson = require_safelyParseJson();
    var errorMessageSSR = "localStorage is not supported, this could happen because you're using the useLocalStorage hook whilst server side rendering.";
    var errorMessageIsNotSupported = "localStorage is not supported, this could happen because window.localStorage is not supported by your current browser";
    var useLocalStorage = function useLocalStorage2(localStorageKey, defaultValue) {
      if (!isClient.default) {
        console.warn(errorMessageSSR);
        return [JSON.stringify(defaultValue), function() {
          return void 0;
        }];
      }
      if (!isAPISupported.default("localStorage")) {
        console.warn(errorMessageIsNotSupported);
        return [JSON.stringify(defaultValue), function() {
          return void 0;
        }];
      }
      var _useState = react.useState(safelyParseJson.default(window.localStorage.getItem(localStorageKey) || JSON.stringify(defaultValue))), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), value = _useState2[0], setValue = _useState2[1];
      react.useEffect(function() {
        window.localStorage.setItem(localStorageKey, JSON.stringify(value));
      }, [localStorageKey, value]);
      return [value, setValue];
    };
    exports.default = useLocalStorage;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useStorage.js
var require_useStorage = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useStorage.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var safelyParseJson = require_safelyParseJson();
    var useStorage = function useStorage2(type) {
      return function(initialValue) {
        var _useState = react.useState(initialValue), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), store = _useState2[0], setStore = _useState2[1];
        var storageType = type;
        if (storageType !== "local" && storageType !== "session") {
          storageType = "local";
        }
        storageType += "Storage";
        var get = function get2(key) {
          return safelyParseJson.default(isClient.default ? window[storageType].getItem(key) : store[key]);
        };
        var set = function set2(key, value) {
          var valueToStore = value instanceof Function ? value(safelyParseJson.default(store[key])) : value;
          if (isClient.default) {
            window[storageType].setItem(key, JSON.stringify(valueToStore));
          }
          return setStore(function(x) {
            return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, x), {}, _rollupPluginBabelHelpers.defineProperty({}, key, valueToStore));
          });
        };
        react.useEffect(function() {
          if (isClient.default) {
            Object.keys(store).map(function(k) {
              return window[storageType].setItem(k, JSON.stringify(store[k]));
            });
          }
        }, [store]);
        var storage = store;
        if (isClient.default) {
          storage = window[storageType];
        }
        return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, storage), {}, {
          get,
          set
        });
      };
    };
    exports.default = useStorage;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/index.js
var require_cjs = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useDidMount = require_useDidMount();
    var useWillUnmount = require_useWillUnmount();
    var useLifecycle = require_useLifecycle();
    var useGlobalEvent2 = require_useGlobalEvent();
    var useWindowResize = require_useWindowResize();
    var useWindowScroll = require_useWindowScroll();
    var useDebouncedFn = require_useDebouncedFn();
    var useThrottledFn = require_useThrottledFn();
    var useMouseEvents = require_useMouseEvents();
    var useMouseState = require_useMouseState();
    var useMouse = require_useMouse();
    var useTimeout = require_useTimeout();
    var usePreviousValue = require_usePreviousValue();
    var useConditionalTimeout = require_useConditionalTimeout();
    var useInterval = require_useInterval();
    var useGeolocationEvents = require_useGeolocationEvents();
    var useGeolocationState = require_useGeolocationState();
    var useGeolocation = require_useGeolocation();
    var useMediaQuery = require_useMediaQuery();
    var useValueHistory = require_useValueHistory();
    var useOnlineState = require_useOnlineState();
    var useViewportSpy = require_useViewportSpy();
    var useValidatedState = require_useValidatedState();
    var useDragEvents = require_useDragEvents();
    var useDrag = require_useDrag();
    var useDropZone = require_useDropZone();
    var useRequestAnimationFrame = require_useRequestAnimationFrame();
    var useLocalStorage = require_useLocalStorage();
    var useStorage = require_useStorage();
    exports.useDidMount = useDidMount.default;
    exports.useWillUnmount = useWillUnmount.default;
    exports.useLifecycle = useLifecycle.default;
    exports.useGlobalEvent = useGlobalEvent2.default;
    exports.useWindowResize = useWindowResize.default;
    exports.useWindowScroll = useWindowScroll.default;
    exports.useDebouncedFn = useDebouncedFn.default;
    exports.useThrottledFn = useThrottledFn.default;
    exports.useMouseEvents = useMouseEvents.default;
    exports.useMouseState = useMouseState.default;
    exports.useMouse = useMouse.default;
    exports.useTimeout = useTimeout.default;
    exports.usePreviousValue = usePreviousValue.default;
    exports.useConditionalTimeout = useConditionalTimeout.default;
    exports.useInterval = useInterval.default;
    exports.useGeolocationEvents = useGeolocationEvents.default;
    exports.useGeolocationState = useGeolocationState.default;
    exports.useGeolocation = useGeolocation.default;
    exports.useMediaQuery = useMediaQuery.default;
    exports.useValueHistory = useValueHistory.default;
    exports.useOnlineState = useOnlineState.default;
    exports.useViewportSpy = useViewportSpy.default;
    exports.useValidatedState = useValidatedState.default;
    exports.useDragEvents = useDragEvents.default;
    exports.useDrag = useDrag.default;
    exports.useDropZone = useDropZone.default;
    exports.useRequestAnimationFrame = useRequestAnimationFrame.default;
    exports.useLocalStorage = useLocalStorage.default;
    exports.useStorage = useStorage.default;
  }
});

// node_modules/resize-observer-polyfill/dist/ResizeObserver.js
var require_ResizeObserver = __commonJS({
  "node_modules/resize-observer-polyfill/dist/ResizeObserver.js"(exports, module2) {
    (function(global2, factory) {
      typeof exports === "object" && typeof module2 !== "undefined" ? module2.exports = factory() : typeof define === "function" && define.amd ? define(factory) : global2.ResizeObserver = factory();
    })(exports, function() {
      "use strict";
      var MapShim = function() {
        if (typeof Map !== "undefined") {
          return Map;
        }
        function getIndex(arr, key) {
          var result = -1;
          arr.some(function(entry, index2) {
            if (entry[0] === key) {
              result = index2;
              return true;
            }
            return false;
          });
          return result;
        }
        return (
          /** @class */
          function() {
            function class_1() {
              this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
              /**
               * @returns {boolean}
               */
              get: function() {
                return this.__entries__.length;
              },
              enumerable: true,
              configurable: true
            });
            class_1.prototype.get = function(key) {
              var index2 = getIndex(this.__entries__, key);
              var entry = this.__entries__[index2];
              return entry && entry[1];
            };
            class_1.prototype.set = function(key, value) {
              var index2 = getIndex(this.__entries__, key);
              if (~index2) {
                this.__entries__[index2][1] = value;
              } else {
                this.__entries__.push([key, value]);
              }
            };
            class_1.prototype.delete = function(key) {
              var entries = this.__entries__;
              var index2 = getIndex(entries, key);
              if (~index2) {
                entries.splice(index2, 1);
              }
            };
            class_1.prototype.has = function(key) {
              return !!~getIndex(this.__entries__, key);
            };
            class_1.prototype.clear = function() {
              this.__entries__.splice(0);
            };
            class_1.prototype.forEach = function(callback, ctx) {
              if (ctx === void 0) {
                ctx = null;
              }
              for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
              }
            };
            return class_1;
          }()
        );
      }();
      var isBrowser2 = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
      var global$1 = function() {
        if (typeof global !== "undefined" && global.Math === Math) {
          return global;
        }
        if (typeof self !== "undefined" && self.Math === Math) {
          return self;
        }
        if (typeof window !== "undefined" && window.Math === Math) {
          return window;
        }
        return Function("return this")();
      }();
      var requestAnimationFrame$1 = function() {
        if (typeof requestAnimationFrame === "function") {
          return requestAnimationFrame.bind(global$1);
        }
        return function(callback) {
          return setTimeout(function() {
            return callback(Date.now());
          }, 1e3 / 60);
        };
      }();
      var trailingTimeout = 2;
      function throttle(callback, delay) {
        var leadingCall = false, trailingCall = false, lastCallTime = 0;
        function resolvePending() {
          if (leadingCall) {
            leadingCall = false;
            callback();
          }
          if (trailingCall) {
            proxy();
          }
        }
        function timeoutCallback() {
          requestAnimationFrame$1(resolvePending);
        }
        function proxy() {
          var timeStamp = Date.now();
          if (leadingCall) {
            if (timeStamp - lastCallTime < trailingTimeout) {
              return;
            }
            trailingCall = true;
          } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
          }
          lastCallTime = timeStamp;
        }
        return proxy;
      }
      var REFRESH_DELAY = 20;
      var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
      var mutationObserverSupported = typeof MutationObserver !== "undefined";
      var ResizeObserverController = (
        /** @class */
        function() {
          function ResizeObserverController2() {
            this.connected_ = false;
            this.mutationEventsAdded_ = false;
            this.mutationsObserver_ = null;
            this.observers_ = [];
            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
          }
          ResizeObserverController2.prototype.addObserver = function(observer) {
            if (!~this.observers_.indexOf(observer)) {
              this.observers_.push(observer);
            }
            if (!this.connected_) {
              this.connect_();
            }
          };
          ResizeObserverController2.prototype.removeObserver = function(observer) {
            var observers2 = this.observers_;
            var index2 = observers2.indexOf(observer);
            if (~index2) {
              observers2.splice(index2, 1);
            }
            if (!observers2.length && this.connected_) {
              this.disconnect_();
            }
          };
          ResizeObserverController2.prototype.refresh = function() {
            var changesDetected = this.updateObservers_();
            if (changesDetected) {
              this.refresh();
            }
          };
          ResizeObserverController2.prototype.updateObservers_ = function() {
            var activeObservers = this.observers_.filter(function(observer) {
              return observer.gatherActive(), observer.hasActive();
            });
            activeObservers.forEach(function(observer) {
              return observer.broadcastActive();
            });
            return activeObservers.length > 0;
          };
          ResizeObserverController2.prototype.connect_ = function() {
            if (!isBrowser2 || this.connected_) {
              return;
            }
            document.addEventListener("transitionend", this.onTransitionEnd_);
            window.addEventListener("resize", this.refresh);
            if (mutationObserverSupported) {
              this.mutationsObserver_ = new MutationObserver(this.refresh);
              this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
              });
            } else {
              document.addEventListener("DOMSubtreeModified", this.refresh);
              this.mutationEventsAdded_ = true;
            }
            this.connected_ = true;
          };
          ResizeObserverController2.prototype.disconnect_ = function() {
            if (!isBrowser2 || !this.connected_) {
              return;
            }
            document.removeEventListener("transitionend", this.onTransitionEnd_);
            window.removeEventListener("resize", this.refresh);
            if (this.mutationsObserver_) {
              this.mutationsObserver_.disconnect();
            }
            if (this.mutationEventsAdded_) {
              document.removeEventListener("DOMSubtreeModified", this.refresh);
            }
            this.mutationsObserver_ = null;
            this.mutationEventsAdded_ = false;
            this.connected_ = false;
          };
          ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
            var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
            var isReflowProperty = transitionKeys.some(function(key) {
              return !!~propertyName.indexOf(key);
            });
            if (isReflowProperty) {
              this.refresh();
            }
          };
          ResizeObserverController2.getInstance = function() {
            if (!this.instance_) {
              this.instance_ = new ResizeObserverController2();
            }
            return this.instance_;
          };
          ResizeObserverController2.instance_ = null;
          return ResizeObserverController2;
        }()
      );
      var defineConfigurable = function(target, props) {
        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
          var key = _a[_i];
          Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
          });
        }
        return target;
      };
      var getWindowOf = function(target) {
        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
        return ownerGlobal || global$1;
      };
      var emptyRect = createRectInit(0, 0, 0, 0);
      function toFloat(value) {
        return parseFloat(value) || 0;
      }
      function getBordersSize(styles) {
        var positions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          positions[_i - 1] = arguments[_i];
        }
        return positions.reduce(function(size, position) {
          var value = styles["border-" + position + "-width"];
          return size + toFloat(value);
        }, 0);
      }
      function getPaddings(styles) {
        var positions = ["top", "right", "bottom", "left"];
        var paddings = {};
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
          var position = positions_1[_i];
          var value = styles["padding-" + position];
          paddings[position] = toFloat(value);
        }
        return paddings;
      }
      function getSVGContentRect(target) {
        var bbox = target.getBBox();
        return createRectInit(0, 0, bbox.width, bbox.height);
      }
      function getHTMLElementContentRect(target) {
        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
        if (!clientWidth && !clientHeight) {
          return emptyRect;
        }
        var styles = getWindowOf(target).getComputedStyle(target);
        var paddings = getPaddings(styles);
        var horizPad = paddings.left + paddings.right;
        var vertPad = paddings.top + paddings.bottom;
        var width = toFloat(styles.width), height = toFloat(styles.height);
        if (styles.boxSizing === "border-box") {
          if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, "left", "right") + horizPad;
          }
          if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, "top", "bottom") + vertPad;
          }
        }
        if (!isDocumentElement(target)) {
          var vertScrollbar = Math.round(width + horizPad) - clientWidth;
          var horizScrollbar = Math.round(height + vertPad) - clientHeight;
          if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
          }
          if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
          }
        }
        return createRectInit(paddings.left, paddings.top, width, height);
      }
      var isSVGGraphicsElement = function() {
        if (typeof SVGGraphicsElement !== "undefined") {
          return function(target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
          };
        }
        return function(target) {
          return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
        };
      }();
      function isDocumentElement(target) {
        return target === getWindowOf(target).document.documentElement;
      }
      function getContentRect(target) {
        if (!isBrowser2) {
          return emptyRect;
        }
        if (isSVGGraphicsElement(target)) {
          return getSVGContentRect(target);
        }
        return getHTMLElementContentRect(target);
      }
      function createReadOnlyRect(_a) {
        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
        var rect = Object.create(Constr.prototype);
        defineConfigurable(rect, {
          x,
          y,
          width,
          height,
          top: y,
          right: x + width,
          bottom: height + y,
          left: x
        });
        return rect;
      }
      function createRectInit(x, y, width, height) {
        return { x, y, width, height };
      }
      var ResizeObservation = (
        /** @class */
        function() {
          function ResizeObservation2(target) {
            this.broadcastWidth = 0;
            this.broadcastHeight = 0;
            this.contentRect_ = createRectInit(0, 0, 0, 0);
            this.target = target;
          }
          ResizeObservation2.prototype.isActive = function() {
            var rect = getContentRect(this.target);
            this.contentRect_ = rect;
            return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
          };
          ResizeObservation2.prototype.broadcastRect = function() {
            var rect = this.contentRect_;
            this.broadcastWidth = rect.width;
            this.broadcastHeight = rect.height;
            return rect;
          };
          return ResizeObservation2;
        }()
      );
      var ResizeObserverEntry = (
        /** @class */
        function() {
          function ResizeObserverEntry2(target, rectInit) {
            var contentRect = createReadOnlyRect(rectInit);
            defineConfigurable(this, { target, contentRect });
          }
          return ResizeObserverEntry2;
        }()
      );
      var ResizeObserverSPI = (
        /** @class */
        function() {
          function ResizeObserverSPI2(callback, controller, callbackCtx) {
            this.activeObservations_ = [];
            this.observations_ = new MapShim();
            if (typeof callback !== "function") {
              throw new TypeError("The callback provided as parameter 1 is not a function.");
            }
            this.callback_ = callback;
            this.controller_ = controller;
            this.callbackCtx_ = callbackCtx;
          }
          ResizeObserverSPI2.prototype.observe = function(target) {
            if (!arguments.length) {
              throw new TypeError("1 argument required, but only 0 present.");
            }
            if (typeof Element === "undefined" || !(Element instanceof Object)) {
              return;
            }
            if (!(target instanceof getWindowOf(target).Element)) {
              throw new TypeError('parameter 1 is not of type "Element".');
            }
            var observations = this.observations_;
            if (observations.has(target)) {
              return;
            }
            observations.set(target, new ResizeObservation(target));
            this.controller_.addObserver(this);
            this.controller_.refresh();
          };
          ResizeObserverSPI2.prototype.unobserve = function(target) {
            if (!arguments.length) {
              throw new TypeError("1 argument required, but only 0 present.");
            }
            if (typeof Element === "undefined" || !(Element instanceof Object)) {
              return;
            }
            if (!(target instanceof getWindowOf(target).Element)) {
              throw new TypeError('parameter 1 is not of type "Element".');
            }
            var observations = this.observations_;
            if (!observations.has(target)) {
              return;
            }
            observations.delete(target);
            if (!observations.size) {
              this.controller_.removeObserver(this);
            }
          };
          ResizeObserverSPI2.prototype.disconnect = function() {
            this.clearActive();
            this.observations_.clear();
            this.controller_.removeObserver(this);
          };
          ResizeObserverSPI2.prototype.gatherActive = function() {
            var _this = this;
            this.clearActive();
            this.observations_.forEach(function(observation) {
              if (observation.isActive()) {
                _this.activeObservations_.push(observation);
              }
            });
          };
          ResizeObserverSPI2.prototype.broadcastActive = function() {
            if (!this.hasActive()) {
              return;
            }
            var ctx = this.callbackCtx_;
            var entries = this.activeObservations_.map(function(observation) {
              return new ResizeObserverEntry(observation.target, observation.broadcastRect());
            });
            this.callback_.call(ctx, entries, ctx);
            this.clearActive();
          };
          ResizeObserverSPI2.prototype.clearActive = function() {
            this.activeObservations_.splice(0);
          };
          ResizeObserverSPI2.prototype.hasActive = function() {
            return this.activeObservations_.length > 0;
          };
          return ResizeObserverSPI2;
        }()
      );
      var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
      var ResizeObserver2 = (
        /** @class */
        function() {
          function ResizeObserver3(callback) {
            if (!(this instanceof ResizeObserver3)) {
              throw new TypeError("Cannot call a class as a function.");
            }
            if (!arguments.length) {
              throw new TypeError("1 argument required, but only 0 present.");
            }
            var controller = ResizeObserverController.getInstance();
            var observer = new ResizeObserverSPI(callback, controller, this);
            observers.set(this, observer);
          }
          return ResizeObserver3;
        }()
      );
      [
        "observe",
        "unobserve",
        "disconnect"
      ].forEach(function(method) {
        ResizeObserver2.prototype[method] = function() {
          var _a;
          return (_a = observers.get(this))[method].apply(_a, arguments);
        };
      });
      var index = function() {
        if (typeof global$1.ResizeObserver !== "undefined") {
          return global$1.ResizeObserver;
        }
        return ResizeObserver2;
      }();
      return index;
    });
  }
});

// node_modules/use-measure/use-measure.js
var require_use_measure = __commonJS({
  "node_modules/use-measure/use-measure.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = useMeasure2;
    var _react = require("react");
    var _resizeObserverPolyfill = _interopRequireDefault(require_ResizeObserver());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    function _iterableToArrayLimit(arr, i) {
      if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
        return;
      }
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i)
            break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null)
            _i["return"]();
        } finally {
          if (_d)
            throw _e;
        }
      }
      return _arr;
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr))
        return arr;
    }
    function useMeasure2(ref) {
      var _useState = (0, _react.useState)(
        // DOMRectReadOnly.fromRect()
        {
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      ), _useState2 = _slicedToArray(_useState, 2), bounds = _useState2[0], setContentRect = _useState2[1];
      (0, _react.useLayoutEffect)(function() {
        if (ref.current === null) {
          return;
        }
        var animationFrameId = null;
        var measure = function measure2(_ref) {
          var _ref2 = _slicedToArray(_ref, 1), entry = _ref2[0];
          animationFrameId = window.requestAnimationFrame(function() {
            setContentRect(entry.contentRect);
          });
        };
        var ro = new _resizeObserverPolyfill.default(measure);
        ro.observe(ref.current);
        return function() {
          window.cancelAnimationFrame(animationFrameId);
          ro.disconnect();
        };
      }, []);
      return bounds;
    }
  }
});

// src/components/PublishableEmbed/index.ts
var PublishableEmbed_exports = {};
__export(PublishableEmbed_exports, {
  DEFAULT_FONT_FAMILY: () => DEFAULT_FONT_FAMILY,
  PreloadType: () => PreloadType,
  PublishableEmbed: () => PublishableEmbed,
  PublishableType: () => PublishableType,
  Slider: () => Slider,
  SliderBreakpoint: () => SliderBreakpoint,
  Tile: () => Tile,
  TileChild: () => TileChild,
  TileType: () => TileType,
  VideoTextAssetTile: () => VideoTextAssetTile,
  WallOfLove: () => WallOfLove,
  computeWallOfLoveColumnTiles: () => computeWallOfLoveColumnTiles,
  computeWallOfLoveColumnTilesEventName: () => computeWallOfLoveColumnTilesEventName,
  loadEmbedVideos: () => loadEmbedVideos,
  parseControlsToEmbedTileProps: () => parseControlsToEmbedTileProps,
  parseStyleToEmbedTileProps: () => parseStyleToEmbedTileProps
});
module.exports = __toCommonJS(PublishableEmbed_exports);

// src/components/AddSocialBlock/AddSocialBlock.tsx
var import_react9 = __toESM(require("react"));
var import_classnames9 = __toESM(require("classnames"));

// src/components/AddSocialBlock/UrlInput.tsx
var import_react2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));

// src/components/TextArea/index.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var defaultClassName = [
  "v2-text-sm v2-w-full v2-p-3",
  "v2-border v2-border-neutral-300 v2-rounded-md",
  "focus:v2-border-turquoise-700 hover:v2-border-turquoise-700",
  "v2-outline-none v2-resize-none"
].join(" ");

// src/components/AddSocialBlock/Description.tsx
var import_react3 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));

// src/components/AddSocialBlock/CtaButton.tsx
var import_react5 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));

// src/components/Button/index.tsx
var import_react4 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
var sizeClasses = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  ["sm" /* Small */]: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  ["md" /* Medium */]: "v2-py-2.5 v2-px-[15px] v2-text-[15px]",
  ["lg" /* Large */]: "v2-py-2.5 v2-px-[15px] v2-text-base",
  ["xl" /* ExtraLarge */]: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
var shapeClasses = {
  ["rectangle" /* Rectangle */]: "",
  ["round" /* Round */]: "v2-rounded-md"
};
var variantClasses = {
  ["danger" /* Danger */]: "v2-border-solid v2-border-pink-900 v2-text-white",
  ["danger-white" /* DangerWhite */]: "v2-border-solid v2-border-neutral-500 v2-text-neutral-900",
  ["default" /* Default */]: "v2-border-solid v2-border-turquoise v2-text-white",
  ["disabled" /* Disabled */]: "v2-border-solid v2-border-neutral-200 v2-text-neutral-400",
  ["primary" /* Primary */]: "v2-border-solid v2-text-neutral-900 v2-border-yellow-500",
  ["secondary" /* Secondary */]: "v2-border-solid v2-border-neutral-500",
  ["secondary-white" /* SecondaryWhite */]: "v2-text-white v2-border-solid v2-border-white",
  ["info" /* Info */]: "v2-text-brown-700 v2-border-solid v2-border-neutral-200",
  ["blue" /* Blue */]: "v2-text-white v2-border-solid v2-border-blue-500",
  ["magenta" /* Magenta */]: "v2-text-white v2-border-solid v2-border-magenta-500",
  ["icon" /* Icon */]: "v2-text-neutral-400 v2-border-none v2-outline-none",
  ["rounded" /* Rounded */]: "v2-cursor-pointer v2-rounded-full v2-border-1 v2-border-solid v2-border-neutral-500"
};
function Button(_a) {
  var _b = _a, {
    children,
    variant: variantProp,
    size: sizeProp,
    shape = "rectangle" /* Rectangle */,
    bgColorClassName,
    disableHover
  } = _b, props = __objRest(_b, [
    "children",
    "variant",
    "size",
    "shape",
    "bgColorClassName",
    "disableHover"
  ]);
  var _a2;
  const variant = (0, import_react4.useMemo)(() => {
    if (props.disabled) {
      return "disabled" /* Disabled */;
    }
    if (variantProp != null) {
      return variantProp;
    }
    if (props.primary) {
      return "primary" /* Primary */;
    }
    if (props.secondary) {
      return "secondary" /* Secondary */;
    }
    if (props.info) {
      return "info" /* Info */;
    }
    if (props.danger) {
      return "danger" /* Danger */;
    }
    return "default" /* Default */;
  }, [props]);
  const size = (0, import_react4.useMemo)(() => {
    if (sizeProp != null) {
      return sizeProp;
    }
    if (props.sm || props.small) {
      return "sm" /* Small */;
    }
    if (props.md || props.medium) {
      return "md" /* Medium */;
    }
    if (props.lg || props.large) {
      return "lg" /* Large */;
    }
    if (props.xl || props.extraLarge) {
      return "xl" /* ExtraLarge */;
    }
    return "md" /* Medium */;
  }, [props]);
  const disabledClass = (0, import_react4.useMemo)(() => {
    if (props.disabled) {
      switch (variant) {
        case "primary" /* Primary */:
          return "!v2-text-neutral-300 !v2-bg-neutral-100 !v2-border-neutral-100";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "!v2-text-neutral-300 !v2-bg-transparent !v2-border-white";
      }
    }
    return "";
  }, [props, variant]);
  const hoverClass = (0, import_react4.useMemo)(() => {
    if (!disableHover) {
      switch (variant) {
        case "danger" /* Danger */:
          return "hover:v2-bg-orange-700 hover:v2-border-orange-700";
        case "danger-white" /* DangerWhite */:
          return "hover:v2-bg-orange-600 hover:v2-border-orange-600 hover:v2-text-white";
        case "default" /* Default */:
          return "hover:v2-bg-turquoise-900 hover:v2-border-turquoise-900";
        case "disabled" /* Disabled */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300 v2-cursor-not-allowed";
        case "primary" /* Primary */:
          return "hover:v2-bg-yellow-300 hover:v2-border-yellow-300";
        case "secondary" /* Secondary */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent";
        case "secondary-white" /* SecondaryWhite */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent hover:v2-text-neutral-900";
        case "blue" /* Blue */:
          return "hover:v2-bg-blue-700 hover:v2-border-blue-700";
        case "magenta" /* Magenta */:
          return "hover:v2-bg-magenta-700 hover:v2-border-magenta-700";
        case "info" /* Info */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300";
        case "icon" /* Icon */:
          return "hover:v2-text-turquoise";
        case "rounded" /* Rounded */:
          return "hover:v2-bg-yellow-500 hover:v2-border-yellow-500";
      }
    }
    return "";
  }, [props, variant]);
  const bgColorClass = (0, import_react4.useMemo)(() => {
    if (!bgColorClassName) {
      switch (variant) {
        case "danger" /* Danger */:
          return "v2-bg-orange-600";
        case "danger-white" /* DangerWhite */:
          return "v2-bg-white";
        case "default" /* Default */:
          return "v2-bg-turquoise";
        case "disabled" /* Disabled */:
          return "v2-bg-neutral-200 ";
        case "primary" /* Primary */:
          return "v2-bg-yellow-500";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "v2-bg-transparent ";
        case "blue" /* Blue */:
          return "v2-bg-blue-500";
        case "magenta" /* Magenta */:
          return "v2-bg-magenta-500";
        case "info" /* Info */:
          return "v2-bg-neutral-200";
        case "icon" /* Icon */:
          return "v2-bg-transparent";
        case "rounded" /* Rounded */:
          return "v2-bg-transparent ";
      }
    }
    return bgColorClassName;
  }, [props, variant]);
  const className = (0, import_react4.useMemo)(() => {
    return [
      sizeClasses.DEFAULT,
      sizeClasses[size],
      shapeClasses[shape],
      variantClasses[variant],
      disabledClass,
      hoverClass,
      bgColorClass
    ].join(" ");
  }, [size, variant, shape]);
  return /* @__PURE__ */ import_react4.default.createElement("button", __spreadProps(__spreadValues({}, props), { className: (0, import_classnames4.default)(`${(_a2 = props.className) != null ? _a2 : ""} ${className}`) }), children);
}

// src/components/AddSocialBlock/CtaButton.tsx
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faCirclePlay = {
  prefix: "fas",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
};
var faImageSlash = {
  prefix: "fas",
  iconName: "image-slash",
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64H487.4l-81.2-64H320 248 152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z"]
};
var faCirclePause = {
  prefix: "fas",
  iconName: "circle-pause",
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faXmark = {
  prefix: "fas",
  iconName: "xmark",
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"]
};
var faTimes = faXmark;

// src/components/AddSocialBlock/Header.tsx
var import_react6 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));

// src/components/ToggleSelector/ToggleButton.tsx
var import_react8 = __toESM(require("react"));
var import_classnames8 = __toESM(require("classnames"));

// src/components/ToggleSelector/ToggleSelector.tsx
var import_react7 = __toESM(require("react"));
var import_classnames7 = __toESM(require("classnames"));

// src/components/AddSocialBlock/AddSocialBlock.tsx
var SocialType = /* @__PURE__ */ ((SocialType2) => {
  SocialType2["Twitter"] = "twitter";
  SocialType2["Youtube"] = "youtube";
  SocialType2["LinkedIn"] = "linked_in";
  return SocialType2;
})(SocialType || {});

// src/components/PublishableEmbed/PublishableEmbed.tsx
var import_react74 = __toESM(require("react"));

// src/components/PublishableEmbed/WallOfLove.tsx
var import_react64 = __toESM(require("react"));
var import_classnames44 = __toESM(require("classnames"));

// src/components/PublishableEmbed/Components/Tile.tsx
var import_react57 = __toESM(require("react"));
var import_classnames41 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTile.tsx
var import_react52 = __toESM(require("react"));
var import_classnames39 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileProfilePanel.tsx
var import_react10 = __toESM(require("react"));
var import_classnames10 = __toESM(require("classnames"));
var import_react_loading_skeleton = __toESM(require("react-loading-skeleton"));

// src/theme/colors.ts
var palette = {
  black: "#000000",
  white: "#FFFFFF",
  red: ["#F9DEDC", "#F0ADA8", "#E77B73", "#DE4A3F", "#C6413E"],
  orange: [
    "#FFEEE6",
    "#FFDCCC",
    "#FFB99A",
    "#FF9767",
    "#FF7435",
    "#FF5102",
    "#CC4102",
    "#993101",
    "#662001",
    "#331000"
  ],
  yellow: [
    "#F7F4EA",
    "#FFF6CC",
    "#FFEC9A",
    "#FFE367",
    "#FFD935",
    "#FFD002",
    "#CCA602",
    "#997D01",
    "#665301",
    "#332A00"
  ],
  green: [
    "#FAFFEF",
    "#E7F4CC",
    "#CFE999",
    "#B8DD67",
    "#A0D234",
    "#88C701",
    "#6D9F01",
    "#527701",
    "#365000",
    "#1B2800"
  ],
  turquoise: ["#E3F2F2", "#BADEDE", "#9ED0D1", "#4EA4A6", "#22A0AC", "#1C7E87"],
  blue: [
    "#F5F7FF",
    "#CCD6FF",
    "#9AADFF",
    "#6783FF",
    "#355AFF",
    "#0231FF",
    "#0227CC",
    "#011D99",
    "#011466",
    "#000A33"
  ],
  purple: ["#E6E5F0", "#B5B1D3", "#847CB6", "#675EA5", "#514983"],
  pink: ["#FFEFF4", "#FFD0DF", "#F2A6BE", "#EC799D", "#D0577D"],
  brown: ["#9B803D", "#8E652A", "#5B4028", "#473A31", "#2D241D", "#1C1616"],
  neutral: [
    "#F2F2F2",
    "#E2E3E7",
    "#C4C7CF",
    "#A7AAB8",
    "#898EA0",
    "#6C7288",
    "#565B6D",
    "#414452",
    "#2B2E36",
    "#16171B"
  ],
  magenta: [
    "#FFF8FF",
    "#F0CEEA",
    "#E19DD6",
    "#D16DC1",
    "#C23CAD",
    "#B30B98",
    "#A10A89",
    "#7D086A",
    "#5A064C",
    "#36032E"
  ]
};
var colors = {
  white: palette.white,
  black: palette.black,
  current: "currentColor",
  transparent: "transparent",
  neutral: {
    DEFAULT: palette.neutral[9],
    50: palette.neutral[0],
    100: palette.neutral[1],
    200: palette.neutral[2],
    300: palette.neutral[3],
    400: palette.neutral[4],
    500: palette.neutral[5],
    600: palette.neutral[6],
    700: palette.neutral[7],
    800: palette.neutral[8],
    900: palette.neutral[9]
  },
  red: {
    DEFAULT: palette.red[3],
    100: palette.red[0],
    300: palette.red[1],
    500: palette.red[2],
    700: palette.red[3],
    900: palette.red[4]
  },
  orange: {
    DEFAULT: palette.orange[5],
    50: palette.orange[0],
    100: palette.orange[1],
    200: palette.orange[2],
    300: palette.orange[3],
    400: palette.orange[4],
    500: palette.orange[5],
    600: palette.orange[6],
    700: palette.orange[7],
    800: palette.orange[8],
    900: palette.orange[9]
  },
  yellow: {
    DEFAULT: palette.yellow[5],
    50: palette.yellow[0],
    100: palette.yellow[1],
    200: palette.yellow[2],
    300: palette.yellow[3],
    400: palette.yellow[4],
    500: palette.yellow[5],
    600: palette.yellow[6],
    700: palette.yellow[7],
    800: palette.yellow[8],
    900: palette.yellow[9]
  },
  green: {
    DEFAULT: palette.green[5],
    50: palette.green[0],
    100: palette.green[1],
    200: palette.green[2],
    300: palette.green[3],
    400: palette.green[4],
    500: palette.green[5],
    600: palette.green[6],
    700: palette.green[7],
    800: palette.green[8],
    900: palette.green[9]
  },
  turquoise: {
    DEFAULT: palette.turquoise[4],
    100: palette.turquoise[0],
    300: palette.turquoise[1],
    500: palette.turquoise[2],
    600: palette.turquoise[3],
    700: palette.turquoise[4],
    900: palette.turquoise[5]
  },
  blue: {
    DEFAULT: palette.blue[5],
    50: palette.blue[0],
    100: palette.blue[1],
    200: palette.blue[2],
    300: palette.blue[3],
    400: palette.blue[4],
    500: palette.blue[5],
    600: palette.blue[6],
    700: palette.blue[7],
    800: palette.blue[8],
    900: palette.blue[9]
  },
  purple: {
    DEFAULT: palette.purple[3],
    100: palette.purple[0],
    300: palette.purple[1],
    500: palette.purple[2],
    700: palette.purple[3],
    900: palette.purple[4]
  },
  pink: {
    DEFAULT: palette.pink[3],
    100: palette.pink[0],
    300: palette.pink[1],
    500: palette.pink[2],
    700: palette.pink[3],
    900: palette.pink[4]
  },
  brown: {
    DEFAULT: palette.brown[3],
    50: palette.brown[0],
    100: palette.brown[1],
    300: palette.brown[2],
    500: palette.brown[3],
    700: palette.brown[4],
    900: palette.brown[5]
  },
  magenta: {
    DEFAULT: palette.magenta[5],
    50: palette.magenta[0],
    100: palette.magenta[1],
    200: palette.magenta[2],
    300: palette.magenta[3],
    400: palette.magenta[4],
    500: palette.magenta[5],
    600: palette.magenta[6],
    700: palette.magenta[7],
    800: palette.magenta[8],
    900: palette.magenta[9]
  }
};

// src/theme/typography.ts
var typography = {
  standard: "Lato"
};

// src/theme/index.ts
var theme = {
  colors,
  extend: {
    screens: {
      xxs: "320px",
      xs: "425px",
      // Widget mobile breakpoint
      wm: "500px"
    },
    fontSize: {
      xxs: [
        ".5rem",
        {
          lineHeight: "0.75rem"
        }
      ]
    },
    fontFamily: {
      sans: ["Circular Std", typography.standard, "sans-serif"],
      circular: ["Circular Std", "Arial", "san-serif"]
    },
    boxShadow: {
      top: "0 -4px 4px 0 rgba(166, 166, 166, 0.13)",
      around: "0 1px 10px 0 rgba(0, 0, 0, 0.16)",
      "3xl": "5px 3px 6px #00000029"
    },
    dropShadow: {
      text: "0px 3px 6px #00000029"
    },
    zIndex: {
      "99": 99
    },
    spacing: {
      "30": "7.5rem",
      "37": "9.375rem"
    },
    animation: {
      "fade-in-100": "fade-in .1s linear forwards",
      "fade-in-150": "fade-in .15s linear forwards",
      "fade-in": "fade-in .25s linear forwards",
      "fade-out-100": "fade-out .1s linear forwards",
      "fade-out-150": "fade-out .15s linear forwards",
      "fade-out": "fade-out .25s linear forwards",
      "fade-in-down-150": "fade-in-down .15s linear 1",
      "fade-in-down": "fade-in-down .25s linear 1",
      "fade-out-down-150": "fade-out-down .15s linear 1",
      "fade-out-down": "fade-out-down .25s linear 1",
      "fade-in-up-150": "fade-in-up .15s linear 1",
      "fade-in-up": "fade-in-up .25s linear 1",
      "fade-out-up-150": "fade-out-up .15s linear 1",
      "fade-out-up": "fade-out-up .25s linear 1",
      "fade-in-left-150": "fade-in-left .15s linear 1",
      "fade-in-left": "fade-in-left .25s linear 1",
      "fade-out-left-150": "fade-out-left .15s linear 1",
      "fade-out-left": "fade-out-left .25s linear 1",
      "fade-in-right-150": "fade-in-right .15s linear 1",
      "fade-in-right": "fade-in-right .25s linear 1",
      "fade-out-right-150": "fade-out-right .15s linear 1",
      "fade-out-right": "fade-out-right .25s linear 1",
      "rotate-360": "rotate-360 2s linear infinite"
    },
    keyframes: {
      "rotate-360": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
      },
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" }
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" }
      },
      "fade-in-down": {
        "0%": { opacity: "0", transform: "translateY(-20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-down": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(20px)" }
      },
      "fade-in-up": {
        "0%": { opacity: "0", transform: "translateY(20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-up": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(-20px)" }
      },
      "fade-in-left": {
        "0%": { opacity: "0", transform: "translateX(20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-left": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(-20px)" }
      },
      "fade-in-right": {
        "0%": { opacity: "0", transform: "translateX(-20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-right": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(20px)" }
      }
    }
  }
};

// src/components/EmbedTile/EmbedTileProfilePanel.tsx
function Loading() {
  return /* @__PURE__ */ import_react10.default.createElement("div", { className: "v2-w-full v2-flex v2-space-x-2.5" }, /* @__PURE__ */ import_react10.default.createElement(
    import_react_loading_skeleton.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      circle: true,
      containerClassName: "v2-h-10 v2-w-10 v2-flex"
    }
  ), /* @__PURE__ */ import_react10.default.createElement("div", { className: "v2-w-3/5 v2-flex v2-flex-col v2-space-y-1" }, /* @__PURE__ */ import_react10.default.createElement(
    import_react_loading_skeleton.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      containerClassName: "v2-h-5 v2-w-3/5 v2-flex"
    }
  ), /* @__PURE__ */ import_react10.default.createElement(
    import_react_loading_skeleton.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      containerClassName: "v2-h-3.5 v2-w-3/5 v2-flex"
    }
  )));
}
function EmbedTileProfilePanel({
  imageUrl,
  name,
  tag,
  url,
  className,
  imageClassName,
  nameClassName,
  tagClassName,
  hideProfileImage = false,
  hideProfileName = false,
  hideProfileTag = false,
  loading = false,
  imageComponent: DefaultImageComponent
}) {
  if (loading)
    return /* @__PURE__ */ import_react10.default.createElement(Loading, null);
  const imageProps = {
    src: imageUrl,
    width: 0,
    height: 0,
    alt: "Profile Picture",
    className: (0, import_classnames10.default)(imageClassName, [
      "v2-rounded-full v2-h-10 v2-w-10 v2-object-cover v2-transition-all v2-ease-in-out",
      "group-hover:v2-outline-blue-300 group-hover:v2-outline",
      "group-hover:-v2-outline-offset-2 group-hover:v2-outline-2"
    ])
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react10.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return imageUrl;
      }
    })
  ) : /* @__PURE__ */ import_react10.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react10.default.createElement(
    "a",
    {
      className: (0, import_classnames10.default)(className, [
        "v2-flex v2-flex-row v2-gap-x-2.5 v2-items-center",
        "v2-group v2-truncate"
      ]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    !hideProfileImage && imageUrl && imageComponent,
    /* @__PURE__ */ import_react10.default.createElement("div", { className: "v2-flex v2-flex-col v2-items-start v2-justify-between v2-gap-1" }, !hideProfileName && name && /* @__PURE__ */ import_react10.default.createElement(
      "span",
      {
        className: (0, import_classnames10.default)(nameClassName, [
          "v2-text-neutral-900 v2-text-base group-hover:v2-underline"
        ])
      },
      name
    ), !hideProfileTag && tag && /* @__PURE__ */ import_react10.default.createElement(
      "span",
      {
        className: (0, import_classnames10.default)(tagClassName, [
          "v2-text-neutral-500 v2-text-xs group-hover:v2-underline"
        ])
      },
      tag
    ))
  );
}

// src/components/EmbedTile/EmbedTileReactionPanel.tsx
var import_react27 = __toESM(require("react"));
var import_classnames24 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileIconImage.tsx
var import_react25 = __toESM(require("react"));

// src/components/Nav/MainNavigation/LogoHeader.tsx
var import_react11 = __toESM(require("react"));
var import_classnames11 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/MainNavigation.tsx
var import_react12 = __toESM(require("react"));
var import_classnames12 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/MaskedImage.tsx
var import_react13 = __toESM(require("react"));
var import_styled = __toESM(require("@emotion/styled"));
var import_classnames13 = __toESM(require("classnames"));
var Image2 = import_styled.default.i`
  ${({ imageUrl, bgColor, hideWhiteBackground = false }) => `
    ${!hideWhiteBackground ? "background-color: white;" : ""}
    ${bgColor ? `background-color: ${bgColor} !important;` : ""}
    mask: url("${imageUrl}");
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `}
`;

// src/components/Nav/MainNavigation/NavContainer.tsx
var import_react14 = __toESM(require("react"));
var import_classnames14 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavGroup.tsx
var import_react15 = __toESM(require("react"));
var import_classnames15 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavItem.tsx
var import_react17 = __toESM(require("react"));
var import_classnames17 = __toESM(require("classnames"));
var import_styled2 = __toESM(require("@emotion/styled"));

// src/components/Nav/MainNavigation/NavItemLabel.tsx
var import_react16 = __toESM(require("react"));
var import_classnames16 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavItem.tsx
var hoverImageStyle = (hoverImageUrl) => `
  i {
    background: url("${hoverImageUrl != null ? hoverImageUrl : ""}") no-repeat 0 0;
    background-position: center;
    mask: none;
  }
`;
var ItemContainer = import_styled2.default.li`
  ${({ hoverImageUrl, active }) => `
    ${hoverImageUrl ? `:hover { ${hoverImageStyle(hoverImageUrl)}}` : ""}
    ${active ? hoverImageStyle(hoverImageUrl) : ""}
  `}
`;

// src/components/Nav/NavProfileDropdown/NavProfileDropdown.tsx
var import_react24 = __toESM(require("react"));
var import_classnames22 = __toESM(require("classnames"));

// src/components/Nav/NavProfileIcon/NavProfileIcon.tsx
var import_react18 = __toESM(require("react"));
var import_classnames18 = __toESM(require("classnames"));
var import_react_fontawesome2 = require("@fortawesome/react-fontawesome");

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faChevronLeft = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [384, 512, [9001], "f053", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
};
var faChevronRight = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [384, 512, [9002], "f054", "M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
};

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItems.tsx
var import_react20 = __toESM(require("react"));

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItem.tsx
var import_react19 = __toESM(require("react"));
var import_classnames19 = __toESM(require("classnames"));

// src/components/Dropdown/Dropdown.tsx
var import_react23 = __toESM(require("react"));
var import_classnames21 = __toESM(require("classnames"));

// src/components/Dropdown/DropdownContainer.tsx
var import_react21 = __toESM(require("react"));
var import_classnames20 = __toESM(require("classnames"));

// src/hook/use-detect-outside-click-hook.ts
var import_react22 = require("react");

// src/components/EmbedTile/EmbedTileIconImage.tsx
var import_classnames23 = __toESM(require("classnames"));
function EmbedTileIconImage({
  type,
  reactionType,
  loading = false,
  theme: theme2,
  className,
  imageComponent: DefaultImageComponent,
  height = 0,
  width = 0
}) {
  var _a, _b, _c, _d, _e;
  const defaultClassName2 = "v2-shrink-0 v2-transition-all";
  const details = reactionType ? (_c = (_b = (_a = embedTileDetails) == null ? void 0 : _a[type]) == null ? void 0 : _b.reactions) == null ? void 0 : _c[reactionType] : (_e = (_d = embedTileDetails) == null ? void 0 : _d[type]) == null ? void 0 : _e.icon;
  if (!details)
    return /* @__PURE__ */ import_react25.default.createElement(import_react25.default.Fragment, null);
  const { url, iconType, iconClassName } = details;
  const imageProps = {
    src: url,
    alt: "Icon Image",
    width,
    height,
    className: (0, import_classnames23.default)(className, iconClassName, defaultClassName2, {
      "v2-grayscale": loading
    })
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react25.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return url;
      }
    })
  ) : /* @__PURE__ */ import_react25.default.createElement("img", __spreadValues({}, imageProps));
  if (iconType === "masked_image") {
    return /* @__PURE__ */ import_react25.default.createElement(
      Image2,
      {
        imageUrl: url,
        className: (0, import_classnames23.default)(className, iconClassName, defaultClassName2, {
          "!v2-bg-neutral-200": loading
        }),
        bgColor: theme2 == null ? void 0 : theme2.primaryColor,
        hideWhiteBackground: true
      }
    );
  }
  return imageComponent;
}

// src/utils.ts
var import_react26 = __toESM(require("react"));
function openFullScreen(videoElement) {
  if (videoElement.requestFullscreen) {
    videoElement.requestFullscreen();
  } else if (videoElement.webkitEnterFullscreen) {
    videoElement.webkitEnterFullscreen();
  } else if (videoElement.msRequestFullscreen) {
    videoElement.msRequestFullscreen();
  } else if (videoElement.mozRequestFullScreen) {
    videoElement.mozRequestFullScreen();
  } else {
    throw new Error("fullscreenElement is not supported by this browser");
  }
}
function toCompactNumber(number = 0, precision = 1) {
  return Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: precision
  }).format(number);
}

// src/components/EmbedTile/EmbedTileReactionPanel.tsx
var import_react_loading_skeleton2 = __toESM(require("react-loading-skeleton"));
function EmbedTileReactionPanel({
  type,
  reactions,
  url,
  className,
  reactionClassName,
  countClassName,
  loading = false
}) {
  const totalReactions = reactions == null ? void 0 : reactions.reduce((n, { count }) => n + count, 0);
  if (!totalReactions && !loading)
    return /* @__PURE__ */ import_react27.default.createElement(import_react27.default.Fragment, null);
  return /* @__PURE__ */ import_react27.default.createElement(
    "a",
    {
      className: (0, import_classnames24.default)(className, [
        "v2-flex v2-flex-row v2-gap-x-2.5 v2-items-center",
        "v2-cursor-pointer v2-group"
      ]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    loading && /* @__PURE__ */ import_react27.default.createElement("span", { className: "v2-flex v2-flex-row v2-gap-x-[3px]" }, /* @__PURE__ */ import_react27.default.createElement(
      EmbedTileIconImage,
      {
        type,
        reactionType: "like" /* Like */,
        className: (0, import_classnames24.default)(reactionClassName),
        width: 15,
        height: 15,
        loading: true
      }
    )),
    reactions && /* @__PURE__ */ import_react27.default.createElement(
      "span",
      { className: "v2-flex v2-flex-row v2-gap-x-[3px]" },
      /** Show only up to 3 reactions */
      reactions.slice(0, 3).map(({ type: reactionType }, index) => {
        return /* @__PURE__ */ import_react27.default.createElement(
          EmbedTileIconImage,
          {
            key: index,
            type,
            reactionType,
            className: (0, import_classnames24.default)(reactionClassName, "v2-h-[15px] v2-w-[15px]")
          }
        );
      })
    ),
    /* @__PURE__ */ import_react27.default.createElement(
      "span",
      {
        className: (0, import_classnames24.default)(countClassName, [
          "v2-flex v2-text-neutral-500 v2-text-xs v2-font-bold",
          "v2-transition-all group-hover:v2-text-neutral-900"
        ])
      },
      loading ? /* @__PURE__ */ import_react27.default.createElement(
        import_react_loading_skeleton2.default,
        {
          baseColor: colors.neutral[200],
          highlightColor: colors.neutral[100],
          height: "100%",
          containerClassName: "v2-h-4 v2-w-6 v2-flex"
        }
      ) : toCompactNumber(reactions == null ? void 0 : reactions.reduce((n, { count }) => n + count, 0))
    )
  );
}

// src/components/EmbedTile/EmbedTileTextContent.tsx
var import_react40 = __toESM(require("react"));

// node_modules/linkify-react/dist/linkify-react.es.js
var React27 = __toESM(require("react"));
var import_linkifyjs = require("linkifyjs");
function stringToElements(str, opts, meta) {
  const tokens = (0, import_linkifyjs.tokenize)(str);
  const elements = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.t === "nl" && opts.get("nl2br")) {
      const key = `__linkify-el-${meta.elementId++}`;
      elements.push(React27.createElement("br", {
        key
      }));
    } else if (!token.isLink || !opts.check(token)) {
      elements.push(token.toString());
    } else {
      let rendered = opts.render(token);
      if (!("key" in rendered.props)) {
        const key = `__linkify-el-${meta.elementId++}`;
        const props = import_linkifyjs.options.assign({
          key
        }, rendered.props);
        rendered = React27.cloneElement(rendered, props);
      }
      elements.push(rendered);
    }
  }
  return elements;
}
function linkifyReactElement(element, opts, meta) {
  if (React27.Children.count(element.props.children) === 0) {
    return element;
  }
  const children = [];
  React27.Children.forEach(element.props.children, (child) => {
    if (typeof child === "string") {
      children.push.apply(children, stringToElements(child, opts, meta));
    } else if (React27.isValidElement(child)) {
      if (typeof child.type === "string" && opts.ignoreTags.indexOf(child.type.toUpperCase()) >= 0) {
        children.push(child);
      } else {
        children.push(linkifyReactElement(child, opts, meta));
      }
    } else {
      children.push(child);
    }
  });
  const key = `__linkify-el-${meta.elementId++}`;
  const newProps = import_linkifyjs.options.assign({
    key
  }, element.props);
  return React27.cloneElement(element, newProps, children);
}
var Linkify = (props) => {
  let linkId = 0;
  const defaultLinkRender = (_ref) => {
    let {
      tagName,
      attributes,
      content
    } = _ref;
    attributes.key = `__linkify-lnk-${linkId++}`;
    if (attributes.class) {
      attributes.className = attributes.class;
      delete attributes.class;
    }
    return React27.createElement(tagName, attributes, content);
  };
  const newProps = {
    key: "__linkify-wrapper"
  };
  for (const prop in props) {
    if (prop !== "options" && prop !== "as" && prop !== "tagName" && prop !== "children") {
      newProps[prop] = props[prop];
    }
  }
  const opts = new import_linkifyjs.Options(props.options, defaultLinkRender);
  const as = props.as || props.tagName || React27.Fragment || "span";
  const children = props.children;
  const element = React27.createElement(as, newProps, children);
  return linkifyReactElement(element, opts, {
    elementId: 0
  });
};

// node_modules/linkify-plugin-hashtag/dist/linkify-plugin-hashtag.es.js
var import_linkifyjs2 = require("linkifyjs");
var HashtagToken = (0, import_linkifyjs2.createTokenClass)("hashtag", {
  isLink: true
});
function hashtag(_ref) {
  let {
    scanner,
    parser
  } = _ref;
  const {
    POUND,
    UNDERSCORE
  } = scanner.tokens;
  const {
    alpha,
    numeric,
    alphanumeric,
    emoji
  } = scanner.tokens.groups;
  const Hash = parser.start.tt(POUND);
  const HashPrefix = Hash.tt(UNDERSCORE);
  const Hashtag = new import_linkifyjs2.State(HashtagToken);
  Hash.ta(numeric, HashPrefix);
  Hash.ta(alpha, Hashtag);
  Hash.ta(emoji, Hashtag);
  HashPrefix.ta(alpha, Hashtag);
  HashPrefix.ta(emoji, Hashtag);
  HashPrefix.ta(numeric, HashPrefix);
  HashPrefix.tt(UNDERSCORE, HashPrefix);
  Hashtag.ta(alphanumeric, Hashtag);
  Hashtag.ta(emoji, Hashtag);
  Hashtag.tt(UNDERSCORE, Hashtag);
}
(0, import_linkifyjs2.registerPlugin)("hashtag", hashtag);

// src/components/EmbedTile/EmbedTileTextContent.tsx
var import_styled4 = __toESM(require("@emotion/styled"));

// src/components/RichTextViewer/RichTextViewer.tsx
var import_react39 = __toESM(require("react"));

// src/components/RichTextEditor/Buttons/BaseButton.tsx
var import_react28 = __toESM(require("react"));
var import_classnames25 = __toESM(require("classnames"));
var BaseButton = (_a) => {
  var _b = _a, {
    className,
    icon,
    active,
    onClick
  } = _b, props = __objRest(_b, [
    "className",
    "icon",
    "active",
    "onClick"
  ]);
  return /* @__PURE__ */ import_react28.default.createElement(
    "button",
    __spreadProps(__spreadValues({}, props), {
      className: (0, import_classnames25.default)(
        className,
        [
          "v2-border-0 v2-cursor-pointer v2-px-1.5 v2-flex v2-items-center",
          "hover:v2-bg-turquoise-100 v2-rounded v2-select-none v2-h-6"
        ],
        {
          "v2-bg-neutral-100": !active,
          "v2-bg-neutral-200": active,
          "v2-opacity-20": props.disabled
        }
      ),
      onMouseDown: (event) => {
        event.preventDefault();
        onClick == null ? void 0 : onClick();
      }
    }),
    icon
  );
};

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var import_react38 = __toESM(require("react"));
var import_slate_react5 = require("slate-react");

// src/components/RichTextEditor/utils.ts
var import_slate3 = require("slate");

// src/components/RichTextEditor/types.ts
var TextAlignType = /* @__PURE__ */ ((TextAlignType2) => {
  TextAlignType2["Center"] = "center";
  TextAlignType2["Left"] = "left";
  TextAlignType2["Right"] = "right";
  TextAlignType2["Justify"] = "justify";
  return TextAlignType2;
})(TextAlignType || {});
var hotkeys = {
  "mod+b": "bold" /* Bold */,
  "mod+i": "italic" /* Italic */,
  "mod+u": "underline" /* Underline */
};
var listStyles = [
  "numbered-list" /* NumberedList */,
  "bulleted-list" /* BulletedList */
];

// src/components/RichTextEditor/Editor/index.tsx
var import_react37 = __toESM(require("react"));
var import_is_hotkey = __toESM(require_lib());
var import_slate_react4 = require("slate-react");
var import_classnames29 = __toESM(require("classnames"));

// src/components/RichTextEditor/Renderer/Element.tsx
var import_react29 = __toESM(require("react"));
var import_styled3 = __toESM(require("@emotion/styled"));
var OrderedList = import_styled3.default.ol`
  li {
    padding-bottom: 0.75rem;
  }
`;
var Element2 = ({ attributes, children, element }) => {
  const style = { textAlign: element.align, color: "unset" };
  switch (element.type) {
    case "heading-one" /* HeadingOne */:
      return /* @__PURE__ */ import_react29.default.createElement(
        "h1",
        __spreadValues({
          className: "v2-text-[2rem] v2-font-normal v2-leading-10 v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "heading-two" /* HeadingTwo */:
      return /* @__PURE__ */ import_react29.default.createElement(
        "h2",
        __spreadValues({
          className: "v2-text-2xl v2-font-normal v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "bulleted-list" /* BulletedList */:
      return /* @__PURE__ */ import_react29.default.createElement(
        "ul",
        __spreadValues({
          className: "v2-list-inside v2-list-disc v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "list-item" /* ListItem */:
      return /* @__PURE__ */ import_react29.default.createElement("li", __spreadValues({ style }, attributes), children);
    case "numbered-list" /* NumberedList */:
      return /* @__PURE__ */ import_react29.default.createElement(
        OrderedList,
        __spreadValues({
          className: "v2-list-inside v2-list-decimal v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    default:
      return /* @__PURE__ */ import_react29.default.createElement(
        "p",
        __spreadValues({
          className: "v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
  }
};

// src/components/RichTextEditor/Renderer/Leaf.tsx
var import_react30 = __toESM(require("react"));
var Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = /* @__PURE__ */ import_react30.default.createElement("strong", { className: "v2-font-bold" }, children);
  }
  if (leaf.italic) {
    children = /* @__PURE__ */ import_react30.default.createElement("em", { className: "v2-italic" }, children);
  }
  if (leaf.underline) {
    children = /* @__PURE__ */ import_react30.default.createElement("u", { className: "v2-underline" }, children);
  }
  if (leaf.decoration === "link" /* Link */) {
    children = /* @__PURE__ */ import_react30.default.createElement(
      "a",
      {
        className: "v2-text-blue-400 hover:!v2-text-blue-300",
        href: leaf.text,
        target: "_blank",
        rel: "noreferrer"
      },
      children
    );
  }
  return /* @__PURE__ */ import_react30.default.createElement("span", __spreadValues({}, attributes), children);
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_react34 = __toESM(require("react"));

// src/components/RichTextEditor/Buttons/MarkButton.tsx
var import_react31 = __toESM(require("react"));
var import_slate_react = require("slate-react");
var MarkButton = ({
  className,
  type,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react.useSlate)();
  const onClickHandler = () => toggleMark(editor, type);
  return /* @__PURE__ */ import_react31.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isMarkActive(editor, type),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_classnames27 = __toESM(require("classnames"));

// src/components/RichTextEditor/Toolbar/GroupContainer.tsx
var import_react32 = __toESM(require("react"));
var import_classnames26 = __toESM(require("classnames"));
function GroupContainer({ className, children }) {
  return /* @__PURE__ */ import_react32.default.createElement(
    "div",
    {
      className: (0, import_classnames26.default)(
        className,
        "v2-flex v2-px-1.5 sm:v2-gap-x-2.5 sm:v2-px-2.5"
      )
    },
    children
  );
}

// src/components/RichTextEditor/Buttons/FormatButton.tsx
var import_react33 = __toESM(require("react"));
var import_slate_react2 = require("slate-react");
var import_slate = require("slate");
var clearBlockFormatting = (editor) => {
  import_slate.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate.Editor.isEditor(n) && import_slate.Element.isElement(n) && listStyles.includes(n.type),
    split: true
  });
  import_slate.Transforms.setNodes(editor, {
    type: "paragraph" /* Paragraph */
  });
};
var clearMarkFormatting = (editor) => {
  import_slate.Editor.removeMark(editor, "bold" /* Bold */);
  import_slate.Editor.removeMark(editor, "italic" /* Italic */);
  import_slate.Editor.removeMark(editor, "underline" /* Underline */);
};
var clearFormatting = (editor) => {
  clearBlockFormatting(editor);
  clearMarkFormatting(editor);
};
var FormatButton = ({
  className,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react2.useSlate)();
  const onClickHandler = () => clearFormatting(editor);
  return /* @__PURE__ */ import_react33.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var boldMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bold-mark.svg";
var italicMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/italic-mark.svg";
var underlineMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/underline-mark.svg";
var bulletedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bulleted-block.svg";
var numberedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/numbered-block.svg";
var headingOneBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-one-block.svg";
var headingTwoBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-two-block.svg";
var clearFormatIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/clear-format.svg";
function Toolbar({
  className,
  groupClassName,
  config,
  containerRef,
  disabled = false,
  toolbarPosition = "bottom"
}) {
  const {
    hideBold,
    hideUnderline,
    hideItalic,
    hideBulletedList,
    hideNumberedList,
    hideHeadingOne,
    hideHeadingTwo,
    hideClearFormat
  } = (0, import_react34.useMemo)(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      hideBold: (_a = config == null ? void 0 : config.hideBold) != null ? _a : false,
      hideUnderline: (_b = config == null ? void 0 : config.hideUnderline) != null ? _b : false,
      hideItalic: (_c = config == null ? void 0 : config.hideItalic) != null ? _c : false,
      hideBulletedList: (_d = config == null ? void 0 : config.hideBulletedList) != null ? _d : false,
      hideNumberedList: (_e = config == null ? void 0 : config.hideNumberedList) != null ? _e : false,
      hideHeadingOne: (_f = config == null ? void 0 : config.hideHeadingOne) != null ? _f : false,
      hideHeadingTwo: (_g = config == null ? void 0 : config.hideHeadingTwo) != null ? _g : false,
      hideClearFormat: (_h = config == null ? void 0 : config.hideClearFormat) != null ? _h : false
    };
  }, [config]);
  const headingButtons = (!hideHeadingOne || !hideHeadingTwo) && /* @__PURE__ */ import_react34.default.createElement(GroupContainer, { className: groupClassName }, !hideHeadingOne && /* @__PURE__ */ import_react34.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-one" /* HeadingOne */,
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingOneBlockIcon })
    }
  ), !hideHeadingTwo && /* @__PURE__ */ import_react34.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-two" /* HeadingTwo */,
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingTwoBlockIcon })
    }
  ));
  const formatButtons = (!hideBold || !hideItalic || !hideUnderline) && /* @__PURE__ */ import_react34.default.createElement(GroupContainer, { className: groupClassName }, !hideBold && /* @__PURE__ */ import_react34.default.createElement(
    MarkButton,
    {
      disabled,
      type: "bold" /* Bold */,
      className: "!v2-px-[7px]",
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-3 v2-w-2.5", src: boldMarkIcon })
    }
  ), !hideItalic && /* @__PURE__ */ import_react34.default.createElement(
    MarkButton,
    {
      disabled,
      type: "italic" /* Italic */,
      className: "!v2-px-2",
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-3 v2-w-2", src: italicMarkIcon })
    }
  ), !hideUnderline && /* @__PURE__ */ import_react34.default.createElement(
    MarkButton,
    {
      disabled,
      type: "underline" /* Underline */,
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-3 v2-w-3", src: underlineMarkIcon })
    }
  ));
  const listButtons = (!hideBulletedList || !hideNumberedList) && /* @__PURE__ */ import_react34.default.createElement(GroupContainer, { className: groupClassName }, !hideBulletedList && /* @__PURE__ */ import_react34.default.createElement(
    BlockButton,
    {
      disabled,
      style: "bulleted-list" /* BulletedList */,
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-4 v2-w-3", src: bulletedBlockIcon })
    }
  ), !hideNumberedList && /* @__PURE__ */ import_react34.default.createElement(
    BlockButton,
    {
      disabled,
      style: "numbered-list" /* NumberedList */,
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-4 v2-w-3", src: numberedBlockIcon })
    }
  ));
  const clearFormatButton = !hideClearFormat && /* @__PURE__ */ import_react34.default.createElement(GroupContainer, { className: groupClassName }, /* @__PURE__ */ import_react34.default.createElement(
    FormatButton,
    {
      disabled,
      className: "!v2-px-1.5 !v2-py-1",
      icon: /* @__PURE__ */ import_react34.default.createElement("img", { className: "v2-h-3 v2-w-3", src: clearFormatIcon })
    }
  ));
  const buttonComponents = (0, import_react34.useMemo)(() => {
    const components = [
      headingButtons,
      formatButtons,
      listButtons,
      clearFormatButton
    ];
    return components.filter((component) => component != false);
  }, [config]);
  return /* @__PURE__ */ import_react34.default.createElement(
    "div",
    {
      ref: containerRef,
      className: (0, import_classnames27.default)(className, ["v2-flex v2-py-1 v2-bg-neutral-100 v2-h-8"], {
        "v2-rounded-t-sm": toolbarPosition == "top",
        "v2-rounded-b-sm": toolbarPosition == "bottom"
      })
    },
    buttonComponents.map((child, index) => /* @__PURE__ */ import_react34.default.createElement(import_react34.default.Fragment, { key: index }, !!index && /* @__PURE__ */ import_react34.default.createElement("span", { className: "v2-h-6 v2-w-[1px] v2-bg-neutral-300" }), child))
  );
}

// src/components/RichTextEditor/Container/index.tsx
var import_react35 = __toESM(require("react"));
var import_classnames28 = __toESM(require("classnames"));
function Container(_a) {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ import_react35.default.createElement("div", __spreadValues({ className: (0, import_classnames28.default)(className, "v2-font-circular") }, props), children);
}

// src/components/RichTextEditor/use-editor-hook.ts
var import_react36 = require("react");
var import_slate2 = require("slate");
var import_slate_history = require("slate-history");
var import_slate_react3 = require("slate-react");
var useEditor = () => {
  return {
    editor: (0, import_react36.useMemo)(() => (0, import_slate_history.withHistory)((0, import_slate_react3.withReact)((0, import_slate2.createEditor)())), [])
  };
};

// src/utils/url.ts
var findUrlsInText = (text) => {
  const urlRegex = (
    // eslint-disable-next-line no-useless-escape
    /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim
  );
  const matches = text.match(urlRegex);
  return matches ? matches.map((m) => [m.trim(), text.indexOf(m.trim())]) : [];
};

// src/components/RichTextEditor/Editor/index.tsx
var defaultEmptyRichTextValue = [
  {
    type: "paragraph" /* Paragraph */,
    children: [
      {
        text: ""
      }
    ]
  }
];
var RichTextEditor = (_a) => {
  var _b = _a, {
    value,
    onChange,
    placeholder = "Enter some rich text\u2026",
    className,
    editorClassName,
    toolbarClassName,
    toolbarGroupClassName,
    toolbarConfig,
    toolbarPosition = "bottom",
    editor: initialEditor,
    hideToolbar = false,
    onKeyDown,
    onScrollToView,
    style
  } = _b, props = __objRest(_b, [
    "value",
    "onChange",
    "placeholder",
    "className",
    "editorClassName",
    "toolbarClassName",
    "toolbarGroupClassName",
    "toolbarConfig",
    "toolbarPosition",
    "editor",
    "hideToolbar",
    "onKeyDown",
    "onScrollToView",
    "style"
  ]);
  const { readOnly } = props;
  const toolbarRef = (0, import_react37.useRef)(null);
  const [content, setContent] = (0, import_react37.useState)(
    value != null ? value : defaultEmptyRichTextValue
  );
  const editor = initialEditor != null ? initialEditor : useEditor().editor;
  const slateDecorator = ([node, path]) => {
    const nodeText = node.text;
    if (!nodeText)
      return [];
    const urls = findUrlsInText(nodeText);
    return urls.map(([url, index]) => {
      return {
        anchor: {
          path,
          offset: index
        },
        focus: {
          path,
          offset: index + url.length
        },
        decoration: "link" /* Link */
      };
    });
  };
  const onKeyDownHandler = (event) => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    for (const hotkey in hotkeys) {
      if ((0, import_is_hotkey.default)(hotkey, event)) {
        event.preventDefault();
        const mark = hotkeys[hotkey];
        toggleMark(editor, mark);
      }
    }
  };
  (0, import_react37.useEffect)(() => {
    if (value !== null && value !== void 0) {
      editor.children = value;
      setContent(value);
    }
  }, [value]);
  const onChangeHandler = (value2) => {
    setContent(value2);
    onChange == null ? void 0 : onChange(value2);
  };
  return /* @__PURE__ */ import_react37.default.createElement(import_slate_react4.Slate, { editor, initialValue: content, onChange: onChangeHandler }, /* @__PURE__ */ import_react37.default.createElement(
    Container,
    {
      style,
      className: (0, import_classnames29.default)(
        className,
        [
          "v2-rounded v2-border v2-border-neutral-200 v2-border-solid",
          "v2-flex v2-h-full v2-w-full v2-text-neutral-900"
        ],
        {
          "v2-flex-col": toolbarPosition === "bottom",
          "v2-flex-col-reverse": toolbarPosition === "top"
        }
      )
    },
    /* @__PURE__ */ import_react37.default.createElement(
      import_slate_react4.Editable,
      __spreadProps(__spreadValues({}, props), {
        key: "rich-text-editor",
        renderElement: Element2,
        renderLeaf: Leaf,
        placeholder,
        renderPlaceholder: ({ attributes, children }) => /* @__PURE__ */ import_react37.default.createElement(
          "span",
          __spreadProps(__spreadValues({}, attributes), {
            style: __spreadProps(__spreadValues({}, attributes.style), {
              display: "unset"
            })
          }),
          children
        ),
        className: (0, import_classnames29.default)(editorClassName, [
          "v2-scrollbar-thin v2-scrollbar-track-neutral-200 v2-p-2",
          "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full",
          "v2-overflow-x-hidden v2-h-full v2-w-auto v2-outline-none"
        ]),
        onKeyDown: onKeyDownHandler,
        scrollSelectionIntoView: onScrollToView,
        decorate: slateDecorator
      })
    ),
    !hideToolbar && /* @__PURE__ */ import_react37.default.createElement(
      Toolbar,
      {
        key: "rich-text-toolbar",
        containerRef: toolbarRef,
        className: toolbarClassName,
        groupClassName: toolbarGroupClassName,
        config: toolbarConfig,
        toolbarPosition,
        disabled: readOnly
      }
    )
  ));
};

// src/components/RichTextEditor/utils.ts
var checkIfTextAlignType = (style) => {
  return Object.values(TextAlignType).includes(
    style
  );
};
var isBlockActive = (editor, style, blockType = "type") => {
  const { selection } = editor;
  if (!selection)
    return false;
  const [match] = Array.from(
    import_slate3.Editor.nodes(editor, {
      at: import_slate3.Editor.unhangRange(editor, selection),
      match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && n[blockType] === style
    })
  );
  return !!match;
};
var isMarkActive = (editor, style) => {
  const marks = import_slate3.Editor.marks(editor);
  return marks ? marks[style] === true : false;
};
var toggleBlock = (editor, style) => {
  const isTextAlignType = checkIfTextAlignType(style);
  const isList = listStyles.includes(style);
  const isActive = isBlockActive(
    editor,
    style,
    isTextAlignType ? "align" : "type"
  );
  import_slate3.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && listStyles.includes(n.type) && !isTextAlignType,
    split: true
  });
  let newProperties;
  if (isTextAlignType) {
    newProperties = {
      align: isActive ? void 0 : style
    };
  } else {
    newProperties = {
      type: isActive ? "paragraph" /* Paragraph */ : isList ? "list-item" /* ListItem */ : style
    };
  }
  import_slate3.Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    const block = { type: style, children: [] };
    import_slate3.Transforms.wrapNodes(editor, block);
  }
};
var toggleMark = (editor, style) => {
  const isActive = isMarkActive(editor, style);
  if (isActive) {
    import_slate3.Editor.removeMark(editor, style);
  } else {
    import_slate3.Editor.addMark(editor, style, true);
  }
};
var parseRichTextToString = (value) => {
  return value.map((n) => import_slate3.Node.string(n)).join("\n");
};
function getRichTextFromSlateData(data, type = "slate" /* V1 */) {
  var _a, _b;
  const filteredData = (_b = (_a = data == null ? void 0 : data.filter((slate) => slate.type === type)) == null ? void 0 : _a[0]) == null ? void 0 : _b.data;
  return filteredData != null ? filteredData : defaultEmptyRichTextValue;
}

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var BlockButton = ({
  className,
  style,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react5.useSlate)();
  const onClickHandler = () => toggleBlock(editor, style);
  return /* @__PURE__ */ import_react38.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isBlockActive(
        editor,
        style,
        checkIfTextAlignType(style) ? "align" : "type"
      ),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextViewer/RichTextViewer.tsx
function RichTextViewer({
  value,
  className = "",
  style
}) {
  return /* @__PURE__ */ import_react39.default.createElement(
    RichTextEditor,
    {
      className: `!v2-border-0 ${className}`,
      editorClassName: "!v2-p-0",
      placeholder: "",
      value,
      style,
      readOnly: true,
      hideToolbar: true
    }
  );
}

// src/components/EmbedTile/EmbedTileTextContent.tsx
var Container2 = import_styled4.default.span`
  a {
    color: ${colors.blue[400]};

    &:hover {
      text-decoration: underline;
    }
  }
`;
function EmbedTileTextContent({
  type,
  text,
  style
}) {
  const options2 = (0, import_react40.useMemo)(() => {
    const defaultOptions = {
      nl2br: true,
      target: "_blank",
      rel: "noopener noreferrer"
    };
    if (isTwitterEmbed(type)) {
      return __spreadProps(__spreadValues({}, defaultOptions), {
        formatHref: {
          hashtag: (href) => "https://twitter.com/hashtag/" + href.substr(1)
        }
      });
    }
    if (isLinkedinEmbed(type)) {
      return __spreadProps(__spreadValues({}, defaultOptions), {
        formatHref: {
          hashtag: (href) => "https://www.linkedin.com/feed/hashtag/?keywords=" + href.substr(1)
        }
      });
    }
  }, [type]);
  const content = typeof text === "string" ? /* @__PURE__ */ import_react40.default.createElement(Linkify, { options: options2 }, text) : /* @__PURE__ */ import_react40.default.createElement(RichTextViewer, { value: text, style });
  return /* @__PURE__ */ import_react40.default.createElement(Container2, { className: "v2-whitespace-pre-wrap v2-px-5" }, content);
}

// src/components/EmbedTile/EmbedTileMediaContent.tsx
var import_react49 = __toESM(require("react"));
var import_classnames36 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileMediaTile.tsx
var import_react48 = __toESM(require("react"));
var import_classnames35 = __toESM(require("classnames"));
var import_styled6 = __toESM(require("@emotion/styled"));

// src/components/VideoPlayer/VideoPlayerComponent.tsx
var import_react47 = __toESM(require("react"));
var import_classnames34 = __toESM(require("classnames"));

// src/components/VideoPlayer/VideoControls.tsx
var import_react46 = __toESM(require("react"));

// src/components/VideoPlayer/VideoPlayerContainer.tsx
var import_react42 = __toESM(require("react"));

// src/components/VideoPlayer/VideoPlayerOverlay.tsx
var import_react41 = __toESM(require("react"));
var import_classnames30 = __toESM(require("classnames"));

// src/components/VideoPlayer/hooks/useVideoProgress.ts
var import_react43 = require("react");
function useVideoProgress({
  videoRef,
  onProgress,
  intervalDelay = 250,
  forceUseInterval = false
}) {
  const [intervalId, setIntervalId] = (0, import_react43.useState)();
  const [playing, setPlaying] = (0, import_react43.useState)(false);
  function handlePlayEvent() {
    setPlaying(true);
  }
  function handlePauseEvent() {
    setPlaying(false);
  }
  (0, import_react43.useEffect)(() => {
    if (videoRef == null ? void 0 : videoRef.current) {
      videoRef.current.addEventListener("play", handlePlayEvent);
      videoRef.current.addEventListener("pause", handlePauseEvent);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("play", handlePlayEvent);
      videoRef.current.removeEventListener("pause", handlePauseEvent);
    };
  }, [videoRef == null ? void 0 : videoRef.current]);
  const supportsTimeUpdate = (0, import_react43.useMemo)(() => {
    var _a;
    return !forceUseInterval && ((_a = (videoRef == null ? void 0 : videoRef.current) && "ontimeupdate" in videoRef.current) != null ? _a : false);
  }, [videoRef == null ? void 0 : videoRef.current]);
  function handleTimeUpdate() {
    var _a;
    ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
  }
  (0, import_react43.useEffect)(() => {
    if (supportsTimeUpdate && (videoRef == null ? void 0 : videoRef.current) && onProgress) {
      videoRef.current.addEventListener("timeupdate", handleTimeUpdate);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [supportsTimeUpdate, onProgress]);
  (0, import_react43.useEffect)(() => {
    if (onProgress && playing && (videoRef == null ? void 0 : videoRef.current) && !videoRef.current.paused && !supportsTimeUpdate) {
      setIntervalId(
        setInterval(() => {
          var _a;
          ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
        }, intervalDelay)
      );
    } else if (intervalId) {
      clearInterval(intervalId);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [playing, supportsTimeUpdate]);
}

// src/utils/localStorage.ts
var import_localforage = __toESM(require("localforage"));
var keyToStr = (key) => key.join(".");
function remember(key, value) {
  return import_localforage.default.setItem(keyToStr(key), JSON.stringify(value));
}
function recall(key) {
  return __async(this, null, function* () {
    const json = yield import_localforage.default.getItem(keyToStr(key));
    if (json) {
      return JSON.parse(json);
    }
    return null;
  });
}

// src/components/VideoPlayer/settings.ts
var storageKeys = {
  all: ["bonjoro", "video-player-settings"]
};
function rememberVideoPlayerSettings(settings) {
  return __async(this, null, function* () {
    const currentSettings = yield getVideoPlayerSettings();
    return remember(storageKeys.all, __spreadValues(__spreadValues({}, currentSettings), settings));
  });
}
function getVideoPlayerSettings() {
  return recall(storageKeys.all);
}

// src/components/VideoPlayer/VideoControls.tsx
var import_react_fontawesome3 = require("@fortawesome/react-fontawesome");
var import_classnames33 = __toESM(require("classnames"));
var import_styled5 = __toESM(require("@emotion/styled"));
var import_isFinite = __toESM(require_isFinite());

// src/utils/elapsed.ts
var import_luxon = require("luxon");
function elapsed(input, options2) {
  const duration = (import_luxon.Duration.isDuration(input) ? input : import_luxon.Duration.fromObject({ seconds: input })).shiftTo("hours", "minutes", "seconds");
  const shouldPadMinutes = !(options2 == null ? void 0 : options2.noPadMinutes);
  const format = ` ${duration.hours ? "hh:" : ""}${shouldPadMinutes ? "mm:ss" : "m:ss"}`;
  return duration.toFormat(format);
}

// src/components/Transcript/Transcript.tsx
var import_react44 = __toESM(require("react"));
var import_classnames31 = __toESM(require("classnames"));
var SENTENCE_ENDING_THRESHOLD_MS = 0.15;
var MAX_WORDS_PER_SENTENCE = 15;
function Transcript({
  videoRef,
  sentences,
  mode = "sentence" /* Sentence */,
  maxWordsPerSentence = MAX_WORDS_PER_SENTENCE,
  containerClassName,
  className,
  onClick
}) {
  const [currentTranscription, setCurrentTranscription] = (0, import_react44.useState)();
  const [sentenceEnding, setSentenceEnding] = (0, import_react44.useState)(false);
  const parsedSentences = (0, import_react44.useMemo)(() => {
    if (!sentences || sentences.length === 0)
      return [];
    return sentences == null ? void 0 : sentences.reduce((sentences2, sentence) => {
      var _a, _b, _c;
      const currentSentence = {
        text: sentence.text,
        start: sentence.start / 1e3,
        end: sentence.end / 1e3,
        words: (_a = sentence == null ? void 0 : sentence.words) == null ? void 0 : _a.reduce((words, word) => {
          return [
            ...words,
            {
              text: word.text,
              start: word.start / 1e3,
              end: word.end / 1e3
            }
          ];
        }, [])
      };
      if ((currentSentence == null ? void 0 : currentSentence.words) && ((_b = currentSentence == null ? void 0 : currentSentence.words) == null ? void 0 : _b.length) > maxWordsPerSentence) {
        const chunkedWords = currentSentence == null ? void 0 : currentSentence.words.reduce(
          (words, word, index) => {
            const chunkIndex = Math.floor(index / maxWordsPerSentence);
            if (!words[chunkIndex]) {
              words[chunkIndex] = [];
            }
            words[chunkIndex].push(word);
            return words;
          },
          []
        );
        return [
          ...sentences2,
          ...(_c = chunkedWords == null ? void 0 : chunkedWords.reduce((sentences3, words) => {
            var _a2, _b2;
            return [
              ...sentences3,
              {
                text: words.map((word) => word.text).join(" "),
                start: (_a2 = words[0]) == null ? void 0 : _a2.start,
                end: (_b2 = words[words.length - 1]) == null ? void 0 : _b2.end,
                words
              }
            ];
          }, [])) != null ? _c : []
        ];
      }
      return [...sentences2, currentSentence];
    }, []);
  }, [sentences, maxWordsPerSentence]);
  const hasActiveTranscriptions = (0, import_react44.useMemo)(
    () => currentTranscription !== "" && currentTranscription !== void 0,
    [currentTranscription]
  );
  (0, import_react44.useEffect)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current))
      return;
    const video = videoRef.current;
    const handleTimeUpdate = () => {
      var _a;
      const currentTime = video.currentTime;
      const currentTranscription2 = parsedSentences.find(
        (transcription) => currentTime >= transcription.start && currentTime <= transcription.end
      );
      if (currentTranscription2 && currentTime <= (currentTranscription2 == null ? void 0 : currentTranscription2.end) && (currentTranscription2 == null ? void 0 : currentTranscription2.end) - currentTime <= SENTENCE_ENDING_THRESHOLD_MS) {
        setSentenceEnding(true);
      } else {
        setSentenceEnding(false);
      }
      switch (mode) {
        case "sentence" /* Sentence */: {
          setCurrentTranscription(
            currentTranscription2 ? currentTranscription2.text : ""
          );
          break;
        }
        case "word_per_word" /* WordPerWord */: {
          const compiledWords = (_a = currentTranscription2 == null ? void 0 : currentTranscription2.words) == null ? void 0 : _a.filter(
            (word) => currentTime >= currentTranscription2.start && currentTime >= word.end || currentTime >= word.start && currentTime <= word.end
          ).reduce((words, word) => {
            return [...words, word.text];
          }, []);
          setCurrentTranscription(
            compiledWords && (compiledWords == null ? void 0 : compiledWords.length) > 0 ? compiledWords.join(" ") : ""
          );
          break;
        }
      }
    };
    video.addEventListener("timeupdate", handleTimeUpdate);
    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [videoRef == null ? void 0 : videoRef.current, parsedSentences, mode]);
  return /* @__PURE__ */ import_react44.default.createElement(
    "div",
    {
      className: (0, import_classnames31.default)(
        containerClassName,
        "v2-rounded v2-cursor-pointer v2-select-none v2-w-auto"
      ),
      onClick
    },
    /* @__PURE__ */ import_react44.default.createElement(
      "span",
      {
        className: (0, import_classnames31.default)(className, {
          "v2-bg-black/50 v2-text-white v2-text-base v2-p-0.5 v2-select-none v2-animate-fade-in-100 v2-whitespace-normal v2-font-circular": hasActiveTranscriptions,
          "v2-animate-fade-out-100": sentenceEnding
        })
      },
      currentTranscription
    )
  );
}

// src/components/Transcript/CCButton.tsx
var import_react45 = __toESM(require("react"));
var import_classnames32 = __toESM(require("classnames"));
function CCButton({
  show = false,
  onShowClick,
  outerContainerClassName,
  innerContainerClassName,
  iconClassName
}) {
  return /* @__PURE__ */ import_react45.default.createElement(
    "div",
    {
      className: (0, import_classnames32.default)(
        "v2-pr-2.5 v2-pt-2.5 v2-cursor-pointer",
        outerContainerClassName
      )
    },
    /* @__PURE__ */ import_react45.default.createElement(
      "div",
      {
        className: (0, import_classnames32.default)(
          innerContainerClassName,
          [
            "v2-flex v2-items-center v2-p-0.5",
            "v2-rounded-md v2-opacity-25 v2-select-none v2-bg-black"
          ],
          {
            "hover:v2-opacity-50 v2-transition-all ": !show,
            "!v2-opacity-25 v2-bg-black": show
          }
        ),
        onClick: (e) => {
          e.stopPropagation();
          onShowClick == null ? void 0 : onShowClick(!show);
        }
      },
      /* @__PURE__ */ import_react45.default.createElement(
        "div",
        {
          className: (0, import_classnames32.default)(
            iconClassName,
            [
              "v2-text-center v2-items-center v2-justify-center v2-flex v2-text-xs",
              "v2-p-[2.5px] v2-py-0 v2-rounded-md v2-min-w-[25px] v2-min-h-[20px] ",
              "v2-border v2-border-[1.5px] v2-border-white v2-border-solid v2-font-bold",
              "v2-font-circular"
            ],
            {
              "v2-bg-black v2-text-white": !show,
              "v2-bg-white v2-text-neutral": show
            }
          )
        },
        "CC"
      )
    )
  );
}

// src/components/VideoPlayer/VideoControls.tsx
var volumeIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-white.svg";
var volumeMuteIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-mute-white.svg";
var fullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/full-screen-white.svg";
var exitFullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/exit-full-screen-white.svg";
var newTabIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/new-tab-white.svg";
var actionIconClass = "v2-overflow-visible v2-z-10 v2-cursor-pointer v2-select-none";
var NewTabIcon = import_styled5.default.img`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
var VideoProgress = import_styled5.default.progress`
  &::-webkit-progress-bar {
    background-color: ${colors.neutral[200]};
  }

  &::-webkit-progress-value {
    background: ${colors.yellow[500]};
  }

  &::-moz-progress-bar {
    background: ${colors.yellow[500]};
  }
`;
var VideoProgressSliderThumb = import_styled5.default.input`
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
  }

  &::-webkit-slider-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
    z-index: 50;
  }

  &:hover::-moz-range-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
  }
`;
var CtaContainer = import_styled5.default.div`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
function VideoControls({
  fullScreen,
  playing,
  muted,
  showControls = true,
  leftHeaderComponent,
  footerComponent,
  initialTranscriptionState = "closed",
  transcription,
  transcriptMode,
  transcriptionTogglerPosition,
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  ctaHoverColor,
  hideClose,
  hideNewTab,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideTranscription,
  onPlayPauseClick,
  onMuteUnmuteClick,
  onFullScreenClick,
  onNewTabClick,
  onCloseClick,
  videoRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay,
  closedCaptionClassName,
  playPauseStyle,
  playPauseClassName,
  playPausePlacement
}) {
  var _a;
  const [currentTime, setCurrentTime] = (0, import_react46.useState)(0);
  const [showTranscription, setShowTranscription] = (0, import_react46.useState)(
    initialTranscriptionState === "open"
  );
  (0, import_react46.useEffect)(() => {
    void getVideoPlayerSettings().then((settings) => {
      var _a2;
      if (!settings)
        return;
      setShowTranscription((_a2 = settings.transcriptionEnabled) != null ? _a2 : false);
    });
  }, []);
  const [formattedCurrentTime, formattedDuration, duration] = (0, import_react46.useMemo)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current)) {
      return [null, null];
    }
    const duration2 = videoRef.current.duration;
    const formattedCurrentTime2 = elapsed(currentTime, { noPadMinutes: true });
    if (!(0, import_isFinite.default)(duration2)) {
      return [null, null];
    }
    const formattedDuration2 = elapsed(duration2, { noPadMinutes: true });
    return [formattedCurrentTime2, formattedDuration2, duration2];
  }, [videoRef == null ? void 0 : videoRef.current, (_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.duration, currentTime]);
  useVideoProgress({
    videoRef,
    onProgress: setCurrentTime,
    intervalDelay: 100,
    forceUseInterval: true
  });
  const onVideoSeek = (0, import_react46.useCallback)(
    (ev) => {
      var _a2;
      ev.preventDefault();
      if (typeof ((_a2 = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a2.currentTime) === "undefined")
        return;
      videoRef.current.currentTime = Number(ev.target.value);
    },
    [videoRef == null ? void 0 : videoRef.current]
  );
  const onTranscriptionClick = (show) => {
    void rememberVideoPlayerSettings({
      transcriptionEnabled: show
    });
    setShowTranscription(show);
  };
  const transciptionTogglerProps = {
    show: showTranscription,
    onShowClick: onTranscriptionClick,
    outerContainerClassName: closedCaptionClassName
  };
  const hasValidTranscription = transcription != void 0 && transcription.length > 0;
  const fadeControls = !(fadeControlsOnPlay && !playing || !fadeControlsOnPlay);
  const isPlayPausePlacementCenter = playPausePlacement === "center" /* Center */;
  const isPlayPausePlacementLowerLeft = playPausePlacement === "lower-left" /* LowerLeft */;
  const scaleOnHoverClassName = "v2-transition-all v2-duration-200 hover:v2-scale-105";
  return /* @__PURE__ */ import_react46.default.createElement(import_react46.default.Fragment, null, showControls && /* @__PURE__ */ import_react46.default.createElement(
    "div",
    {
      className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-top-0 v2-z-50",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-flex v2-flex-row v2-justify-between" }, /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-inline-flex" }, leftHeaderComponent, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "left" && /* @__PURE__ */ import_react46.default.createElement(
      CCButton,
      __spreadProps(__spreadValues({}, transciptionTogglerProps), {
        outerContainerClassName: "v2-pl-2.5"
      })
    )), /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-inline-flex" }, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "right" && /* @__PURE__ */ import_react46.default.createElement(CCButton, __spreadValues({}, transciptionTogglerProps)), !hideNewTab && /* @__PURE__ */ import_react46.default.createElement(
      NewTabIcon,
      {
        ctaHoverColor,
        className: (0, import_classnames33.default)(
          actionIconClass,
          "v2-w-7 v2-h-7 v2-p-1",
          scaleOnHoverClassName
        ),
        src: newTabIcon,
        onClick: (e) => {
          e.stopPropagation();
          onNewTabClick == null ? void 0 : onNewTabClick();
        },
        title: "Open in a new window"
      }
    ), !hideClose && /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-px-1 v2-bg-black v2-bg-opacity-50 v2-h-7 v2-flex v2-items-center" }, /* @__PURE__ */ import_react46.default.createElement(
      import_react_fontawesome3.FontAwesomeIcon,
      {
        className: (0, import_classnames33.default)(
          scaleOnHoverClassName,
          "v2-w-5 v2-h-6 v2-text-white v2-cursor-pointer"
        ),
        icon: faTimes,
        onClick: (e) => {
          e.stopPropagation();
          onCloseClick == null ? void 0 : onCloseClick();
        },
        title: "Close"
      }
    ))))
  ), !hidePlayPause && isPlayPausePlacementCenter && /* @__PURE__ */ import_react46.default.createElement(
    "div",
    {
      className: (0, import_classnames33.default)(
        [
          "v2-absolute v2-top-1/2 v2-left-1/2 v2-flex v2-transition-all v2-duration-200",
          "-v2-translate-x-1/2 -v2-translate-y-1/2 v2-z-[20]",
          ""
        ],
        {
          "v2-animate-fade-in": !playing,
          "v2-animate-fade-out": playing
        }
      )
    },
    /* @__PURE__ */ import_react46.default.createElement(
      import_react_fontawesome3.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames33.default)(playPauseClassName, scaleOnHoverClassName, [
          "v2-h-[90px] !v2-w-[50px] v2-text-white v2-cursor-pointer"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    )
  ), /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-bottom-0 v2-z-50" }, !hideTranscription && hasValidTranscription && (videoRef == null ? void 0 : videoRef.current) && !(fadeControlsOnPlay && !playing) && /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-flex v2-items-center v2-justify-center" }, /* @__PURE__ */ import_react46.default.createElement(
    Transcript,
    {
      onClick: onPlayPauseClick,
      sentences: transcription,
      videoRef,
      mode: transcriptMode,
      maxWordsPerSentence: transcriptionMaxWordsPerSentence,
      className: transcriptionClassName,
      containerClassName: (0, import_classnames33.default)(
        transcriptionContainerClassName,
        "v2-text-center v2-w-fit",
        {
          "v2-opacity-0": !showTranscription
        }
      )
    }
  )), showControls && /* @__PURE__ */ import_react46.default.createElement(
    "div",
    {
      className: "v2-flex v2-flex-row v2-justify-between v2-pointer-events-auto v2-z-50 v2-px-3.5 v2-pb-3.5 v2-h-[42px]",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-flex v2-space-x-3.5 v2-items-center" }, !hidePlayPause && isPlayPausePlacementLowerLeft && !fadeControls && /* @__PURE__ */ import_react46.default.createElement(
      import_react_fontawesome3.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames33.default)(playPauseClassName, [
          "v2-h-[38px] !v2-w-[30px] v2-text-4xl v2-text-white",
          "v2-cursor-pointer v2-animate-fade-in"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    ), !hideTimer && formattedCurrentTime && formattedDuration && /* @__PURE__ */ import_react46.default.createElement(
      "div",
      {
        className: (0, import_classnames33.default)(
          "v2-group/video-player-timer",
          scaleOnHoverClassName,
          "v2-flex v2-gap-x-1 v2-text-white v2-text-base v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react46.default.createElement("span", { className: "v2-w-[35px] v2-font-circular" }, formattedCurrentTime),
      /* @__PURE__ */ import_react46.default.createElement(
        "span",
        {
          className: (0, import_classnames33.default)(
            "v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        "/"
      ),
      /* @__PURE__ */ import_react46.default.createElement(
        "span",
        {
          className: (0, import_classnames33.default)(
            "v2-w-[35px] v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        formattedDuration
      )
    )),
    /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-inline-flex v2-gap-x-3 v2-items-center" }, !hideMuteUnmute && /* @__PURE__ */ import_react46.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames33.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react46.default.createElement(
        "img",
        {
          className: (0, import_classnames33.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: muted ? volumeMuteIcon : volumeIcon,
          title: "Mute/Unmute",
          onClick: (e) => {
            e.stopPropagation();
            onMuteUnmuteClick == null ? void 0 : onMuteUnmuteClick();
          }
        }
      )
    ), !hideFullScreen && /* @__PURE__ */ import_react46.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames33.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react46.default.createElement(
        "img",
        {
          className: (0, import_classnames33.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: fullScreen ? exitFullScreenIcon : fullScreenIcon,
          onClick: (e) => {
            e.stopPropagation();
            onFullScreenClick == null ? void 0 : onFullScreenClick();
          },
          title: "Full screen"
        }
      )
    ))
  ), showProgressBar && /* @__PURE__ */ import_react46.default.createElement("div", { className: "v2-flex" }, /* @__PURE__ */ import_react46.default.createElement(
    VideoProgress,
    {
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-absolute v2-bottom-0 v2-transition-all v2-duration-200"
    }
  ), /* @__PURE__ */ import_react46.default.createElement(
    VideoProgressSliderThumb,
    {
      type: "range",
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-bg-transparent v2-z-10  v2-cursor-ew-resize v2-transition-all v2-duration-200",
      min: 0,
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      onChange: onVideoSeek
    }
  )), footerComponent));
}

// src/components/VideoPlayer/VideoPlayerComponent.tsx
function VideoPlayerComponent({
  videoUrl,
  videoTitle,
  videoThumbnail,
  videoThumbnailClassName,
  containerClassName,
  videoClassName,
  playPauseStyle,
  playPauseClassName,
  videoStyle,
  showDefaultFullScreen = false,
  showDefaultControls = false,
  autoPlay = false,
  loop = false,
  fullScreen = false,
  children,
  footerComponent,
  leftHeaderComponent,
  initialTranscriptionState,
  transcription,
  transcriptMode = "sentence" /* Sentence */,
  transcriptionTogglerPosition = "right",
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  preload = "auto",
  playsInline = true,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideClose,
  hideNewTab,
  hideTranscription,
  hideLoader = false,
  ctaHoverColor,
  onNewTabClick,
  onCloseClick,
  onFullScreenClick,
  onVideoLoaded,
  onThumbnailLoad,
  onThumbnailLoadError,
  onProgress,
  onPlay,
  onPause,
  videoRef,
  containerRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay = false,
  playPausePlacement = "lower-left" /* LowerLeft */,
  rounded,
  forceFirstFrame = true,
  forceShowControls = false,
  forceShowThumbnail = false,
  loadOnIntersect = false,
  muted: initialMuted = false,
  imageComponent: DefaultImageComponent,
  closedCaptionClassName
}) {
  const [activeDefaultFullScreen, setActiveDefaultFullScreen] = (0, import_react47.useState)(false);
  const [playing, setPlaying] = (0, import_react47.useState)(false);
  const [muted, setMuted] = (0, import_react47.useState)(initialMuted);
  const [videoLoaded, setVideoLoaded] = (0, import_react47.useState)(false);
  const [thumbnailClicked, setThumbnailClicked] = (0, import_react47.useState)(false);
  const videoElement = videoRef != null ? videoRef : (0, import_react47.useRef)(null);
  const containerElement = containerRef != null ? containerRef : (0, import_react47.useRef)(null);
  const toggleMute = () => setMuted(!muted);
  const togglePlay = (0, import_react47.useCallback)(
    (play) => {
      if (!videoElement.current)
        return;
      if (play) {
        void videoElement.current.play();
        setThumbnailClicked(true);
      } else {
        videoElement.current.pause();
      }
      setPlaying(play);
    },
    [videoLoaded, videoElement.current]
  );
  const onVideoLoadedHandler = () => {
    setVideoLoaded(true);
    onVideoLoaded == null ? void 0 : onVideoLoaded();
  };
  const onCloseClickHandler = () => {
    togglePlay(false);
    onCloseClick == null ? void 0 : onCloseClick();
  };
  (0, import_react47.useEffect)(() => {
    if (videoElement.current && !videoLoaded && preload === "auto") {
      videoElement.current.load();
    }
  }, []);
  const onVolumeChangeHandler = (0, import_react47.useCallback)(() => {
    var _a;
    if (!videoLoaded || !videoElement.current)
      return;
    setMuted((_a = videoElement.current) == null ? void 0 : _a.muted);
  }, [videoElement.current]);
  const toggleFullScreen = (0, import_react47.useCallback)(() => {
    if (showDefaultFullScreen && (videoElement == null ? void 0 : videoElement.current)) {
      openFullScreen(videoElement == null ? void 0 : videoElement.current);
    } else {
      onFullScreenClick == null ? void 0 : onFullScreenClick();
    }
  }, [showDefaultFullScreen, fullScreen]);
  const onVideoContainerClickHandler = () => {
    if (document.fullscreenElement != null || document.webkitFullscreenElement != null || document.mozFullScreenElement != null) {
      console.log(
        "Video fullscreen is active. Will use default event handlers."
      );
      return;
    }
    togglePlay(!playing);
  };
  useVideoProgress({
    videoRef: videoElement,
    onProgress
  });
  (0, import_react47.useEffect)(() => {
    if (!videoElement.current)
      return;
    videoElement.current.onfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
    videoElement.current.onwebkitfullscreenchange = () => {
      setActiveDefaultFullScreen(document.webkitFullscreenElement !== null);
    };
    videoElement.current.onmozfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
  }, [activeDefaultFullScreen, videoElement.current, document]);
  (0, import_react47.useEffect)(() => {
    if (!loadOnIntersect || !(videoElement == null ? void 0 : videoElement.current) || !(containerElement == null ? void 0 : containerElement.current))
      return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          var _a, _b;
          if (entry.isIntersecting) {
            (_a = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _a.setAttribute("preload", "auto");
            (_b = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _b.load();
            if (videoElement == null ? void 0 : videoElement.current) {
              observer.unobserve(videoElement == null ? void 0 : videoElement.current);
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    );
    observer.observe(videoElement == null ? void 0 : videoElement.current);
  }, [videoElement == null ? void 0 : videoElement.current, loadOnIntersect]);
  const activeCustomFullScreen = !activeDefaultFullScreen && fullScreen;
  const imageProps = {
    src: videoThumbnail,
    width: 0,
    height: 0,
    alt: "Video Thumbnail",
    onClick: () => setThumbnailClicked(true),
    className: (0, import_classnames34.default)(
      videoThumbnailClassName,
      "v2-w-auto v2-h-auto v2-absolute v2-object-cover v2-top-0 v2-cursor-pointer",
      {
        "!v2-z-20": !thumbnailClicked,
        "!v2-z-0 !v2-hidden": thumbnailClicked
      }
    ),
    onLoad: onThumbnailLoad,
    onError: onThumbnailLoadError
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react47.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return videoThumbnail;
      }
    })
  ) : /* @__PURE__ */ import_react47.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react47.default.createElement(
    "div",
    {
      className: (0, import_classnames34.default)(
        containerClassName,
        "v2-group/video-player v2-overflow-hidden",
        {
          "v2-cursor-pointer v2-inline-flex v2-relative": !fullScreen,
          "v2-fixed v2-transform v2-left-1/2 v2-top-1/2 -v2-translate-x-1/2 ": fullScreen,
          "-v2-translate-y-1/2 v2-translate v2-z-40 v2-w-screen sm:v2-w-auto sm:v2-h-auto v2-flex v2-justify-center": fullScreen,
          "v2-rounded-[10px]": rounded,
          "v2-z-0": !fullScreen
        }
      ),
      ref: containerElement
    },
    /* @__PURE__ */ import_react47.default.createElement(
      "div",
      {
        key: videoUrl,
        className: (0, import_classnames34.default)("v2-flex v2-relative v2-w-full v2-group", {
          "v2-drop-shadow v2-shadow": activeCustomFullScreen
        })
      },
      /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-w-full", onClick: onVideoContainerClickHandler }, !hideLoader && /* @__PURE__ */ import_react47.default.createElement(
        "span",
        {
          className: (0, import_classnames34.default)(
            "v2-absolute v2-w-full v2-h-full v2-flex v2-flex-col v2-bg-neutral-400",
            {
              "v2-animate-fade-out": videoLoaded
            }
          )
        }
      ), forceShowThumbnail && videoThumbnail && imageComponent, /* @__PURE__ */ import_react47.default.createElement(
        "video",
        {
          id: "bonjoro-video-player",
          ref: videoElement,
          className: (0, import_classnames34.default)("bonjoro-video-player v2-cursor-pointer", {
            "v2-object-cover": !activeDefaultFullScreen,
            "v2-h-full v2-w-full": activeCustomFullScreen,
            [videoClassName != null ? videoClassName : ""]: !fullScreen,
            "!v2-z-0": forceShowThumbnail && !thumbnailClicked,
            "!v2-z-10": forceShowThumbnail && thumbnailClicked
          }),
          style: videoStyle,
          poster: videoThumbnail,
          title: videoTitle,
          controls: showDefaultControls,
          playsInline,
          "webkit-playsinline": playsInline && "webkit-playsinline",
          preload,
          autoPlay,
          muted,
          loop,
          onTouchEnd: (event) => {
            event.preventDefault();
            togglePlay(!playing);
          },
          onTouchMove: (event) => {
            event.preventDefault();
          },
          onPlay: () => {
            togglePlay(true);
            onPlay == null ? void 0 : onPlay();
          },
          onPause: () => {
            togglePlay(false);
            onPause == null ? void 0 : onPause();
          },
          onLoadedData: onVideoLoadedHandler,
          onVolumeChange: onVolumeChangeHandler,
          src: forceFirstFrame ? `${videoUrl}#t=0.001` : videoUrl
        },
        children
      )),
      !showDefaultControls && /* @__PURE__ */ import_react47.default.createElement(
        VideoControls,
        {
          fullScreen,
          playing,
          muted,
          hideClose,
          hideNewTab,
          hidePlayPause,
          hideMuteUnmute,
          hideFullScreen,
          hideTimer,
          hideTranscription,
          onPlayPauseClick: () => togglePlay(!playing),
          onMuteUnmuteClick: toggleMute,
          onFullScreenClick: toggleFullScreen,
          onNewTabClick,
          onCloseClick: onCloseClickHandler,
          ctaHoverColor,
          leftHeaderComponent,
          footerComponent,
          transcription,
          initialTranscriptionState,
          transcriptMode,
          transcriptionTogglerPosition,
          transcriptionMaxWordsPerSentence,
          transcriptionClassName,
          transcriptionContainerClassName,
          showControls: forceShowControls || videoLoaded,
          videoRef: videoElement,
          showProgressBar: videoLoaded && showProgressBar,
          fadeControlsOnPlay,
          closedCaptionClassName,
          playPauseStyle,
          playPauseClassName,
          playPausePlacement
        }
      )
    )
  );
}

// src/components/EmbedTile/EmbedTileMediaTile.tsx
var playIcon = "https://cdn.bonjoro.com/assets/Flat-icons/play.svg";
var PlayIconContainer = import_styled6.default.span`
  ${({ bgColor }) => {
  if (bgColor) {
    return `background-color:  ${bgColor} !important`;
  }
}}
`;
function EmbedTileMediaTile(_a) {
  var _b = _a, {
    type,
    url,
    thumbnailUrl,
    transcriptionClassName,
    onThumbnailLoad,
    onThumbnailLoadError,
    theme: theme2,
    playable = false,
    hidePlayIcon = false,
    preload = "auto",
    loadOnIntersect = false,
    onClick,
    className,
    imageComponent: DefaultImageComponent
  } = _b, props = __objRest(_b, [
    "type",
    "url",
    "thumbnailUrl",
    "transcriptionClassName",
    "onThumbnailLoad",
    "onThumbnailLoadError",
    "theme",
    "playable",
    "hidePlayIcon",
    "preload",
    "loadOnIntersect",
    "onClick",
    "className",
    "imageComponent"
  ]);
  const defaultClassName2 = (0, import_classnames35.default)(className, genericTileHoverEffectClassName, [
    "v2-object-cover v2-h-auto v2-w-full v2-cursor-pointer v2-drop-shadow"
  ]);
  const imageProps = {
    src: thumbnailUrl != null ? thumbnailUrl : url,
    alt: "Media Tile",
    width: 0,
    height: 0,
    className: defaultClassName2,
    onClick,
    onLoad: onThumbnailLoad,
    onError: onThumbnailLoadError
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react48.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return thumbnailUrl != null ? thumbnailUrl : url;
      }
    })
  ) : /* @__PURE__ */ import_react48.default.createElement("img", __spreadValues({}, imageProps));
  if (type === "video" /* Video */ && !playable) {
    return /* @__PURE__ */ import_react48.default.createElement("div", { className: "v2-relative v2-w-full v2-group" }, !hidePlayIcon && /* @__PURE__ */ import_react48.default.createElement(
      PlayIconContainer,
      {
        bgColor: theme2 == null ? void 0 : theme2.primaryColor,
        className: (0, import_classnames35.default)(genericTileHoverEffectClassName, [
          "v2-absolute v2-top-1/2 v2-left-1/2 v2-z-20 v2-flex v2-bg-neutral-900/50",
          "-v2-translate-x-1/2 -v2-translate-y-1/2 v2-rounded-full v2-p-3"
        ])
      },
      /* @__PURE__ */ import_react48.default.createElement(
        Image2,
        {
          imageUrl: playIcon,
          className: "v2-h-[30px] v2-w-[30px] v2-relative"
        }
      )
    ), thumbnailUrl ? imageComponent : /* @__PURE__ */ import_react48.default.createElement(
      "video",
      {
        src: `${url}#t=1.00`,
        className: (0, import_classnames35.default)(defaultClassName2, "v2-z-10"),
        muted: true,
        onClick
      }
    ));
  }
  if (type === "video" /* Video */ && playable) {
    return /* @__PURE__ */ import_react48.default.createElement(
      VideoPlayerComponent,
      __spreadProps(__spreadValues({}, props), {
        containerClassName: defaultClassName2,
        videoThumbnail: thumbnailUrl,
        onPlay: onClick,
        onPause: onClick,
        videoUrl: url,
        hidePlayPause: hidePlayIcon,
        hideFullScreen: true,
        hideMuteUnmute: true,
        hideClose: true,
        hideNewTab: true,
        hideLoader: true,
        fadeControlsOnPlay: true,
        forceShowControls: true,
        forceShowThumbnail: true,
        preload,
        loadOnIntersect,
        onThumbnailLoad,
        onThumbnailLoadError,
        videoClassName: "embed-tile-video-player v2-max-w-full v2-h-auto v2-block v2-align-middle",
        videoThumbnailClassName: "v2-max-w-full !v2-w-full v2-h-auto v2-block v2-align-middle",
        transcriptionClassName: (0, import_classnames35.default)(transcriptionClassName, "v2-text-sm"),
        imageComponent: DefaultImageComponent,
        playPauseStyle: { color: theme2 == null ? void 0 : theme2.primaryColor }
      })
    );
  }
  return imageComponent;
}

// src/components/EmbedTile/EmbedTileMediaContent.tsx
function EmbedTileAnchor(_a) {
  var _b = _a, {
    className,
    children
  } = _b, otherProps = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ import_react49.default.createElement(
    "a",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames36.default)(
        className,
        "v2-py-[1px] v2-px-5 v2-transition-all v2-h-full v2-w-full"
      )
    }),
    children
  );
}
function EmbedTileMediaContent({
  media,
  url,
  theme: theme2,
  playable,
  imageComponent
}) {
  const anchorProps = {
    target: "_blank",
    rel: "noopener noreferrer",
    href: url
  };
  if (!media || media.length == 0)
    return /* @__PURE__ */ import_react49.default.createElement(import_react49.default.Fragment, null);
  const defaultTileProps = { theme: theme2, playable, imageComponent };
  const groupOne = media.slice(0, media.length / 2);
  const groupTwo = media.slice(media.length / 2, media.length);
  const hasOneMedia = (media == null ? void 0 : media.length) == 1;
  const hasTwoMedia = (media == null ? void 0 : media.length) == 2;
  const hasThreeMedia = (media == null ? void 0 : media.length) == 3;
  const hasFourOrMoreMedia = (media == null ? void 0 : media.length) >= 4;
  return /* @__PURE__ */ import_react49.default.createElement(
    EmbedTileAnchor,
    __spreadProps(__spreadValues({}, anchorProps), {
      className: (0, import_classnames36.default)("v2-flex v2-gap-0.5 v2-px-5 v2-h-auto v2-w-full", {
        "v2-flex-row": hasThreeMedia || hasTwoMedia,
        "v2-flex-col": hasFourOrMoreMedia
      })
    }),
    (groupOne == null ? void 0 : groupOne.length) > 0 && /* @__PURE__ */ import_react49.default.createElement(
      "div",
      {
        className: (0, import_classnames36.default)("v2-flex v2-h-full v2-gap-0.5", {
          "v2-flex-row": hasFourOrMoreMedia,
          "!v2-w-full": hasOneMedia || hasFourOrMoreMedia,
          "v2-w-1/2": !hasOneMedia
        })
      },
      groupOne.slice(0, 2).map((item, index) => /* @__PURE__ */ import_react49.default.createElement(
        EmbedTileMediaTile,
        __spreadProps(__spreadValues(__spreadValues({
          key: index
        }, defaultTileProps), item), {
          className: (0, import_classnames36.default)(item == null ? void 0 : item.className, {
            "!v2-h-[100px] v2-w-1/2": (groupOne == null ? void 0 : groupOne.length) >= 2,
            "v2-rounded-tl": (groupOne == null ? void 0 : groupOne.length) >= 2 && index == 0,
            "v2-rounded-tr": (groupOne == null ? void 0 : groupOne.length) >= 2 && index == 1,
            "v2-h-[202px] v2-rounded-l": (groupOne == null ? void 0 : groupOne.length) == 1
          })
        })
      ))
    ),
    (groupTwo == null ? void 0 : groupTwo.length) > 0 && /* @__PURE__ */ import_react49.default.createElement(
      "div",
      {
        className: (0, import_classnames36.default)("v2-flex v2-h-full v2-gap-0.5", {
          "v2-flex-row": hasFourOrMoreMedia,
          "v2-flex-col": !hasFourOrMoreMedia,
          "!v2-w-full": hasOneMedia || hasFourOrMoreMedia,
          "v2-w-1/2": !hasOneMedia
        })
      },
      groupTwo.slice(0, 2).map((item, index) => /* @__PURE__ */ import_react49.default.createElement(
        EmbedTileMediaTile,
        __spreadProps(__spreadValues(__spreadValues({
          key: index
        }, defaultTileProps), item), {
          className: (0, import_classnames36.default)(item == null ? void 0 : item.className, {
            "!v2-h-[100px]": (groupTwo == null ? void 0 : groupTwo.length) >= 2,
            "!v2-w-1/2": (groupTwo == null ? void 0 : groupTwo.length) >= 2 && hasFourOrMoreMedia,
            "!v2-w-full": (groupTwo == null ? void 0 : groupTwo.length) == 1,
            "v2-rounded-bl": hasFourOrMoreMedia && (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 0,
            "v2-rounded-tr": !hasFourOrMoreMedia && (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 0,
            "v2-rounded-br": (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 1,
            "v2-h-[202px] v2-rounded-r": (groupOne == null ? void 0 : groupOne.length) >= 1 && (groupTwo == null ? void 0 : groupTwo.length) == 1,
            "v2-rounded": (groupOne == null ? void 0 : groupOne.length) == 0 && (groupTwo == null ? void 0 : groupTwo.length) == 1
          })
        })
      ))
    )
  );
}

// src/components/EmbedTile/EmbedTileLinkContent.tsx
var import_react50 = __toESM(require("react"));
var import_classnames37 = __toESM(require("classnames"));
function getProperLink(links) {
  const completeLinks = links.filter(
    (link) => link.url && link.imageUrl && link.title && link.description
  );
  if (completeLinks.length > 0)
    return completeLinks[0];
  return links[0];
}
function EmbedTileLinkContent({
  links,
  className,
  imageComponent: DefaultImageComponent
}) {
  if (!links || links && (links == null ? void 0 : links.length) === 0)
    return /* @__PURE__ */ import_react50.default.createElement(import_react50.default.Fragment, null);
  const { url, imageUrl, title, description } = getProperLink(links);
  const urlObject = new URL(url);
  const imageProps = {
    src: imageUrl,
    alt: "Link Content",
    width: 0,
    height: 0,
    className: "v2-w-full v2-h-[160px] v2-object-cover"
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react50.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return imageUrl;
      }
    })
  ) : /* @__PURE__ */ import_react50.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react50.default.createElement(
    "a",
    {
      className: (0, import_classnames37.default)(className, ["v2-py-[1px] v2-px-5 v2-flex v2-flex-col"]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    /* @__PURE__ */ import_react50.default.createElement(
      "div",
      {
        className: (0, import_classnames37.default)(
          genericTileHoverEffectClassName,
          "v2-drop-shadow v2-w-full v2-h-full"
        )
      },
      imageUrl && imageComponent,
      /* @__PURE__ */ import_react50.default.createElement("div", { className: "v2-p-2.5 v2-bg-neutral-50 v2-flex v2-flex-col v2-gap-[5px]" }, /* @__PURE__ */ import_react50.default.createElement("span", { className: "v2-text-neutral-500 v2-text-xs v2-truncate" }, urlObject.host.toUpperCase()), title && /* @__PURE__ */ import_react50.default.createElement("span", { className: "v2-text-neutral-900 v2-font-bold v2-text-xs v2-truncate" }, title), description && /* @__PURE__ */ import_react50.default.createElement(
        "span",
        {
          className: (0, import_classnames37.default)("v2-text-xs v2-truncate", {
            "v2-text-neutral-900 v2-font-bold": !title,
            "v2-text-neutral-500": title
          })
        },
        description
      ))
    )
  );
}

// src/components/EmbedTile/EmbedTile.tsx
var import_react_loading_skeleton3 = __toESM(require("react-loading-skeleton"));

// src/components/EmbedTile/EmbedTileErrorContent.tsx
var import_react51 = __toESM(require("react"));
var import_classnames38 = __toESM(require("classnames"));
function EmbedTileErrorContent({
  iconUrl,
  text,
  iconClassName,
  textClassName
}) {
  return /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-bg-neutral-50 v2-h-[120px] v2-mx-5 v2-flex v2-flex-col v2-items-center v2-justify-center v2-space-y-1" }, iconUrl && /* @__PURE__ */ import_react51.default.createElement(
    Image2,
    {
      imageUrl: iconUrl,
      className: (0, import_classnames38.default)("v2-w-12 v2-h-12 v2-bg-neutral-500", iconClassName),
      hideWhiteBackground: true
    }
  ), text && /* @__PURE__ */ import_react51.default.createElement("div", { className: (0, import_classnames38.default)("v2-text-neutral-500", textClassName) }, text));
}

// src/components/EmbedTile/EmbedTile.tsx
var EmbedTile = import_react52.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      type,
      profile,
      text,
      media,
      reactions,
      url,
      links,
      theme: theme2,
      datetime,
      className,
      hideIcon: defaultHideIcon = false,
      hideText = false,
      hideMedia = false,
      hideLink = false,
      hideDateTime = false,
      hideReaction = false,
      onLoad,
      onClick,
      queued = false,
      playable = false,
      content: customContent,
      cornerRadius = 6,
      hideShadow = false,
      showBorder = false,
      borderWidth,
      borderColor,
      fontFamily,
      imageComponent,
      style
    } = _b, otherProps = __objRest(_b, [
      "type",
      "profile",
      "text",
      "media",
      "reactions",
      "url",
      "links",
      "theme",
      "datetime",
      "className",
      "hideIcon",
      "hideText",
      "hideMedia",
      "hideLink",
      "hideDateTime",
      "hideReaction",
      "onLoad",
      "onClick",
      "queued",
      "playable",
      "content",
      "cornerRadius",
      "hideShadow",
      "showBorder",
      "borderWidth",
      "borderColor",
      "fontFamily",
      "imageComponent",
      "style"
    ]);
    var _a2;
    (0, import_react52.useEffect)(() => {
      onLoad == null ? void 0 : onLoad();
    }, []);
    const {
      formattedDateTime,
      profileTagClassName,
      reactionClassName,
      hideIconWithoutProfile
    } = (0, import_react52.useMemo)(() => {
      const defaultProps = {
        formattedDateTime: datetime == null ? void 0 : datetime.toFormat("dd/LL/y"),
        profileTagClassName: "v2-text-blue-400",
        reactionClassName: "group-hover:v2-opacity-50",
        hideIconWithoutProfile: false
      };
      if (isBonjoroResponseEmbed(type)) {
        return __spreadProps(__spreadValues({}, defaultProps), {
          profileTagClassName: "v2-text-neutral-500",
          hideIconWithoutProfile: true
        });
      }
      return defaultProps;
    }, [type]);
    const content = () => {
      return /* @__PURE__ */ import_react52.default.createElement(
        "div",
        {
          className: (0, import_classnames39.default)([
            "v2-min-h-[120px] v2-flex v2-flex-col v2-w-full h-full v2-overflow-y-auto",
            "v2-scrollbar-thin v2-scrollbar-thumb-neutral-300 v2-overflow-x-hidden",
            "v2-scrollbar-thumb-rounded-full v2-text-neutral-900 v2-text-base v2-gap-y-[15px] "
          ])
        },
        customContent,
        queued && /* @__PURE__ */ import_react52.default.createElement(
          EmbedTileErrorContent,
          {
            iconUrl: "https://cdn.bonjoro.com/assets/Flat-icons/pending.svg",
            text: "Queued"
          }
        ),
        !hideText && text && /* @__PURE__ */ import_react52.default.createElement(
          EmbedTileTextContent,
          {
            type,
            text,
            style: { fontFamily }
          }
        ),
        !hideMedia && media && /* @__PURE__ */ import_react52.default.createElement(
          EmbedTileMediaContent,
          {
            media,
            url,
            theme: theme2,
            playable,
            imageComponent
          }
        ),
        !hideLink && links && (!media || media.length == 0) && /* @__PURE__ */ import_react52.default.createElement(EmbedTileLinkContent, { links })
      );
    };
    const footer = () => {
      if (hideDateTime && hideReaction)
        return /* @__PURE__ */ import_react52.default.createElement(import_react52.default.Fragment, null);
      return /* @__PURE__ */ import_react52.default.createElement(
        "div",
        {
          className: (0, import_classnames39.default)([
            "v2-flex v2-flex-row v2-gap-x-[15px]",
            "v2-items-center v2-h-[15px] v2-px-5 v2-mt-[15px]"
          ])
        },
        !hideReaction && /* @__PURE__ */ import_react52.default.createElement(
          EmbedTileReactionPanel,
          {
            type,
            url,
            reactions,
            reactionClassName,
            loading: queued
          }
        ),
        queued && /* @__PURE__ */ import_react52.default.createElement(
          import_react_loading_skeleton3.default,
          {
            baseColor: colors.neutral[200],
            highlightColor: colors.neutral[100],
            height: "100%",
            containerClassName: "v2-h-4 v2-w-3/5 v2-flex"
          }
        ),
        !hideDateTime && !queued && /* @__PURE__ */ import_react52.default.createElement("span", { className: "v2-text-neutral-500 v2-text-xs" }, formattedDateTime)
      );
    };
    const hideIcon = defaultHideIcon || hideIconWithoutProfile && profile == void 0;
    return /* @__PURE__ */ import_react52.default.createElement(
      "div",
      __spreadProps(__spreadValues({
        ref
      }, otherProps), {
        className: (0, import_classnames39.default)(
          className,
          [
            "v2-w-full v2-h-fit v2-min-h-[245px] v2-relative v2-gap-y-[15px]",
            "v2-flex v2-flex-col v2-py-5 v2-bg-white v2-break-inside-avoid"
          ],
          {
            "v2-shadow": !hideShadow
          }
        ),
        style: __spreadValues(__spreadValues({
          borderRadius: `${cornerRadius}px`
        }, showBorder && {
          border: "solid",
          borderWidth: `${borderWidth != null ? borderWidth : 1}px`,
          borderColor: `${borderColor != null ? borderColor : colors.neutral[500]}`
        }), style),
        onClick
      }),
      (!hideIcon || profile != void 0) && /* @__PURE__ */ import_react52.default.createElement("div", { className: "v2-flex v2-flex-row v2-h-10 v2-px-5 v2-gap-x-2 v2-justify-between" }, profile && /* @__PURE__ */ import_react52.default.createElement(
        EmbedTileProfilePanel,
        __spreadProps(__spreadValues({}, profile), {
          url: (_a2 = profile == null ? void 0 : profile.url) != null ? _a2 : url,
          tagClassName: profileTagClassName,
          hideProfileImage: otherProps == null ? void 0 : otherProps.hideProfileImage,
          hideProfileName: otherProps == null ? void 0 : otherProps.hideProfileName,
          hideProfileTag: otherProps == null ? void 0 : otherProps.hideProfileTag,
          imageComponent,
          loading: queued
        })
      ), !hideIcon && /* @__PURE__ */ import_react52.default.createElement(
        EmbedTileIconImage,
        {
          type,
          className: "v2-h-5 v2-w-5",
          width: 20,
          height: 20,
          imageComponent,
          theme: theme2
        }
      )),
      /* @__PURE__ */ import_react52.default.createElement(
        "div",
        {
          className: (0, import_classnames39.default)([
            "v2-flex v2-flex-col v2-h-full v2-w-full",
            "v2-min-h-[150px] v2-justify-between"
          ])
        },
        content(),
        footer()
      )
    );
  }
);

// src/components/EmbedTile/util.tsx
var import_react53 = __toESM(require("react"));
var defaultTwitterUrl = "https://x.com";
var mapTwitterProps = ({
  url,
  content,
  datetime
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    type: "twitter" /* Twitter */,
    profile: {
      name: (_a = content == null ? void 0 : content.profile) == null ? void 0 : _a.name,
      url: ((_b = content == null ? void 0 : content.profile) == null ? void 0 : _b.tag) ? `${defaultTwitterUrl}/${(_c = content == null ? void 0 : content.profile) == null ? void 0 : _c.tag}` : url,
      imageUrl: (_d = content == null ? void 0 : content.profile) == null ? void 0 : _d.img_url,
      tag: (_e = content == null ? void 0 : content.profile) == null ? void 0 : _e.tag
    },
    url,
    text: content == null ? void 0 : content.text,
    media: (_f = content == null ? void 0 : content.media) == null ? void 0 : _f.map((item) => {
      return {
        type: item == null ? void 0 : item.type,
        url: item == null ? void 0 : item.url,
        thumbnailUrl: item == null ? void 0 : item.preview_url
      };
    }),
    reactions: content == null ? void 0 : content.reactions,
    links: (_g = content == null ? void 0 : content.links) == null ? void 0 : _g.map((item) => {
      return {
        url: item == null ? void 0 : item.url,
        imageUrl: item == null ? void 0 : item.img_url,
        title: item == null ? void 0 : item.title,
        description: item == null ? void 0 : item.description
      };
    }),
    queued: content === null,
    content: ((_h = content == null ? void 0 : content.error) == null ? void 0 : _h.title) ? /* @__PURE__ */ import_react53.default.createElement(
      EmbedTileErrorContent,
      {
        iconUrl: " https://cdn.bonjoro.com/assets/Flat-icons/error.svg",
        text: content.error.title
      }
    ) : void 0,
    datetime
  };
};

// src/components/EmbedTile/index.ts
var embedTileDetails = {
  ["twitter" /* Twitter */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/twitter-x-black.svg",
      iconType: "image"
    },
    reactions: {
      ["like" /* Like */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/twitter-reaction-heart.svg",
        iconType: "masked_image",
        iconClassName: "v2-bg-magenta-300"
      }
    }
  },
  ["linkedin" /* LinkedIn */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/linkedin.svg",
      iconType: "image"
    },
    reactions: {
      ["like" /* Like */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-like.svg",
        iconType: "image"
      },
      ["celebrate" /* Celebrate */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-celebrate.svg",
        iconType: "image"
      },
      ["support" /* Support */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-support.svg",
        iconType: "image"
      },
      ["love" /* Love */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-love.svg",
        iconType: "image"
      },
      ["insightful" /* Insightful */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-insightful.svg",
        iconType: "image"
      },
      ["funny" /* Funny */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-funny.svg",
        iconType: "image"
      }
    }
  },
  ["bonjoro_response" /* BonjoroResponse */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/quote.svg",
      iconType: "masked_image",
      iconClassName: "v2-bg-neutral-500"
    }
  }
};
var genericTileHoverEffectClassName = "hover:v2-scale-[0.99] hover:v2-shadow group-hover:v2-scale-[0.99] group-hover:v2-shadow v2-transition-all v2-ease-in";
function isTwitterEmbed(type) {
  return type === "twitter" /* Twitter */;
}
function isLinkedinEmbed(type) {
  return type === "linkedin" /* LinkedIn */;
}
function isBonjoroResponseEmbed(type) {
  return type === "bonjoro_response" /* BonjoroResponse */;
}

// src/components/Youtube/Embed.tsx
var import_react55 = __toESM(require("react"));
var import_styled7 = __toESM(require("@emotion/styled"));
var import_classnames40 = __toESM(require("classnames"));

// src/components/Youtube/util.ts
function getIdFromYoutubeUrl(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : null;
}
function isValidYoutubeUrl(url) {
  const regExp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))/;
  const youtubeId = getIdFromYoutubeUrl(url);
  return regExp.test(url) && !!youtubeId;
}

// src/components/EmbedErrorState/EmbedErrorState.tsx
var import_react54 = __toESM(require("react"));
var import_react_fontawesome4 = require("@fortawesome/react-fontawesome");
var EmbedErrorState = ({
  text,
  className = ""
}) => {
  return /* @__PURE__ */ import_react54.default.createElement(
    "div",
    {
      className: `
        v2-w-64 v2-h-40 v2-bg-neutral-100 v2-text-neutral-500 v2-rounded-md
        v2-border v2-border-solid v2-border-neutral-300 v2-flex v2-flex-col
        v2-justify-center v2-text-center v2-text-base v2-items-center
        ${className}`
    },
    /* @__PURE__ */ import_react54.default.createElement(import_react_fontawesome4.FontAwesomeIcon, { className: "v2-h-7", icon: faImageSlash }),
    /* @__PURE__ */ import_react54.default.createElement("div", { className: "v2-m-3.5" }, text)
  );
};

// src/components/Youtube/Embed.tsx
var PlayButton = import_styled7.default.img`
  transform: translate3d(-50%, -50%, 0);
  filter: grayscale(100%);

  &:hover {
    filter: none;
  }
`;
var Container3 = import_styled7.default.div`
  &:hover img {
    filter: none;
  }
`;
var Embed = import_react55.default.forwardRef(
  ({
    containerRef: defaultContainerRef,
    youtubeUrl,
    showControls = false,
    hideErrorState = false,
    className = "",
    errorStateClassName = "",
    onLoad,
    onLoadError,
    cornerRadius = 6,
    hideShadow = false,
    showBorder = false,
    borderWidth,
    borderColor,
    style
  }, ref) => {
    const containerRef = defaultContainerRef != null ? defaultContainerRef : (0, import_react55.useRef)(null);
    const youtubeId = (0, import_react55.useMemo)(
      () => getIdFromYoutubeUrl(youtubeUrl),
      [youtubeUrl]
    );
    const [showIframe, setShowIframe] = (0, import_react55.useState)(false);
    const [preConnection, setPreConnection] = (0, import_react55.useState)(false);
    const isValidYoutube = (0, import_react55.useMemo)(
      () => isValidYoutubeUrl(youtubeUrl),
      [youtubeUrl]
    );
    (0, import_react55.useEffect)(() => {
      if (!isValidYoutube || !youtubeId) {
        onLoadError == null ? void 0 : onLoadError();
      }
    }, [isValidYoutube, youtubeUrl]);
    if ((!isValidYoutube || !youtubeId) && hideErrorState) {
      return null;
    }
    if (!isValidYoutube) {
      return /* @__PURE__ */ import_react55.default.createElement(
        EmbedErrorState,
        {
          className: errorStateClassName,
          text: "The URL you've provided is not a valid Youtube URL."
        }
      );
    }
    const posterUrl = `https://i3.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;
    const youtubeEmbedUrl = `https://www.youtube.com/embed/${youtubeId}?rel=0&controls=${Number(
      showControls
    )}&autoplay=1`;
    return /* @__PURE__ */ import_react55.default.createElement(
      Container3,
      {
        ref,
        className: (0, import_classnames40.default)(className, "v2-w-96 v2-h-56 v2-overflow-hidden ", {
          "v2-shadow": !hideShadow
        }),
        onClick: () => setShowIframe(true),
        onPointerOver: () => setPreConnection(true),
        style: __spreadValues(__spreadValues({
          borderRadius: `${cornerRadius}px`
        }, showBorder && {
          border: "solid",
          borderWidth: `${borderWidth != null ? borderWidth : 1}px`,
          borderColor: `${borderColor != null ? borderColor : colors.neutral[500]}`
        }), style)
      },
      /* @__PURE__ */ import_react55.default.createElement("link", { rel: "preload", href: posterUrl, as: "image" }),
      /* @__PURE__ */ import_react55.default.createElement(import_react55.default.Fragment, null, preConnection && /* @__PURE__ */ import_react55.default.createElement(import_react55.default.Fragment, null, /* @__PURE__ */ import_react55.default.createElement("link", { rel: "preconnect", href: "https://www.youtube.com" }), /* @__PURE__ */ import_react55.default.createElement("link", { rel: "preconnect", href: "https://www.google.com" }))),
      !showIframe ? /* @__PURE__ */ import_react55.default.createElement("div", { className: "v2-h-full v2-w-full v2-relative v2-cursor-pointer" }, /* @__PURE__ */ import_react55.default.createElement(
        "img",
        {
          className: "v2-h-full v2-w-full v2-object-cover",
          onLoad,
          src: posterUrl
        }
      ), /* @__PURE__ */ import_react55.default.createElement(
        PlayButton,
        {
          className: "v2-h-12 v2-w-[68px] v2-absolute v2-left-2/4 v2-top-2/4",
          src: "https://cdn.bonjoro.com/assets/bonjoro-ui-components/youtube-play.svg"
        }
      )) : /* @__PURE__ */ import_react55.default.createElement(
        "iframe",
        {
          ref: containerRef,
          allowFullScreen: true,
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          src: youtubeEmbedUrl,
          className: "v2-aspect-video v2-w-full v2-h-full v2-border-0",
          onLoad
        }
      )
    );
  }
);

// src/hook/use-date-hook.ts
var import_react56 = require("react");
var import_luxon3 = require("luxon");

// src/utils/date.ts
var import_luxon2 = require("luxon");
function parseUtcDate(input, options2) {
  var _a;
  const dtOptions = {
    zone: "utc"
  };
  if (typeof input === "string") {
    const sqlDate = import_luxon2.DateTime.fromSQL(input, dtOptions);
    if (sqlDate.invalidReason) {
      return import_luxon2.DateTime.fromISO(input, dtOptions);
    } else {
      return sqlDate;
    }
  }
  if (typeof input === "number") {
    switch ((_a = options2 == null ? void 0 : options2.parseNumberAs) != null ? _a : "seconds") {
      case "millis":
        return import_luxon2.DateTime.fromMillis(input, dtOptions);
      case "seconds":
      default:
        return import_luxon2.DateTime.fromSeconds(input, dtOptions);
    }
  }
  if (input instanceof Date) {
    return import_luxon2.DateTime.fromJSDate(input, dtOptions);
  }
}
function utcToLocalDate(utcDate, timeZone) {
  if (timeZone) {
    return utcDate.setZone(timeZone);
  }
  return utcDate.toLocal();
}

// src/hook/use-date-hook.ts
function useDate(input, options2) {
  const utc = (0, import_react56.useMemo)(() => {
    if (import_luxon3.DateTime.isDateTime(input)) {
      return input.toUTC();
    }
    return parseUtcDate(input, { parseNumberAs: options2 == null ? void 0 : options2.parseNumberAs });
  }, [input]);
  return (0, import_react56.useMemo)(() => {
    var _a;
    const local = utc && utcToLocalDate(utc, options2 == null ? void 0 : options2.timezone);
    const relative = local == null ? void 0 : local.toRelative({
      style: (_a = options2 == null ? void 0 : options2.relativeStyle) != null ? _a : "short"
    });
    return {
      original: input,
      utc,
      local,
      relative: relative != null ? relative : void 0
    };
  }, [options2 == null ? void 0 : options2.timezone, input, utc]);
}

// src/components/PublishableEmbed/Components/Tile.tsx
var PreloadType = /* @__PURE__ */ ((PreloadType2) => {
  PreloadType2["None"] = "none";
  PreloadType2["Auto"] = "auto";
  PreloadType2["OnIntersect"] = "on_intersect";
  return PreloadType2;
})(PreloadType || {});
var TileChild = import_react57.default.forwardRef(
  ({
    className,
    asset,
    controls,
    style,
    timezone,
    imageComponent,
    cssProperties,
    preload = "on_intersect" /* OnIntersect */,
    showTextAsPlainText = false
  }, ref) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const tileType = asset.type;
    const thumb = (_a = asset.thumb_full_url) != null ? _a : asset.thumb_url;
    const { utc } = useDate((_b = asset == null ? void 0 : asset.content) == null ? void 0 : _b.datetime, { timezone });
    const createdAt = useDate(asset == null ? void 0 : asset.created_at, { timezone });
    const text = getRichTextFromSlateData((_c = asset == null ? void 0 : asset.text_response_rich) != null ? _c : []);
    switch (tileType) {
      case TileType.Video:
      case TileType.Text:
      case void 0:
      case null:
        return /* @__PURE__ */ import_react57.default.createElement(
          EmbedTile,
          __spreadProps(__spreadValues(__spreadValues({
            ref
          }, parseStyleToEmbedTileProps(style)), parseControlsToEmbedTileProps(controls)), {
            type: "bonjoro_response" /* BonjoroResponse */,
            profile: ((_d = asset == null ? void 0 : asset.owner) == null ? void 0 : _d.name) ? {
              name: (_e = asset == null ? void 0 : asset.owner) == null ? void 0 : _e.name,
              imageUrl: (_f = asset == null ? void 0 : asset.owner) == null ? void 0 : _f.image,
              tag: (_g = asset == null ? void 0 : asset.owner) == null ? void 0 : _g.position
            } : void 0,
            className: (0, import_classnames41.default)(className, "!v2-min-h-[195px]"),
            datetime: createdAt == null ? void 0 : createdAt.local,
            media: (asset == null ? void 0 : asset.video_url) ? [
              {
                type: "video" /* Video */,
                url: (_h = asset == null ? void 0 : asset.video_url) != null ? _h : "",
                thumbnailUrl: thumb,
                transcription: (controls == null ? void 0 : controls.hideTranscription) ? void 0 : (_j = (_i = asset == null ? void 0 : asset.transcript) == null ? void 0 : _i.captions) == null ? void 0 : _j.sentences,
                transcriptionClassName: "!v2-text-xs",
                preload: preload === "auto" /* Auto */ ? "auto" : "none",
                loadOnIntersect: preload === "on_intersect" /* OnIntersect */
              }
            ] : void 0,
            text: parseRichTextToString(text) != "" ? showTextAsPlainText ? parseRichTextToString(text) : text : void 0,
            theme: {
              primaryColor: style == null ? void 0 : style.primaryColor
            },
            playable: true,
            imageComponent,
            style: cssProperties
          })
        );
      case TileType.Youtube:
        return /* @__PURE__ */ import_react57.default.createElement(
          Embed,
          __spreadProps(__spreadValues({
            ref
          }, parseStyleToEmbedTileProps(style)), {
            className: (0, import_classnames41.default)("!v2-w-full v2-border-none", className),
            youtubeUrl: asset.url,
            style: cssProperties,
            hideErrorState: true
          })
        );
      case TileType.Twitter:
        return /* @__PURE__ */ import_react57.default.createElement(
          EmbedTile,
          __spreadProps(__spreadValues(__spreadValues(__spreadValues({
            ref
          }, parseStyleToEmbedTileProps(style)), mapTwitterProps({
            url: asset.url,
            content: asset.content,
            datetime: utc
          })), parseControlsToEmbedTileProps(controls)), {
            className: (0, import_classnames41.default)("!v2-w-full", className),
            imageComponent,
            style: cssProperties
          })
        );
      default:
        return null;
    }
  }
);
var Tile = import_react57.default.forwardRef(
  ({
    className,
    containerClassName,
    detail,
    showHoverAnimation,
    controls,
    style,
    timezone,
    imageComponent,
    cssProperties,
    preload,
    showTextAsPlainText
  }, ref) => {
    return /* @__PURE__ */ import_react57.default.createElement(
      "div",
      {
        className: (0, import_classnames41.default)("v2-break-inside-avoid v2-max-w-sm", containerClassName, {
          "v2-transition v2-ease-in-out hover:v2-scale-[1.02]": showHoverAnimation
        })
      },
      /* @__PURE__ */ import_react57.default.createElement(
        TileChild,
        {
          ref,
          className,
          asset: detail,
          controls,
          style,
          timezone,
          imageComponent,
          cssProperties,
          preload,
          showTextAsPlainText
        }
      )
    );
  }
);
function parseControlsToEmbedTileProps(props) {
  var _a, _b, _c, _d;
  return {
    hideProfileImage: (_a = props == null ? void 0 : props.hideProfileImage) != null ? _a : false,
    hideProfileName: (_b = props == null ? void 0 : props.hideName) != null ? _b : false,
    hideProfileTag: (_c = props == null ? void 0 : props.hideTitle) != null ? _c : false,
    hideDateTime: (_d = props == null ? void 0 : props.hideDate) != null ? _d : false
  };
}
function parseStyleToEmbedTileProps(props) {
  var _a, _b, _c, _d, _e;
  return {
    cornerRadius: (_a = props == null ? void 0 : props.cornerRadius) != null ? _a : 5,
    hideShadow: (props == null ? void 0 : props.dropShadow) != void 0 ? !(props == null ? void 0 : props.dropShadow) : false,
    showBorder: (_b = props == null ? void 0 : props.border) != null ? _b : false,
    borderWidth: (_c = props == null ? void 0 : props.borderSize) != null ? _c : 1,
    borderColor: (_d = props == null ? void 0 : props.borderColor) != null ? _d : colors.neutral[500],
    fontFamily: (_e = props == null ? void 0 : props.fontFamily) != null ? _e : DEFAULT_FONT_FAMILY
  };
}

// src/utils/assetUrl.ts
function assetUrl(path) {
  return `https://cdn.bonjoro.com/assets/bonjoro-ui-components/${path}`;
}

// src/components/GridLayout/GridLayout.tsx
var import_react62 = __toESM(require("react"));
var import_classnames42 = __toESM(require("classnames"));
var import_styled8 = __toESM(require("@emotion/styled"));

// node_modules/react-use/esm/misc/util.js
function on(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.addEventListener) {
    obj.addEventListener.apply(obj, args);
  }
}
function off(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.removeEventListener) {
    obj.removeEventListener.apply(obj, args);
  }
}
var isBrowser = typeof window !== "undefined";

// node_modules/react-use/esm/useEffectOnce.js
var import_react58 = require("react");
var useEffectOnce = function(effect) {
  (0, import_react58.useEffect)(effect, []);
};
var useEffectOnce_default = useEffectOnce;

// node_modules/react-use/esm/useRafState.js
var import_react60 = require("react");

// node_modules/react-use/esm/useUnmount.js
var import_react59 = require("react");
var useUnmount = function(fn) {
  var fnRef = (0, import_react59.useRef)(fn);
  fnRef.current = fn;
  useEffectOnce_default(function() {
    return function() {
      return fnRef.current();
    };
  });
};
var useUnmount_default = useUnmount;

// node_modules/react-use/esm/useRafState.js
var useRafState = function(initialState) {
  var frame = (0, import_react60.useRef)(0);
  var _a = (0, import_react60.useState)(initialState), state = _a[0], setState = _a[1];
  var setRafState = (0, import_react60.useCallback)(function(value) {
    cancelAnimationFrame(frame.current);
    frame.current = requestAnimationFrame(function() {
      setState(value);
    });
  }, []);
  useUnmount_default(function() {
    cancelAnimationFrame(frame.current);
  });
  return [state, setRafState];
};
var useRafState_default = useRafState;

// node_modules/react-use/esm/useWindowSize.js
var import_react61 = require("react");
var useWindowSize = function(initialWidth, initialHeight) {
  if (initialWidth === void 0) {
    initialWidth = Infinity;
  }
  if (initialHeight === void 0) {
    initialHeight = Infinity;
  }
  var _a = useRafState_default({
    width: isBrowser ? window.innerWidth : initialWidth,
    height: isBrowser ? window.innerHeight : initialHeight
  }), state = _a[0], setState = _a[1];
  (0, import_react61.useEffect)(function() {
    if (isBrowser) {
      var handler_1 = function() {
        setState({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      on(window, "resize", handler_1);
      return function() {
        off(window, "resize", handler_1);
      };
    }
  }, []);
  return state;
};
var useWindowSize_default = useWindowSize;

// src/components/GridLayout/GridLayout.tsx
var Container4 = import_styled8.default.div`
  @media (max-width: 400px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;
function GridLayout({
  containerRef,
  className,
  children
}) {
  const { width } = useWindowSize_default();
  const gridRef = containerRef != null ? containerRef : (0, import_react62.useRef)(null);
  function resizeGridItem(item, rowHeight, rowGap) {
    if (!item.firstChild) {
      item.style.display = "none";
      return;
    }
    const rowSpan = Math.ceil(
      (item.firstChild.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap)
    );
    item.style.gridRowEnd = `span ${rowSpan}`;
  }
  function resizeAllGridItems() {
    var _a;
    const tiles = (_a = gridRef.current) == null ? void 0 : _a.children;
    if (!tiles)
      return;
    const gridStyles = window.getComputedStyle(gridRef.current);
    const rowHeight = parseInt(gridStyles.gridAutoRows);
    const rowGap = parseInt(gridStyles.rowGap);
    for (const tile of Array.from(tiles)) {
      resizeGridItem(tile, rowHeight, rowGap);
    }
  }
  const tileResizeObserver = (0, import_react62.useRef)(
    new ResizeObserver((entries) => {
      entries.forEach(() => {
        resizeAllGridItems();
      });
    })
  );
  (0, import_react62.useLayoutEffect)(() => {
    resizeAllGridItems();
  }, [width, children]);
  (0, import_react62.useEffect)(() => {
    var _a;
    const tiles = (_a = gridRef.current) == null ? void 0 : _a.children;
    if (!tiles || !tileResizeObserver)
      return;
    for (const tile of Array.from(tiles)) {
      if (tile && tile.children[0]) {
        tileResizeObserver.current.observe(tile.children[0]);
      }
    }
    return () => {
      if (tileResizeObserver) {
        for (const tile of Array.from(tiles)) {
          if (tile && tile.children[0]) {
            tileResizeObserver.current.unobserve(tile.children[0]);
          }
        }
        tileResizeObserver.current.disconnect();
      }
    };
  }, [children, tileResizeObserver]);
  return /* @__PURE__ */ import_react62.default.createElement(
    Container4,
    {
      id: "bonjoro-grid-layout",
      ref: gridRef,
      className: (0, import_classnames42.default)("grid-layout", className, [
        "v2-grid v2-gap-2.5 v2-grid-cols-[repeat(auto-fill,_minmax(350px,1fr))]",
        "v2-auto-rows-[10px] v2-transition v2-transition-all v2-ease-in"
      ])
    },
    children
  );
}

// src/components/GridLayout/GridLayoutTile.tsx
var import_react63 = __toESM(require("react"));
var import_classnames43 = __toESM(require("classnames"));

// src/utils/color.ts
var import_memoize = __toESM(require_memoize());
var defaultColor = {
  BLACK: "#000000",
  WHITE: "#FFFFFF"
};
var cutHex = (0, import_memoize.default)((h) => {
  return h.charAt(0) == "#" ? h.substring(1, 7) : h;
});
var hexToR = (0, import_memoize.default)((h) => {
  return parseInt(cutHex(h).substring(0, 2), 16);
});
var hexToG = (0, import_memoize.default)((h) => {
  return parseInt(cutHex(h).substring(2, 4), 16);
});
var hexToB = (0, import_memoize.default)((h) => {
  return parseInt(cutHex(h).substring(4, 6), 16);
});
var computeTextColor = (0, import_memoize.default)((color) => {
  const r = hexToR(color);
  const g = hexToG(color);
  const b = hexToB(color);
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? defaultColor.BLACK : defaultColor.WHITE;
});

// src/components/PublishableEmbed/WallOfLove.tsx
var import_beautiful_react_hooks = __toESM(require_cjs());
var DEFAULT_PAGE_LIMIT = 50;
var DEFAULT_MOBILE_PAGE_LIMIT = 3;
var TILE_WIDTH_PER_COLUMN = 350;
var TILE_GAPS = 15;
var computeWallOfLoveColumnTilesEventName = "compute-wall-of-love-column-tiles";
var computeWallOfLoveColumnTiles = () => window.dispatchEvent(new CustomEvent(computeWallOfLoveColumnTilesEventName));
function WallOfLove(_a) {
  var _b = _a, {
    data = [],
    containerClassName,
    innerElementClassName,
    containerStyle,
    onBonjoroBadgeClick,
    imageComponent,
    isResizerReady = false
  } = _b, props = __objRest(_b, [
    "data",
    "containerClassName",
    "innerElementClassName",
    "containerStyle",
    "onBonjoroBadgeClick",
    "imageComponent",
    "isResizerReady"
  ]);
  const [columnTiles, setColumnTiles] = (0, import_react64.useState)(0);
  const containerRef = (0, import_react64.useRef)(null);
  const gridLayoutRef = (0, import_react64.useRef)();
  const {
    enableMaxHeight,
    maxHeight = 0,
    primaryColor,
    allowDynamicTiles,
    allowMobileTileRestriction
  } = props;
  const computeColumnTiles = () => {
    var _a2, _b2, _c;
    if (!(gridLayoutRef == null ? void 0 : gridLayoutRef.current))
      return;
    const width = (_c = (_b2 = (_a2 = gridLayoutRef == null ? void 0 : gridLayoutRef.current) == null ? void 0 : _a2.getBoundingClientRect()) == null ? void 0 : _b2.width) != null ? _c : 0;
    const columns = Math.floor(width / TILE_WIDTH_PER_COLUMN);
    if (width < columns * TILE_WIDTH_PER_COLUMN + (columns - 1) * TILE_GAPS) {
      setColumnTiles(columns - 1);
      return;
    }
    setColumnTiles(columns != 0 ? columns : 1);
    return;
  };
  const gridResizeObserver = (0, import_react64.useRef)(
    new ResizeObserver(() => computeColumnTiles())
  );
  const onComputeWallOfLoveColumnTiles = (0, import_beautiful_react_hooks.useGlobalEvent)(
    computeWallOfLoveColumnTilesEventName
  );
  onComputeWallOfLoveColumnTiles(() => computeColumnTiles());
  (0, import_react64.useEffect)(() => {
    if (!gridLayoutRef.current || !gridResizeObserver.current)
      return;
    gridResizeObserver.current.observe(gridLayoutRef.current);
  }, [gridLayoutRef.current, gridResizeObserver]);
  const isLoadedInsideIFrame = (0, import_react64.useMemo)(() => window.self !== window.top, []);
  const [page, setPage] = (0, import_react64.useState)(1);
  const publishables = (0, import_react64.useMemo)(() => {
    if (allowMobileTileRestriction && columnTiles === 1) {
      return data == null ? void 0 : data.slice(0, DEFAULT_MOBILE_PAGE_LIMIT * page);
    }
    return data == null ? void 0 : data.slice(0, DEFAULT_PAGE_LIMIT * page);
  }, [data, page, columnTiles, allowMobileTileRestriction]);
  const hasMore = (0, import_react64.useMemo)(() => {
    return (data == null ? void 0 : data.length) > (publishables == null ? void 0 : publishables.length);
  }, [publishables, data, columnTiles]);
  const tileStyle = (0, import_react64.useMemo)(() => {
    if (!enableMaxHeight)
      return {};
    if (allowDynamicTiles) {
      return {
        overflowY: "hidden",
        maxHeight: `${maxHeight}px`
      };
    }
    return {
      height: `${maxHeight}px`
    };
  }, [maxHeight, allowDynamicTiles, enableMaxHeight]);
  return /* @__PURE__ */ import_react64.default.createElement(import_react64.default.Fragment, null, /* @__PURE__ */ import_react64.default.createElement(
    "div",
    {
      ref: containerRef,
      className: (0, import_classnames44.default)(
        "v2-w-full v2-mx-auto lg:v2-max-w-none v2-min-w-[300px] v2-animate-fade-in-down",
        containerClassName,
        {
          "h-screen": !isLoadedInsideIFrame,
          "overflow-y-auto": !props.disableScroll,
          hidden: isLoadedInsideIFrame && !isResizerReady || !(containerRef == null ? void 0 : containerRef.current)
        }
      ),
      style: containerStyle
    },
    /* @__PURE__ */ import_react64.default.createElement(
      "div",
      {
        className: (0, import_classnames44.default)("v2-flex v2-flex-col", {
          hidden: !(containerRef == null ? void 0 : containerRef.current)
        })
      },
      /* @__PURE__ */ import_react64.default.createElement("div", { className: "v2-p-4 v2-pt-10 v2-pb-4 v2-w-full v2-mx-auto v2-overflow-y-none" }, /* @__PURE__ */ import_react64.default.createElement(
        GridLayout,
        {
          containerRef: gridLayoutRef,
          className: (0, import_classnames44.default)(
            innerElementClassName,
            "v2-mx-0 v2-my-auto v2-gap-[15px] v2-justify-center",
            "min-[400px]:!v2-grid-cols-[repeat(auto-fill,350px)]",
            "!v2-grid-cols-[repeat(auto-fit, minmax(200px, 1fr))]"
          )
        },
        publishables && publishables.map((detail) => /* @__PURE__ */ import_react64.default.createElement(
          Tile,
          {
            key: detail.uuid,
            detail,
            className: (0, import_classnames44.default)(
              [
                "v2-scrollbar-thin v2-scrollbar-track-neutral-200",
                "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full"
              ],
              {
                "v2-animate-fade-in-150": isLoadedInsideIFrame && !isResizerReady || !(containerRef == null ? void 0 : containerRef.current)
              }
            ),
            controls: props,
            style: props,
            timezone: props.timezone,
            preload: props.preload,
            showTextAsPlainText: props.showTextAsPlainText,
            imageComponent,
            cssProperties: tileStyle
          }
        ))
      )),
      hasMore && /* @__PURE__ */ import_react64.default.createElement(
        Button,
        {
          className: (0, import_classnames44.default)([
            "v2-cursor-pointer v2-text-base v2-font-bold v2-text-center v2-self-center",
            "v2-w-[350px] v2-mb-5 v2-border-0 hover:v2-scale-[1.02] v2-transition-all"
          ]),
          onClick: () => setPage(page + 1),
          style: {
            backgroundColor: primaryColor,
            color: computeTextColor(primaryColor)
          }
        },
        "Load more"
      ),
      !(props == null ? void 0 : props.hideBonjoroBadge) && /* @__PURE__ */ import_react64.default.createElement(
        "div",
        {
          className: "v2-flex v2-justify-center v2-cursor-pointer",
          onClick: onBonjoroBadgeClick
        },
        /* @__PURE__ */ import_react64.default.createElement(
          "img",
          {
            className: "v2-h-12 v2-mb-10",
            src: assetUrl("powered-by-bj.svg")
          }
        )
      )
    )
  ));
}

// src/components/PublishableEmbed/Slider.tsx
var import_react73 = __toESM(require("react"));
var import_classnames51 = __toESM(require("classnames"));
var import_use_measure = __toESM(require_use_measure());

// src/components/Carousel/Carousel.tsx
var import_react69 = __toESM(require("react"));
var import_classnames49 = __toESM(require("classnames"));

// src/components/Carousel/CarouselGroupedNavigator.tsx
var import_react67 = __toESM(require("react"));
var import_classnames47 = __toESM(require("classnames"));

// src/components/Carousel/CarouselNavigatorContainer.tsx
var import_react65 = __toESM(require("react"));
var import_classnames45 = __toESM(require("classnames"));
function CarouselNavigatorContainer({
  className,
  children,
  onClick,
  disabled = false
}) {
  return /* @__PURE__ */ import_react65.default.createElement(
    "span",
    {
      className: (0, import_classnames45.default)("carousel-navigator-container", className, [
        "v2-absolute v2-text-black v2-cursor-pointer",
        "-v2-translate-y-1/2 v2-flex v2-top-1/2 v2-items-center"
      ]),
      onClick: disabled ? void 0 : onClick
    },
    children
  );
}

// src/components/Carousel/CarouselNavigatorIcon.tsx
var import_react66 = __toESM(require("react"));
var import_classnames46 = __toESM(require("classnames"));
var import_react_fontawesome5 = require("@fortawesome/react-fontawesome");
var import_styled9 = __toESM(require("@emotion/styled"));
var NavigatorIcon = (0, import_styled9.default)(import_react_fontawesome5.FontAwesomeIcon)`
  ${({
  chevronColor = colors.neutral[900],
  chevronHoverColor = colors.neutral[900]
}) => `
    color: ${chevronColor};

    &:hover {
      color: ${chevronHoverColor};
    }
   
  `}
`;
function CarouselNavigatorIcon({
  disabled = false,
  icon,
  className,
  onClick,
  chevronColor,
  chevronHoverColor
}) {
  if (!icon)
    return /* @__PURE__ */ import_react66.default.createElement(import_react66.default.Fragment, null);
  return /* @__PURE__ */ import_react66.default.createElement(
    NavigatorIcon,
    {
      icon,
      className: (0, import_classnames46.default)(
        "carousel-navigator-icon",
        className,
        "v2-text-[38px] v2-w-8 v2-select-none v2-transition-all",
        {
          "!v2-text-neutral-300 v2-cursor-not-allowed": disabled
        }
      ),
      onClick: disabled ? void 0 : onClick,
      chevronColor,
      chevronHoverColor
    }
  );
}

// src/components/Carousel/CarouselGroupedNavigator.tsx
function CarouselGroupedNavigator({
  className,
  leftNavigatorProps,
  leftNavigatorComponent,
  rightNavigatorProps,
  rightNavigatorComponent
}) {
  return /* @__PURE__ */ import_react67.default.createElement("div", { className: (0, import_classnames47.default)("carousel-grouped-navigator", className) }, /* @__PURE__ */ import_react67.default.createElement(
    CarouselNavigatorContainer,
    __spreadProps(__spreadValues({}, leftNavigatorProps), {
      className: (0, import_classnames47.default)(leftNavigatorProps == null ? void 0 : leftNavigatorProps.containerClassName, "v2-left-1")
    }),
    leftNavigatorComponent != null ? leftNavigatorComponent : /* @__PURE__ */ import_react67.default.createElement(CarouselNavigatorIcon, __spreadValues({}, leftNavigatorProps))
  ), /* @__PURE__ */ import_react67.default.createElement(
    CarouselNavigatorContainer,
    __spreadProps(__spreadValues({}, rightNavigatorProps), {
      className: (0, import_classnames47.default)(rightNavigatorProps == null ? void 0 : rightNavigatorProps.containerClassName, "v2-right-1")
    }),
    rightNavigatorComponent != null ? rightNavigatorComponent : /* @__PURE__ */ import_react67.default.createElement(CarouselNavigatorIcon, __spreadValues({}, rightNavigatorProps))
  ));
}

// src/components/Carousel/CarouselIndicators.tsx
var import_react68 = __toESM(require("react"));
var import_classnames48 = __toESM(require("classnames"));
var import_styled10 = __toESM(require("@emotion/styled"));
var IndicatorSpan = import_styled10.default.span`
  ${({
  active = false,
  indicatorColor = colors.neutral[300],
  indicatorActiveColor = colors.yellow[500]
}) => `
    ${!active ? `background-color: ${indicatorColor} !important;` : ""}
    ${active ? `background-color: ${indicatorActiveColor} !important;` : ""}
  `}
`;
function CarouselIndicators({
  activeIndex,
  items,
  onClick,
  indicatorComponent,
  className,
  indicatorColor,
  indicatorActiveColor
}) {
  const indicatorsComponent = () => {
    const indicators = [];
    for (let i = 1; i <= items; i++) {
      indicators.push(
        /* @__PURE__ */ import_react68.default.createElement("span", { key: `indicator-container-${i}` }, indicatorComponent != null ? indicatorComponent : /* @__PURE__ */ import_react68.default.createElement(
          IndicatorSpan,
          {
            active: activeIndex === i - 1,
            key: `indicator-${i}`,
            onClick: () => onClick(i - 1),
            className: (0, import_classnames48.default)(
              "carousel-indicator-item",
              "v2-w-[15px] v2-h-[15px] v2-rounded-full v2-block",
              "v2-cursor-pointer v2-transition-all"
            ),
            indicatorColor,
            indicatorActiveColor
          }
        ))
      );
    }
    return indicators;
  };
  return /* @__PURE__ */ import_react68.default.createElement(
    "div",
    {
      className: (0, import_classnames48.default)("carousel-indicators-container", className, [
        "v2-flex v2-flex-row v2-gap-x-3 v2-gap-y-4 v2-py-2.5",
        "v2-flex-wrap v2-items-center v2-justify-center"
      ])
    },
    indicatorsComponent()
  );
}

// src/components/Carousel/Carousel.tsx
var poweredByBonjoroIcon = "https://cdn.bonjoro.com/assets/icons/powered-by-bj.svg";
function Carousel(_a) {
  var _b = _a, {
    activeIndex,
    setActiveIndex,
    setToPrev: onPrevClick,
    setToNext: onNextClick,
    carouselRef,
    transitionDuration = 300,
    children,
    overflowClassName,
    overflowStyle,
    containerClassName,
    className,
    groupedNavigatorClassName,
    items,
    hideNavigator = false,
    hideIndicators = false,
    hideBonjoroBadge = false,
    bonjoroBadgeIconClassName,
    styleProps,
    onBonjoroBadgeClick,
    leftNavigatorProps,
    leftNavigatorComponent,
    rightNavigatorProps,
    rightNavigatorComponent,
    indicatorComponent
  } = _b, otherProps = __objRest(_b, [
    "activeIndex",
    "setActiveIndex",
    "setToPrev",
    "setToNext",
    "carouselRef",
    "transitionDuration",
    "children",
    "overflowClassName",
    "overflowStyle",
    "containerClassName",
    "className",
    "groupedNavigatorClassName",
    "items",
    "hideNavigator",
    "hideIndicators",
    "hideBonjoroBadge",
    "bonjoroBadgeIconClassName",
    "styleProps",
    "onBonjoroBadgeClick",
    "leftNavigatorProps",
    "leftNavigatorComponent",
    "rightNavigatorProps",
    "rightNavigatorComponent",
    "indicatorComponent"
  ]);
  const ref = carouselRef != null ? carouselRef : (0, import_react69.useRef)(null);
  const showFooter = !hideIndicators || !hideBonjoroBadge;
  const navigatorIconStyleProps = {
    chevronColor: styleProps == null ? void 0 : styleProps.chevronColor,
    chevronHoverColor: styleProps == null ? void 0 : styleProps.chevronHoverColor
  };
  return /* @__PURE__ */ import_react69.default.createElement(
    "div",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames49.default)(
        "carousel-container",
        containerClassName,
        "v2-flex v2-flex-col v2-gap-y-2"
      )
    }),
    /* @__PURE__ */ import_react69.default.createElement(
      "div",
      {
        className: (0, import_classnames49.default)(
          "carousel-overflow",
          overflowClassName,
          "v2-overflow-hidden v2-relative"
        ),
        style: overflowStyle
      },
      /* @__PURE__ */ import_react69.default.createElement(
        "ul",
        {
          ref,
          className: (0, import_classnames49.default)(
            "carousel",
            className,
            "v2-p-0 v2-m-0 v2-whitespace-nowrap v2-transition v2-relative v2-h-full"
          ),
          style: {
            transform: `translateX(-${activeIndex * 100}%)`,
            transitionDuration: `${transitionDuration}ms`
          }
        },
        import_react69.default.Children.map(children, (child) => {
          if (child == null)
            return;
          return import_react69.default.cloneElement(child);
        })
      ),
      !hideNavigator && /* @__PURE__ */ import_react69.default.createElement(
        CarouselGroupedNavigator,
        {
          className: groupedNavigatorClassName,
          leftNavigatorComponent,
          leftNavigatorProps: __spreadProps(__spreadValues(__spreadValues({}, leftNavigatorProps), navigatorIconStyleProps), {
            icon: faChevronLeft,
            onClick: onPrevClick,
            disabled: activeIndex == 0
          }),
          rightNavigatorComponent,
          rightNavigatorProps: __spreadProps(__spreadValues(__spreadValues({}, rightNavigatorProps), navigatorIconStyleProps), {
            icon: faChevronRight,
            onClick: onNextClick,
            disabled: activeIndex + 1 == items
          })
        }
      )
    ),
    showFooter && /* @__PURE__ */ import_react69.default.createElement("div", { className: "carousel-footer v2-flex v2-flex-row v2-gap-x-4 v2-items-center v2-justify-center" }, !hideBonjoroBadge && /* @__PURE__ */ import_react69.default.createElement(
      "img",
      {
        className: (0, import_classnames49.default)(
          "carousel-bonjoro-badge",
          bonjoroBadgeIconClassName,
          "v2-h-8 v2-w-24 v2-cursor-pointer v2-select-none"
        ),
        src: poweredByBonjoroIcon,
        onClick: onBonjoroBadgeClick
      }
    ), !hideIndicators && /* @__PURE__ */ import_react69.default.createElement(
      CarouselIndicators,
      {
        indicatorComponent,
        activeIndex,
        items,
        onClick: setActiveIndex,
        indicatorColor: styleProps == null ? void 0 : styleProps.indicatorColor,
        indicatorActiveColor: styleProps == null ? void 0 : styleProps.indicatorActiveColor
      }
    ))
  );
}

// src/components/Carousel/CarouselItem.tsx
var import_react70 = __toESM(require("react"));
var import_classnames50 = __toESM(require("classnames"));
function CarouselItem({
  children,
  className,
  outerClassName,
  innerClassName
}) {
  return /* @__PURE__ */ import_react70.default.createElement(
    "div",
    {
      className: (0, import_classnames50.default)("carousel-item", className, [
        "v2-w-full v2-h-full v2-inline-flex"
      ])
    },
    /* @__PURE__ */ import_react70.default.createElement(
      "div",
      {
        className: (0, import_classnames50.default)("carousel-item-outer", outerClassName, [
          "v2-w-full v2-h-full v2-relative v2-items-center v2-justify-center"
        ])
      },
      /* @__PURE__ */ import_react70.default.createElement(
        "div",
        {
          className: (0, import_classnames50.default)(
            "carousel-item-inner",
            innerClassName,
            "v2-w-full v2-h-full v2-absolute"
          )
        },
        children
      )
    )
  );
}

// src/hook/use-child-observer-hook.ts
var import_react71 = require("react");
function useChildObserver({ ref, onChange }) {
  const mutationObserver = new MutationObserver((mutationsList) => {
    if (ref == null ? void 0 : ref.current) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          onChange == null ? void 0 : onChange();
        }
      }
    }
  });
  (0, import_react71.useEffect)(() => {
    if (ref == null ? void 0 : ref.current) {
      mutationObserver.observe(ref.current, { childList: true });
      return () => {
        mutationObserver.disconnect();
      };
    }
  }, [ref == null ? void 0 : ref.current]);
}

// src/components/Carousel/use-carousel-hook.tsx
var import_react72 = require("react");
function useCarousel(carouselRef, options2) {
  const [activeIndex, setActiveIndex] = (0, import_react72.useState)(0);
  const [items, setItems] = (0, import_react72.useState)(0);
  (0, import_react72.useEffect)(() => {
    if (carouselRef == null ? void 0 : carouselRef.current) {
      setItems(carouselRef == null ? void 0 : carouselRef.current.childElementCount);
    }
  }, []);
  const updateActiveIndex = (index) => {
    if (index < 0) {
      index = items - 1;
    } else if (index >= items) {
      index = 0;
    }
    setActiveIndex(index);
  };
  useChildObserver({
    ref: carouselRef,
    onChange: () => {
      var _a;
      if (carouselRef == null ? void 0 : carouselRef.current) {
        setItems((_a = carouselRef == null ? void 0 : carouselRef.current) == null ? void 0 : _a.children.length);
        if (options2 == null ? void 0 : options2.resetIndexOnItemsChange) {
          setActiveIndex(0);
        }
      }
    }
  });
  (0, import_react72.useEffect)(() => {
    if (items > 0 && activeIndex > items - 1) {
      setActiveIndex(items - 1);
    }
  }, [items, activeIndex]);
  return {
    activeIndex,
    setActiveIndex: updateActiveIndex,
    setToFirst: () => updateActiveIndex(0),
    setToLast: () => updateActiveIndex(items - 1),
    setToNext: () => updateActiveIndex(activeIndex + 1),
    setToPrev: () => updateActiveIndex(activeIndex - 1),
    items
  };
}

// src/components/PublishableEmbed/Slider.tsx
var SliderBreakpoint = /* @__PURE__ */ ((SliderBreakpoint2) => {
  SliderBreakpoint2[SliderBreakpoint2["Mobile"] = 450] = "Mobile";
  SliderBreakpoint2[SliderBreakpoint2["Tablet"] = 768] = "Tablet";
  return SliderBreakpoint2;
})(SliderBreakpoint || {});
var OVERFLOW_HEIGHT_OFFSET = 5;
function Slider(_a) {
  var _b = _a, {
    data = [],
    hideBonjoroBadge,
    disableResponsiveness = false,
    containerClassName,
    containerStyle,
    onBonjoroBadgeClick,
    imageComponent
  } = _b, props = __objRest(_b, [
    "data",
    "hideBonjoroBadge",
    "disableResponsiveness",
    "containerClassName",
    "containerStyle",
    "onBonjoroBadgeClick",
    "imageComponent"
  ]);
  const carouselRef = (0, import_react73.useRef)(null);
  const hookProps = useCarousel(carouselRef);
  const { width } = (0, import_use_measure.default)(carouselRef);
  const videoRefs = (0, import_react73.useRef)(
    document.getElementsByClassName(
      "embed-tile-video-player"
    )
  );
  const [hovered, setHovered] = (0, import_react73.useState)(false);
  const [videoPlaying, setVideoPlaying] = (0, import_react73.useState)(false);
  const { setToNext } = hookProps;
  const {
    maxHeight = 0,
    autoSlide,
    allowDynamicTiles,
    hideCarouselIndicator,
    hideCarouselChevron,
    primaryColor
  } = props;
  const disableVideoPlaying = () => setVideoPlaying(false);
  const enableVideoPlaying = () => setVideoPlaying(true);
  (0, import_react73.useEffect)(() => {
    if (!videoRefs.current)
      return;
    Object.values(videoRefs.current).map((videoRef) => {
      videoRef == null ? void 0 : videoRef.addEventListener("ended", disableVideoPlaying);
      videoRef == null ? void 0 : videoRef.addEventListener("play", enableVideoPlaying);
    });
    return () => {
      Object.values(videoRefs.current).map((videoRef) => {
        videoRef == null ? void 0 : videoRef.removeEventListener("ended", disableVideoPlaying);
        videoRef == null ? void 0 : videoRef.removeEventListener("play", enableVideoPlaying);
      });
    };
  }, [videoRefs.current, enableVideoPlaying, disableVideoPlaying]);
  (0, import_react73.useEffect)(() => {
    if (!autoSlide || videoPlaying || hovered)
      return;
    const intervalId = setInterval(() => {
      setToNext();
      clearInterval(intervalId);
    }, 5e3);
    return () => clearInterval(intervalId);
  }, [autoSlide, setToNext, videoPlaying, hovered]);
  const overflowStyle = (0, import_react73.useMemo)(() => {
    return {
      height: `${maxHeight + OVERFLOW_HEIGHT_OFFSET}px`
    };
  }, [maxHeight]);
  const tileStyle = (0, import_react73.useMemo)(() => {
    if (allowDynamicTiles) {
      return {
        overflowY: "hidden",
        maxHeight: `${maxHeight}px`
      };
    }
    return {
      height: `${maxHeight}px`
    };
  }, [maxHeight, allowDynamicTiles]);
  const tilesPerPage = (0, import_react73.useMemo)(() => {
    if (!disableResponsiveness) {
      if (width <= 450 /* Mobile */) {
        return 1;
      }
      if (width <= 768 /* Tablet */) {
        return 2;
      }
    }
    return props.tilesPerPage;
  }, [width, disableResponsiveness, props.tilesPerPage]);
  (0, import_react73.useEffect)(() => {
    Object.values(videoRefs.current).forEach((video) => video.pause());
  }, [hookProps.activeIndex]);
  const tileData = (0, import_react73.useMemo)(() => {
    let index = 0;
    return new Array(Math.ceil(data.length / tilesPerPage)).fill(0).map(() => {
      const page = new Array(
        Math.min(tilesPerPage, data.length - index)
      );
      for (let i = 0; i < page.length; i++) {
        page[i] = data[index + i];
      }
      index += tilesPerPage;
      return page;
    });
  }, [tilesPerPage, data]);
  return /* @__PURE__ */ import_react73.default.createElement(
    Carousel,
    __spreadProps(__spreadValues({}, hookProps), {
      style: containerStyle,
      styleProps: {
        indicatorActiveColor: primaryColor,
        chevronHoverColor: primaryColor
      },
      containerClassName: (0, import_classnames51.default)("v2-w-full", containerClassName),
      overflowStyle,
      carouselRef,
      hideBonjoroBadge,
      hideIndicators: hideCarouselIndicator,
      hideNavigator: hideCarouselChevron,
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      onBonjoroBadgeClick
    }),
    tileData.map((tiles, carouselIndex) => /* @__PURE__ */ import_react73.default.createElement(
      CarouselItem,
      {
        key: carouselIndex,
        innerClassName: "v2-flex v2-items-center v2-justify-center v2-space-x-6 v2-px-10"
      },
      tiles.map((tile) => /* @__PURE__ */ import_react73.default.createElement(
        Tile,
        {
          key: tile.uuid,
          detail: tile,
          containerClassName: (0, import_classnames51.default)("v2-h-full", {
            "v2-w-full": tilesPerPage === 1,
            "v2-w-1/2 v2-min-w-0": tilesPerPage === 2,
            "v2-w-1/3 v2-min-w-0": tilesPerPage === 3
          }),
          className: (0, import_classnames51.default)([
            "v2-scrollbar-thin v2-scrollbar-track-neutral-200",
            "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full"
          ]),
          controls: props,
          style: props,
          timezone: props.timezone,
          preload: props.preload,
          showTextAsPlainText: props.showTextAsPlainText,
          imageComponent,
          cssProperties: tileStyle
        }
      ))
    ))
  );
}

// src/components/PublishableEmbed/PublishableEmbed.tsx
var loadEmbedVideos = () => {
  const videoElements = document.getElementsByClassName(
    "embed-tile-video-player"
  );
  if (!videoElements || videoElements.length === 0)
    return;
  for (const videoElement of Array.from(videoElements)) {
    videoElement == null ? void 0 : videoElement.setAttribute("preload", "auto");
    videoElement == null ? void 0 : videoElement.load();
  }
};
function PublishableEmbed(_a) {
  var _b = _a, { type } = _b, props = __objRest(_b, ["type"]);
  switch (type) {
    case "wall_of_love" /* WallOfLove */:
      return /* @__PURE__ */ import_react74.default.createElement(WallOfLove, __spreadValues({}, props));
    case "slider" /* Slider */:
      return /* @__PURE__ */ import_react74.default.createElement(Slider, __spreadValues({}, props));
    default:
      return /* @__PURE__ */ import_react74.default.createElement(import_react74.default.Fragment, null);
  }
}

// src/components/PublishableEmbed/index.ts
var PublishableType = /* @__PURE__ */ ((PublishableType2) => {
  PublishableType2["Quote"] = "quote";
  PublishableType2["Slider"] = "slider";
  PublishableType2["WallOfLove"] = "wall_of_love";
  return PublishableType2;
})(PublishableType || {});
var DEFAULT_FONT_FAMILY = "Circular Std";
var VideoTextAssetTile = /* @__PURE__ */ ((VideoTextAssetTile2) => {
  VideoTextAssetTile2["Video"] = "video";
  VideoTextAssetTile2["Text"] = "text";
  return VideoTextAssetTile2;
})(VideoTextAssetTile || {});
var TileType = __spreadValues(__spreadValues({}, VideoTextAssetTile), SocialType);
